/**
 * ScanMeFamily Landing-Section
 * - Sprachlogik (Verse + Texte)
 * - Scroll-Indikatoren
 * - Nav-Overlay
 * - UI-Hinweis genau einmal pro tatsächlichem Sprachwechsel
 */ 
(function() {
  "use strict";

  var smfLandingScrollRoot = document.querySelector(".smf-wrapper");
  if (smfLandingScrollRoot) {
    if (window.history && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    var smfEarlyPath = (window.location.pathname || "/").replace(/\/{2,}/g, "/");
    if (smfEarlyPath.length > 1) {
      smfEarlyPath = smfEarlyPath.replace(/\/+$/, "");
    }
    smfEarlyPath = smfEarlyPath.replace(/^\/[a-z]{2}(?=\/|$)/i, "") || "/";
    if (smfEarlyPath === "/") {
      smfLandingScrollRoot.scrollTop = 0;
    }
  }

  /* Breakpoint tiers — keep in sync with smef.css */
  var SMF_MQ_MOBILE =
    "(max-width: 899px), (orientation: landscape) and (hover: none) and (pointer: coarse)";
  var SMF_BP_DESKTOP_MIN = 900;

  /* Timing (ms) — keep related CSS animation durations aligned where noted */
  var SMF_LANDING_SCROLL_CORRECTION_DELAY = 120;
  var SMF_LANDING_SECTION_SETTLE_DELAY = 140;
  var SMF_LANDING_SNAP_RESTORE_DURATION = 260;
  var SMF_LANDING_DEEP_LINK_SNAP_DISABLE_DURATION = 900;
  var SMF_LANDING_PAGE_TRANSITION_DURATION = 420;
  var SMF_LANDING_INFO_FADE_OUT_DURATION = 220;
  var SMF_LANDING_INFO_FADE_IN_DURATION = 300;
  var SMF_LANDING_BOOT_GUARD_DURATION = 650;
  var SMF_GESTURE_SETTLE_DELAY = 220;
  var SMF_DRAWER_MORPH_DURATION = 176;
  var SMF_DRAWER_CLOSE_BUFFER = 28;
  var SMF_COLLECTION_TILE_ACTIVATE_DELAY = 165;
  var SMF_VERSE_CHEV_FIRST_HINT_DURATION = 1450;
  var SMF_LANDING_INTRO_STORAGE_KEY = "landingIntroSeen";
  var SMF_LANDING_INTRO_LEGACY_CHEV_KEY = "smf_chev_first_v1";
  var SMF_LANDING_INTRO_NOTCH_DELAY = 3000;
  var SMF_LANDING_INTRO_NOTCH_PULSE_DURATION = 700;
  var SMF_LANDING_INTRO_REF_GAP = 1500;
  var SMF_FAITH_PILL_HIGHLIGHT_DELAY_STRONG = 180;
  var SMF_FAITH_PILL_HIGHLIGHT_DURATION = 6600;
  var SMF_FAITH_PILL_HIGHLIGHT_BUFFER = 600;
  var SMF_VERSE_CARD_BASE_WIDTH = 1080;
  var SMF_VERSE_CARD_BASE_HEIGHT = 1350;
  var SMF_VERSE_CARD_FORMATS = {
    card: { width: 1080, height: 1350, fileSuffix: "verse-card" },
    square: { width: 1080, height: 1080, fileSuffix: "verse-card-square" },
    phone: { width: 1080, height: 1920, fileSuffix: "verse-card-phone" },
    desktop: { width: 1920, height: 1080, fileSuffix: "verse-card-desktop" }
  };

  /* Scroll / gesture thresholds */
  var SMF_PINCH_ZOOM_SCALE_EPSILON = 0.001;
  var SMF_LIVE_PINCH_MIN_SCALE = 1;
  var SMF_LIVE_PINCH_MAX_SCALE = 2.75;
  var SMF_LANDSCAPE_LOCK_SETTLE_DELAY = 280;
  var SMF_LANDSCAPE_FADE_DURATION = 200;

  function smfMatchesMediaQuery(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
  }

  function smfGetViewportWidth() {
    return (
      window.innerWidth ||
      (document.documentElement && document.documentElement.clientWidth) ||
      0
    );
  }

  function smfIsMobileLayout() {
    if (window.matchMedia) {
      return smfMatchesMediaQuery(SMF_MQ_MOBILE);
    }

    return smfGetViewportWidth() < SMF_BP_DESKTOP_MIN;
  }


  /* ===========================================
     KONFIGURATION: Sprachen & Verse
  ============================================ */

  var supportedLanguages = ["de", "en", "nl", "fr", "es", "ru"];
  var smfLanguageStorageKeys = {
    verse: "smf_verse_lang",
    legacyVerse: "smf_ui_lang",
    shop: "smf_shop_lang",
    source: "smf_lang_source"
  };
  var smfEntryStorageKeys = {
    socialEntry: "smf_social_entry"
  };
  var smfUiHintStorageKeys = {
    pendingSwitch: "smf_ui_hint_pending_switch"
  };
  var SMF_UI_HINT_PENDING_MAX_AGE = 600000;
  var SMF_VIRTUAL_ROUTES = {
    shop: { slug: "shop", path: "/shop", sectionId: "smf-shop" },
    social: { slug: "social", path: "/social", sectionId: "smf-artist" },
    samesky: { slug: "social", path: "/social", sectionId: "smf-artist" },
    sameskycollective: { slug: "social", path: "/social", sectionId: "smf-artist" },
    info: { slug: "info", path: "/info", sectionId: "smf-footer" },
    protected: { slug: "protected", path: "/protected", sectionId: null }
  };
  var SMF_LOCALE_PREFIX_CODES = (function() {
    var codes = { en: true, de: true };
    var list = [];
    var key;
    
    for (key in codes) {
      if (Object.prototype.hasOwnProperty.call(codes, key) && key) {
        list.push(key);
      }
    }
    return list;
  })();
  var SMF_LOCALE_PREFIX_RE = new RegExp(
    "^\\/(" + SMF_LOCALE_PREFIX_CODES.join("|") + ")(?=\\/|$)",
    "i"
  );
  var smfVerseLangByCountry = {
    DE: "de",
    GB: "en",
    US: "en",
    ES: "es",
    MX: "es",
    AR: "es",
    BO: "es",
    CL: "es",
    CO: "es",
    CR: "es",
    DO: "es",
    EC: "es",
    GT: "es",
    HN: "es",
    NI: "es",
    PA: "es",
    PE: "es",
    PR: "es",
    PY: "es",
    SV: "es",
    UY: "es",
    VE: "es",
    FR: "fr",
    NL: "nl"
  };

  var verses = {
 de: [
  { text: "Gott ist unsere Zuflucht, Stärke, Hilfe in der Not.", ref: "lies Psalm 46,1" },
  { text: "Gott ist treu – du wirst nicht allein gelassen.", ref: "lies 1. Korinther 10,13" },
  { text: "Der Herr ist nahe – keine Angst, bring’s ins Gebet.", ref: "lies Philipper 4,5–6" },
  { text: "Gott richtet auf, wer niedergeschlagen ist.", ref: "lies Psalm 146,8" },
  { text: "Leg deinen Weg in Gottes Hand und vertrau ihm.", ref: "lies Psalm 37,5" },
  { text: "Der HERR ist nahe bei zerbrochenem Herzen.", ref: "lies Psalm 34,19" },
  { text: "Überwinde Böses mit Gutem.", ref: "lies Römer 12,21" },
  { text: "Freundliche Worte tun der Seele gut.", ref: "lies Sprüche 16,24" },
  { text: "Menschen sehen das Äußere – das Herz zählt.", ref: "lies 1. Samuel 16,7" },
  { text: "Geduld ist stärker als Kraft.", ref: "lies Sprüche 16,32" },

  { text: "Alles hat seine Zeit – und seinen Sinn.", ref: "lies Prediger 3,1" },
  { text: "Halte fest am Guten, das dich stärkt.", ref: "lies 1. Thessalonicher 5,21" },
  { text: "Du bist wertvoll – mehr, als du denkst.", ref: "lies Jesaja 43,4" },
  { text: "Vertraue Gott mehr als dir selbst.", ref: "lies Sprüche 3,5" },
  { text: "Wirf deine Sorgen auf Gott.", ref: "lies Psalm 55,23" },
  { text: "Gott behütet dich in allem.", ref: "lies Psalm 121,7–8" },
  { text: "Komm zur Ruhe bei Gott.", ref: "lies Matthäus 11,28" },
  { text: "Wer Gott sucht, findet Befreiung.", ref: "lies Psalm 34,5" },
  { text: "Gott hört Gebete und antwortet.", ref: "lies Psalm 66,20" },
  { text: "Wer auf Gott hofft, bekommt neue Kraft.", ref: "lies Jesaja 40,31" },

  { text: "Du bist wunderbar gemacht.", ref: "lies Psalm 139,14" },
  { text: "Sanfte Worte wenden Streit ab.", ref: "lies Sprüche 15,1" },
  { text: "Gott ist die Kraft meines Herzens.", ref: "lies Psalm 73,26" },
  { text: "Gib nicht auf – innerlich wirst du erneuert.", ref: "lies 2. Korinther 4,16" },
  { text: "Wer Gott vertraut, bleibt innerlich ruhig.", ref: "lies Psalm 112,7" },
  { text: "Gott zieht mich aus der Tiefe.", ref: "lies Psalm 40,2" },
  { text: "Geben bringt Segen.", ref: "lies Sprüche 11,25" },
  { text: "Unsere Hoffnung liegt bei Gott – er hält uns fest.", ref: "lies Psalm 33,20" },
  { text: "Leg dein Tun in Gottes Hand.", ref: "lies Sprüche 16,3" },
  { text: "In Ruhe und Vertrauen liegt Kraft.", ref: "lies Jesaja 30,15" },

  { text: "Wer Gott vertraut, dem fehlt nichts.", ref: "lies Psalm 34,9" },
  { text: "Gott führt und stärkt.", ref: "lies Jesaja 58,11" },
  { text: "Gott heilt zerbrochene Herzen.", ref: "lies Psalm 147,3" },
  { text: "Gottes Segen macht reich ohne Sorge.", ref: "lies Sprüche 10,22" },
  { text: "Gott ist allen nah, die ihn anrufen.", ref: "lies Psalm 145,18" },
  { text: "Gott schenkt Freude statt Trauer.", ref: "lies Jesaja 61,3" },
  { text: "Gottes Pläne sind größer als unsere.", ref: "lies Jesaja 55,8–9" },

  { text: "Vertraue auf Gott – er wird helfen.", ref: "lies Sprüche 20,22" },

],
en: [
  { text: "God is our refuge, strength, and help in times of trouble.", ref: "read Psalm 46:1" },
  { text: "God is faithful — you will not be left alone.", ref: "read 1 Corinthians 10:13" },
  { text: "The Lord is near — do not be afraid; bring it to prayer.", ref: "read Philippians 4:5–6" },
  { text: "God lifts up those who are bowed down.", ref: "read Psalm 146:8" },
  { text: "Commit your way to God and trust in Him.", ref: "read Psalm 37:5" },
  { text: "The Lord is close to the brokenhearted.", ref: "read Psalm 34:19" },
  { text: "Overcome evil with good.", ref: "read Romans 12:21" },
  { text: "Kind words are healing to the soul.", ref: "read Proverbs 16:24" },
  { text: "People look at the outward appearance — the heart matters.", ref: "read 1 Samuel 16:7" },
  { text: "Patience is stronger than strength.", ref: "read Proverbs 16:32" },

  { text: "Everything has its time — and its purpose.", ref: "read Ecclesiastes 3:1" },
  { text: "Hold on to what is good and strengthens you.", ref: "read 1 Thessalonians 5:21" },
  { text: "You are precious — more than you realize.", ref: "read Isaiah 43:4" },
  { text: "Trust God more than yourself.", ref: "read Proverbs 3:5" },
  { text: "Cast your worries on God.", ref: "read Psalm 55:23" },
  { text: "God watches over you in all things.", ref: "read Psalm 121:7–8" },
  { text: "Come to God and find rest.", ref: "read Matthew 11:28" },
  { text: "Those who seek God find freedom.", ref: "read Psalm 34:5" },
  { text: "God hears prayers and answers.", ref: "read Psalm 66:20" },
  { text: "Those who hope in God receive new strength.", ref: "read Isaiah 40:31" },

  { text: "You are wonderfully made.", ref: "read Psalm 139:14" },
  { text: "Gentle words turn away conflict.", ref: "read Proverbs 15:1" },
  { text: "God is the strength of my heart.", ref: "read Psalm 73:26" },
  { text: "Do not give up — inwardly you are being renewed.", ref: "read 2 Corinthians 4:16" },
  { text: "Those who trust God remain inwardly calm.", ref: "read Psalm 112:7" },
  { text: "God lifts me out of the depths.", ref: "read Psalm 40:2" },
  { text: "Giving brings blessing.", ref: "read Proverbs 11:25" },
  { text: "Our hope rests in God — He holds us.", ref: "read Psalm 33:20" },
  { text: "Commit your work to God.", ref: "read Proverbs 16:3" },
  { text: "Strength lies in quietness and trust.", ref: "read Isaiah 30:15" },

  { text: "Those who trust God lack nothing.", ref: "read Psalm 34:9" },
  { text: "God guides and strengthens.", ref: "read Isaiah 58:11" },
  { text: "God heals broken hearts.", ref: "read Psalm 147:3" },
  { text: "God’s blessing brings wealth without worry.", ref: "read Proverbs 10:22" },
  { text: "God is near to all who call on Him.", ref: "read Psalm 145:18" },
  { text: "God gives joy instead of mourning.", ref: "read Isaiah 61:3" },

  { text: "God’s plans are greater than ours.", ref: "read Isaiah 55:8–9" },
 
  { text: "Trust in God — He will help.", ref: "read Proverbs 20:22" },
 
],
nl: [
  { text: "God is een toevlucht, kracht en hulp in nood.", ref: "lees Psalm 46:1" },
  { text: "God is trouw — je wordt niet alleen gelaten.", ref: "lees 1 Korintiërs 10:13" },
  { text: "De Heer is nabij — wees niet bang, breng het in gebed.", ref: "lees Filippenzen 4:5–6" },
  { text: "God richt op wie neergebogen zijn.", ref: "lees Psalm 146:8" },
  { text: "Leg je weg in Gods hand en vertrouw op Hem.", ref: "lees Psalm 37:5" },
  { text: "De HEER is nabij de gebrokenen van hart.", ref: "lees Psalm 34:19" },
  { text: "Overwin het kwade door het goede.", ref: "lees Romeinen 12:21" },
  { text: "Vriendelijke woorden doen de ziel goed.", ref: "lees Spreuken 16:24" },
  { text: "Mensen zien wat uiterlijk is — het hart telt.", ref: "lees 1 Samuël 16:7" },
  { text: "Geduld is sterker dan kracht.", ref: "lees Spreuken 16:32" },

  { text: "Alles heeft zijn tijd — en zijn betekenis.", ref: "lees Prediker 3:1" },
  { text: "Houd vast aan het goede dat je versterkt.", ref: "lees 1 Tessalonicenzen 5:21" },
  { text: "Je bent kostbaar — meer dan je denkt.", ref: "lees Jesaja 43:4" },
  { text: "Vertrouw op God meer dan op jezelf.", ref: "lees Spreuken 3:5" },
  { text: "Werp je zorgen op God.", ref: "lees Psalm 55:23" },
  { text: "God bewaart je in alles.", ref: "lees Psalm 121:7–8" },
  { text: "Kom tot rust bij God.", ref: "lees Matteüs 11:28" },
  { text: "Wie God zoekt, vindt bevrijding.", ref: "lees Psalm 34:5" },
  { text: "God hoort gebeden en antwoordt.", ref: "lees Psalm 66:20" },
  { text: "Wie op God hoopt, krijgt nieuwe kracht.", ref: "lees Jesaja 40:31" },

  { text: "Je bent wonderbaarlijk gemaakt.", ref: "lees Psalm 139:14" },
  { text: "Zachte woorden wenden ruzie af.", ref: "lees Spreuken 15:1" },
  { text: "God is de kracht van mijn hart.", ref: "lees Psalm 73:26" },
  { text: "Geef niet op — innerlijk word je vernieuwd.", ref: "lees 2 Korintiërs 4:16" },
  { text: "Wie op God vertrouwt, blijft innerlijk rustig.", ref: "lees Psalm 112:7" },
  { text: "God trekt mij uit de diepte.", ref: "lees Psalm 40:2" },
  { text: "Geven brengt zegen.", ref: "lees Spreuken 11:25" },
  { text: "Onze hoop ligt bij God — Hij houdt ons vast.", ref: "lees Psalm 33:20" },
  { text: "Leg je werk in Gods hand.", ref: "lees Spreuken 16:3" },
  { text: "In rust en vertrouwen ligt kracht.", ref: "lees Jesaja 30:15" },

  { text: "Wie God vertrouwt, komt niets tekort.", ref: "lees Psalm 34:9" },
  { text: "God leidt en versterkt.", ref: "lees Jesaja 58:11" },
  { text: "God geneest gebroken harten.", ref: "lees Psalm 147:3" },
  { text: "De zegen van God maakt rijk zonder zorgen.", ref: "lees Spreuken 10:22" },
  { text: "God is dichtbij allen die Hem aanroepen.", ref: "lees Psalm 145:18" },
  { text: "God geeft vreugde in plaats van rouw.", ref: "lees Jesaja 61:3" },

  { text: "Gods plannen zijn groter dan de onze.", ref: "lees Jesaja 55:8–9" },

  { text: "Vertrouw op God — Hij zal helpen.", ref: "lees Spreuken 20:22" },
 
],
fr: [
  { text: "Dieu est un refuge, une force, un secours dans la détresse.", ref: "lis Psaume 46:1" },
  { text: "Dieu est fidèle — tu ne seras pas abandonné.", ref: "lis 1 Corinthiens 10:13" },
  { text: "Le Seigneur est proche — n’aie pas peur, remets tout dans la prière.", ref: "lis Philippiens 4:5–6" },
  { text: "Dieu relève ceux qui sont abattus.", ref: "lis Psaume 146:8" },
  { text: "Remets ton chemin entre les mains de Dieu et fais-lui confiance.", ref: "lis Psaume 37:5" },
  { text: "Le Seigneur est près de ceux qui ont le cœur brisé.", ref: "lis Psaume 34:19" },
  { text: "Vaincs le mal par le bien.", ref: "lis Romains 12:21" },
  { text: "Les paroles bienveillantes font du bien   l  me.", ref: "lis Proverbes 16:24" },
  { text: "L’homme regarde à l’apparence — le cœur compte.", ref: "lis 1 Samuel 16:7" },
  { text: "La patience est plus forte que la puissance.", ref: "lis Proverbes 16:32" },

  { text: "Il y a un temps pour toute chose — et un sens.", ref: "lis Ecclésiaste 3:1" },
  { text: "Attache-toi à ce qui est bon et sois fortifié.", ref: "lis 1 Thessaloniciens 5:21" },
  { text: "Tu as de la valeur — plus que tu ne le penses.", ref: "lis Ésaïe 43:4" },
  { text: "Fais confiance à Dieu plus qu’à toi-même.", ref: "lis Proverbes 3:5" },
  { text: "Remets tes soucis à Dieu.", ref: "lis Psaume 55:23" },
  { text: "Dieu te protège en toute chose.", ref: "lis Psaume 121:7–8" },
  { text: "Repose-toi en Dieu.", ref: "lis Matthieu 11:28" },
  { text: "Celui qui cherche Dieu trouve la délivrance.", ref: "lis Psaume 34:5" },
  { text: "Dieu entend les prières et y répond.", ref: "lis Psaume 66:20" },
  { text: "Ceux qui espèrent en Dieu retrouvent des forces.", ref: "lis Ésaïe 40:31" },

  { text: "Tu es merveilleusement créé.", ref: "lis Psaume 139:14" },
  { text: "Des paroles douces apaisent les conflits.", ref: "lis Proverbes 15:1" },
  { text: "Dieu est la force de mon cœur.", ref: "lis Psaume 73:26" },
  { text: "Ne baisse pas les bras — ton être intérieur se renouvelle.", ref: "lis 2 Corinthiens 4:16" },
  { text: "Qui fait confiance à Dieu demeure paisible.", ref: "lis Psaume 112:7" },
  { text: "Dieu me tire de la profondeur.", ref: "lis Psaume 40:2" },
  { text: "Donner apporte la bénédiction.", ref: "lis Proverbes 11:25" },
  { text: "Notre espérance repose en Dieu — il nous soutient.", ref: "lis Psaume 33:20" },
  { text: "Confie ton travail à Dieu.", ref: "lis Proverbes 16:3" },
  { text: "La force se trouve dans le calme et la confiance.", ref: "lis Ésaïe 30:15" },

  { text: "Qui fait confiance à Dieu ne manque de rien.", ref: "lis Psaume 34:9" },
  { text: "Dieu guide et fortifie.", ref: "lis Ésaïe 58:11" },
  { text: "Dieu guérit les cœurs brisés.", ref: "lis Psaume 147:3" },
  { text: "La bénédiction de Dieu enrichit sans souci.", ref: "lis Proverbes 10:22" },
  { text: "Dieu est proche de tous ceux qui l’invoquent.", ref: "lis Psaume 145:18" },
  { text: "Dieu donne la joie au lieu du deuil.", ref: "lis Ésaïe 61:3" },

  { text: "Les projets de Dieu sont plus grands que les nôtres.", ref: "lis Ésaïe 55:8–9" },

  { text: "Fais confiance à Dieu — il aidera.", ref: "lis Proverbes 20:22" },
  
],
es: [
  { text: "Dios es refugio, fuerza y ayuda en la angustia.", ref: "lee Salmo 46:1" },
  { text: "Dios es fiel — no te dejará.", ref: "lee 1 Corintios 10:13" },
  { text: "El Se or est  cerca   no tengas miedo, entr galo en oraci n.", ref: "lee Filipenses 4:5 6" },
  { text: "Dios levanta a los abatidos.", ref: "lee Salmo 146:8" },
  { text: "Pon tu camino en manos de Dios y confía en Él.", ref: "lee Salmo 37:5" },
  { text: "El Se or est  cerca de los quebrantados de coraz n.", ref: "lee Salmo 34:19" },
  { text: "Vence el mal con el bien.", ref: "lee Romanos 12:21" },
  { text: "Las palabras amables sanan el alma.", ref: "lee Proverbios 16:24" },
  { text: "Las personas miran lo exterior — el corazón cuenta.", ref: "lee 1 Samuel 16:7" },
  { text: "La paciencia es más fuerte que el poder.", ref: "lee Proverbios 16:32" },

  { text: "Todo tiene su tiempo — y su propósito.", ref: "lee Eclesiastés 3:1" },
  { text: "Aférrate a lo bueno que te fortalece.", ref: "lee 1 Tesalonicenses 5:21" },
  { text: "Tu valor es mayor de lo que piensas.", ref: "lee Isaías 43:4" },
  { text: "Confía más en Dios que en ti.", ref: "lee Proverbios 3:5" },
  { text: "Entrega tus preocupaciones a Dios.", ref: "lee Salmo 55:23" },
  { text: "Dios te guarda en todo momento.", ref: "lee Salmo 121:7–8" },
  { text: "Descansa en Dios.", ref: "lee Mateo 11:28" },
  { text: "Quien busca a Dios encuentra libertad.", ref: "lee Salmo 34:5" },
  { text: "Dios escucha las oraciones y responde.", ref: "lee Salmo 66:20" },
  { text: "Quien espera en Dios recibe nuevas fuerzas.", ref: "lee Isaías 40:31" },

  { text: "Eres maravillosamente creado.", ref: "lee Salmo 139:14" },
  { text: "Las palabras suaves apartan el conflicto.", ref: "lee Proverbios 15:1" },
  { text: "Dios es la fuerza de mi corazón.", ref: "lee Salmo 73:26" },
  { text: "No te rindas — hay una renovación interior.", ref: "lee 2 Corintios 4:16" },
  { text: "Quien confía en Dios permanece en calma interior.", ref: "lee Salmo 112:7" },
  { text: "Dios me saca de lo profundo.", ref: "lee Salmo 40:2" },
  { text: "Dar trae bendición.", ref: "lee Proverbios 11:25" },
  { text: "Nuestra esperanza está en Dios — Él nos sostiene.", ref: "lee Salmo 33:20" },
  { text: "Pon tu trabajo en manos de Dios.", ref: "lee Proverbios 16:3" },
  { text: "En la calma y la confianza hay fuerza.", ref: "lee Isaías 30:15" },

  { text: "Quien confía en Dios no carece de nada.", ref: "lee Salmo 34:9" },
  { text: "Dios guía y fortalece.", ref: "lee Isaías 58:11" },
  { text: "Dios sana los corazones quebrantados.", ref: "lee Salmo 147:3" },
  { text: "La bendición de Dios enriquece sin afán.", ref: "lee Proverbios 10:22" },
  { text: "Dios está cerca de todos los que lo invocan.", ref: "lee Salmo 145:18" },
  { text: "Dios da gozo en lugar de tristeza.", ref: "lee Isaías 61:3" },
  
  { text: "Los planes de Dios son más grandes que los nuestros.", ref: "lee Isaías 55:8–9" },
 
  { text: "Confía en Dios — Él ayudará.", ref: "lee Proverbios 20:22" },

],
ru: [
  { text: "Бог — прибежище, сила и помощь в беде.", ref: "читай Псалом 46:1" },
  { text: "Бог верен — Он не оставит тебя.", ref: "читай 1 Коринфянам 10:13" },
  { text: "Господь близко — не бойся, принеси всё в молитве.", ref: "читай Филиппийцам 4:5–6" },
  { text: "Бог поднимает сокрушённых.", ref: "читай Псалом 146:8" },
  { text: "Вверь свой путь Богу и доверься Ему.", ref: "читай Псалом 37:5" },
  { text: "Господь близок к сокрушённым сердцам.", ref: "читай Псалом 34:19" },
  { text: "Побеждай зло добром.", ref: "читай Римлянам 12:21" },
  { text: "Добрые слова исцеляют душу.", ref: "читай Притчи 16:24" },
  { text: "Люди смотрят на внешность — но сердце важно.", ref: "читай 1 Царств 16:7" },
  { text: "Терпение сильнее силы.", ref: "читай Притчи 16:32" },

  { text: "Всему своё время — и свой смысл.", ref: "читай Екклесиаст 3:1" },
  { text: "Держись добра, которое укрепляет тебя.", ref: "читай 1 Фессалоникийцам 5:21" },
  { text: "Твоя ценность больше, чем ты думаешь.", ref: "читай Исаия 43:4" },
  { text: "Доверяй Богу больше, чем себе.", ref: "читай Притчи 3:5" },
  { text: "Возложи свои заботы на Бога.", ref: "читай Псалом 55:23" },
  { text: "Бог хранит тебя во всём пути твоём.", ref: "читай Псалом 121:7–8" },
  { text: "Покой — в Боге.", ref: "читай Матфея 11:28" },
  { text: "Ищущий Бога находит освобождение.", ref: "читай Псалом 34:5" },
  { text: "Бог слышит молитвы и отвечает.", ref: "читай Псалом 66:20" },
  { text: "Надеющиеся на Бога получают новую силу.", ref: "читай Исаия 40:31" },

  { text: "Ты — дивное творение.", ref: "читай Псалом 139:14" },
  { text: "Кроткие слова отвращают распрю.", ref: "читай Притчи 15:1" },
  { text: "Бог — сила моего сердца.", ref: "читай Псалом 73:26" },
  { text: "Не сдавайся — внутри происходит обновление.", ref: "читай 2 Коринфянам 4:16" },
  { text: "Кто уповает на Бога, сохраняет внутренний покой.", ref: "читай Псалом 112:7" },
  { text: "Бог выводит меня из глубин.", ref: "читай Псалом 40:2" },
  { text: "Щедрость приносит благословение.", ref: "читай Притчи 11:25" },
  { text: "Наша надежда — в Боге, Он держит нас.", ref: "читай Псалом 33:20" },
  { text: "Вверь Богу свои дела.", ref: "читай Притчи 16:3" },
  { text: "Сила — в тишине и доверии.", ref: "читай Исаия 30:15" },

  { text: "Кто уповает на Бога, ни в чём не нуждается.", ref: "читай Псалом 34:9" },
  { text: "Бог ведёт и укрепляет.", ref: "читай Исаия 58:11" },
  { text: "Бог исцеляет сокрушённые сердца.", ref: "читай Псалом 147:3" },
  { text: "Благословение Господа обогащает без забот.", ref: "читай Притчи 10:22" },
  { text: "Бог близок ко всем, кто призывает Его.", ref: "читай Псалом 145:18" },
  { text: "Бог даёт радость вместо скорби.", ref: "читай Исаия 61:3" },

  { text: "Замыслы Бога больше наших.", ref: "читай Исаия 55:8–9" },

  { text: "Уповай на Бога — Он поможет.", ref: "читай Притчи 20:22" },

]
  };

  var i18n = {
	    verseKicker: {
	      de: "Vers des Tages",
	      en: "Verse of the Day",
	      nl: "Vers van de dag",
	      fr: "Verset du jour",
	      es: "Vers\u00edculo del d\u00eda",
	      ru: "\u0421\u0442\u0438\u0445 \u0434\u043d\u044f"
	    },
    shopBandsName: {
      de: "Protected Bands",
      en: "Protected Bands",
      nl: "Protected Bands",
      fr: "Protected Bands",
      es: "Protected Bands"
    },
    shopApparelName: {
      de: "Protected Apparel",
      en: "Protected Apparel",
      nl: "Protected Apparel",
      fr: "Protected Apparel",
      es: "Protected Apparel"
    },
    shopBandsHeadlineDesktop: {
      de: "Ganz nah.",
      en: "Stay Close.",
      nl: "Stay Close.",
      fr: "Stay Close.",
      es: "Stay Close."
    },
    shopApparelHeadline1: {
      de: "Aus Botschaft",
      en: "From Message",
      nl: "From Message",
      fr: "From Message",
      es: "From Message"
    },
    shopApparelHeadline2: {
      de: "wird Bewegung.",
      en: "to Movement.",
      nl: "to Movement.",
      fr: "to Movement.",
      es: "to Movement."
    },
    shopBandsMicrocopy: {
      de: "Scannen. Bezugsperson erreichen.",
      en: "Scan to reach the right person."
    },
    shopApparelMicrocopy: {
      de: "Trag die Botschaft. Teil die Idee.",
      en: "Wear the message. Share the idea."
    },
    shopBandsCta: {
      de: "DISCOVER",
      en: "DISCOVER",
      nl: "DISCOVER",
      fr: "DISCOVER",
      es: "DISCOVER"
    },
    shopApparelCta: {
      de: "KOLLEKTIONEN ENTDECKEN",
      en: "EXPLORE COLLECTIONS",
      nl: "EXPLORE COLLECTIONS",
      fr: "EXPLORE COLLECTIONS",
      es: "EXPLORE COLLECTIONS"
    },
    shopStoriesName: {
      de: "Stories",
      en: "Stories"
    },
    shopStoriesCta: {
      de: "STORIES ENTDECKEN",
      en: "EXPLORE STORIES"
    },
    storiesFreeTitle: {
      de: "STORIES IST KOSTENLOS.",
      en: "STORIES IS FREE."
    },
    storiesFreeBody: {
      de: "F\u00fcr den Zugang zu unseren t\u00e4glichen Bibelgeschichten ist kein Kauf erforderlich.",
      en: "No purchase is required to access our daily Bible stories."
    },
    storiesFreeCta: {
      de: "ZU STORIES WECHSELN",
      en: "SWITCH TO STORIES"
    },
    verseCardSheetTitle: {
      de: "Vers-Karte",
      en: "Verse Card"
    },
    verseCardDownload: {
      de: "Karte herunterladen",
      en: "Download Card"
    },
    verseCardShare: {
      de: "Karte teilen",
      en: "Share Card"
    },
    verseCardCopyLink: {
      de: "Link kopieren",
      en: "Copy Link"
    },
    verseCardSheetAriaLabel: {
      de: "Vers-Karten-Aktionen",
      en: "Verse card actions"
    },
    verseCardShareTitle: {
      de: "Vers-Karte",
      en: "Verse Card"
    },
    verseCardCopyPrompt: {
      de: "Link kopieren:",
      en: "Copy this link:"
    },
    verseCardFormatTitle: {
      de: "Format w\u00e4hlen",
      en: "Choose format"
    },
    verseCardFormatPhone: {
      de: "Handy-Hintergrund",
      en: "Phone wallpaper"
    },
    verseCardFormatSquare: {
      de: "Post-Format",
      en: "Post format"
    },
    verseCardFormatDesktop: {
      de: "Desktop-Hintergrund",
      en: "Desktop wallpaper"
    },
    verseCardFormatBack: {
      de: "Zur\u00fcck",
      en: "Back"
    },
    artistTitle: {
      de: "SOCIAL HUB",
      en: "SOCIAL HUB",
      nl: "SOCIAL HUB",
      fr: "SOCIAL HUB",
      es: "SOCIAL HUB"
    },
    socialHubHeading: {
      de: "Mehr als Clothing. Eine Bewegung.",
      en: "More than clothing. It\u2019s a movement.",
      nl: "More than clothing. It\u2019s a movement.",
      fr: "More than clothing. It\u2019s a movement.",
      es: "More than clothing. It\u2019s a movement."
    },
    socialHubSubline: {
      de:
        "Entdecke die Welt hinter ScanMeFamily.\nJeder QR-Code f\u00fchrt \u00fcber das Produkt hinaus\n\u2013 zu Musik, Inhalten und Community.",
      en:
        "Discover the world behind ScanMeFamily.\nEach QR code connects beyond the product\n\u2014 into music, content and community.",
      nl:
        "Access the platforms behind ScanMeFamily. Each QR code connects beyond the product \u2014 into music, content and community.",
      fr:
        "Access the platforms behind ScanMeFamily. Each QR code connects beyond the product \u2014 into music, content and community.",
      es:
        "Access the platforms behind ScanMeFamily. Each QR code connects beyond the product \u2014 into music, content and community."
    },
    musicPlatforms: {
      de: "STORIES",
      en: "STORIES",
      nl: "STORIES",
      fr: "STORIES",
      es: "STORIES"
    },
    socialPlatforms: {
      de: "Social",
      en: "Social",
      nl: "Social",
      fr: "Social",
      es: "Social"
    },
    featuredWeeklyInput: {
      de: "Impuls dieser Woche",
      en: "This Week\u2019s Input",
      nl: "This Week\u2019s Input",
      fr: "This Week\u2019s Input",
      es: "This Week\u2019s Input"
    },
    faithLabel: {
      de: "Glaube",
      en: "Faith",
      nl: "Faith",
      fr: "Faith",
      es: "Faith"
    },
    faithCta: {
      de: "Entdecke die Bibel",
      en: "Explore the Bible",
      nl: "Explore the Bible",
      fr: "Explore the Bible",
      es: "Explore the Bible"
    },
    verseOverlayTitle: {
      de: "Wenn du weitergehen willst...",
      en: "If you want to continue...",
      nl: "Als je verder wilt gaan...",
      fr: "Si tu veux continuer...",
      es: "Si quieres continuar...",
      ru: "\u0415\u0441\u043b\u0438 \u0442\u044b \u0445\u043e\u0447\u0435\u0448\u044c \u0438\u0434\u0442\u0438 \u0434\u0430\u043b\u044c\u0448\u0435..."
    },
    verseOverlayCta: {
      de: "Entdecke die Bibel",
      en: "Discover the Bible",
      nl: "Ontdek de Bijbel",
      fr: "D\u00e9couvre la Bible",
      es: "Descubre la Biblia",
      ru: "\u041e\u0442\u043a\u0440\u043e\u0439 \u0434\u043b\u044f \u0441\u0435\u0431\u044f \u0411\u0438\u0431\u043b\u0438\u044e"
    },
    footerLinkImpressum: {
      de: "Impressum",
      en: "Imprint"
    },
    footerLinkTerms: {
      de: "AGB",
      en: "Terms"
    },
    footerLinkPrivacy: {
      de: "Datenschutz",
      en: "Privacy"
    },
    footerLinkWithdrawal: {
      de: "Widerruf",
      en: "Withdrawal"
    },
    footerLinkAbout: {
      de: "About",
      en: "About"
    },
    footerLinkContact: {
      de: "Kontakt",
      en: "Contact"
    },
    footerRights: {
      de: "From Message To Movement. All rights reserved.",
      en: "From Message To Movement. All rights reserved."
    },
    footerPopupImpressumTitle: {
      de: "Impressum",
      en: "Imprint"
    },
    footerPopupTermsTitle: {
      de: "AGB",
      en: "Terms"
    },
    footerPopupPrivacyTitle: {
      de: "Datenschutz",
      en: "Privacy"
    },
    footerPopupWithdrawalTitle: {
      de: "Widerruf",
      en: "Withdrawal"
    },
    footerPopupAboutTitle: {
      de: "About",
      en: "About"
    },
    footerPopupContactTitle: {
      de: "Kontakt",
      en: "Contact"
    }
  };

  var smfStorieskidsKidsHtml =
    '<span class="smf-storieskids-kids">' +
    '<span class="smf-storieskids-kids__k">K</span>' +
    '<span class="smf-storieskids-kids__i">I</span>' +
    '<span class="smf-storieskids-kids__d">D</span>' +
    '<span class="smf-storieskids-kids__s">S</span>' +
    "</span>";

  var i18nHtml = {
    musicCollectiveCta: {
      de: "Entdecke Stories" + smfStorieskidsKidsHtml,
      en: "Discover Stories" + smfStorieskidsKidsHtml,
      nl: "Discover Stories" + smfStorieskidsKidsHtml,
      fr: "Discover Stories" + smfStorieskidsKidsHtml,
      es: "Discover Stories" + smfStorieskidsKidsHtml
    },
    footerPopupImpressumBody: {
      de: [
        "<p>",
        "<span style=\"font-size:1.15em; font-weight:500; display:inline-block; margin-bottom:4px;\">ScanMeFamily</span><br>",
        "Inhaber: Josef Gusejnov-K&ouml;ppl<br>",
        "c/o Postflex #9965<br>",
        "Emsdettener Str. 10<br>",
        "48268 Greven<br>",
        "Deutschland<br><br>",
        "E-Mail: <a href=\"mailto:support@scanmefamily.com\" style=\"color:rgba(190, 186, 186, 0.65); text-decoration:none;\">support@scanmefamily.com</a><br><br>",
        "USt-ID: DE459262280",
        "</p>"
      ].join(""),
      en: [
        "<p>",
        "<span style=\"font-size:1.15em; font-weight:500; display:inline-block; margin-bottom:4px;\">ScanMeFamily</span><br>",
        "Owner: Josef Gusejnov-K&ouml;ppl<br>",
        "c/o Postflex #9965<br>",
        "Emsdettener Str. 10<br>",
        "48268 Greven<br>",
        "Germany<br><br>",
        "Email: <a href=\"mailto:support@scanmefamily.com\" style=\"color:rgba(190, 186, 186, 0.65); text-decoration:none;\">support@scanmefamily.com</a><br><br>",
        "VAT ID: DE459262280",
        "</p>"
      ].join("")
    },
    footerPopupTermsBody: {
      de: [
        "<div>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.85); line-height:1.6;\">Diese Allgemeinen Gesch&auml;ftsbedingungen (AGB) gelten f&uuml;r alle Bestellungen, die Verbraucher (&sect; 13 BGB) &uuml;ber den Online-Shop <strong>ScanMeFamily</strong> t&auml;tigen.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">1. Vertragspartner</span><br>Der Kaufvertrag kommt zustande mit:<br>ScanMeFamily<br>Inhaber: Josef Gusejnov-K&ouml;ppl<br><span style=\"opacity:0.7;\">Weitere Angaben zum Vertragspartner finden Sie im Impressum.</span></p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">2. Vertragsschluss</span><br>Die Darstellung der Produkte im Online-Shop stellt kein rechtlich bindendes Angebot dar, sondern eine unverbindliche Aufforderung zur Bestellung. Durch Absenden der Bestellung geben Sie ein verbindliches Angebot ab. Der Vertrag kommt zustande, sobald wir Ihre Bestellung per E-Mail best&auml;tigen.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">3. Preise und Versandkosten</span><br>Alle Preise sind Endpreise in Euro und enthalten die gesetzliche Umsatzsteuer. Zus&auml;tzlich anfallende Versandkosten werden im Bestellprozess deutlich ausgewiesen.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">4. Lieferung</span><br>Die Lieferung erfolgt an die von Ihnen angegebene Lieferadresse. Unsere Produkte werden erst nach Bestellung gefertigt (Print-on-Demand). Lieferzeiten werden im Shop angegeben.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">5. Zahlung</span><br>Die verf&uuml;gbaren Zahlungsarten werden im Online-Shop angezeigt. Die Belastung erfolgt unmittelbar nach Vertragsschluss, sofern nichts anderes angegeben ist.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">6. Widerrufsrecht</span><br>Verbrauchern steht ein gesetzliches Widerrufsrecht zu. Einzelheiten finden Sie in der gesondert im Shop bereitgestellten Widerrufsbelehrung.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">7. Eigentumsvorbehalt</span><br>Die Ware bleibt bis zur vollst&auml;ndigen Bezahlung unser Eigentum.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">8. Gew&auml;hrleistung</span><br>Es gilt das gesetzliche M&auml;ngelhaftungsrecht.</p>",
        "<p style=\"margin-bottom:0; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">9. Haftung</span><br>Wir haften unbeschr&auml;nkt bei Vorsatz, grober Fahrl&auml;ssigkeit sowie bei Verletzung von Leben, K&ouml;rper oder Gesundheit. Bei leichter Fahrl&auml;ssigkeit haften wir nur bei Verletzung wesentlicher Vertragspflichten und beschr&auml;nkt auf den vorhersehbaren Schaden.</p>",
        "</div>"
      ].join(""),
      en: [
        "<div>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.85); line-height:1.6;\">These Terms and Conditions apply to all orders placed by consumers (Section 13 German Civil Code, BGB) through the <strong>ScanMeFamily</strong> online shop.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">1. Contract partner</span><br>The purchase contract is concluded with:<br>ScanMeFamily<br>Owner: Josef Gusejnov-K&ouml;ppl<br><span style=\"opacity:0.7;\">Further details about the contractual partner can be found in the imprint.</span></p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">2. Conclusion of contract</span><br>The presentation of products in the online shop does not constitute a legally binding offer, but a non-binding invitation to place an order. By submitting an order, you make a binding offer. The contract is concluded as soon as we confirm your order by email.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">3. Prices and shipping costs</span><br>All prices are final prices in euros and include statutory VAT. Any additional shipping costs are clearly displayed during checkout.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">4. Delivery</span><br>Delivery is made to the shipping address you provide. Our products are only produced after an order is placed (print-on-demand). Delivery times are stated in the shop.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">5. Payment</span><br>The available payment methods are shown in the online shop. Payment is charged immediately after the contract is concluded unless stated otherwise.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">6. Right of withdrawal</span><br>Consumers have a statutory right of withdrawal. Details can be found in the separate withdrawal policy provided in the shop.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">7. Retention of title</span><br>The goods remain our property until full payment has been made.</p>",
        "<p style=\"margin-bottom:1.8em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">8. Warranty</span><br>The statutory warranty rights apply.</p>",
        "<p style=\"margin-bottom:0; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.4em;\">9. Liability</span><br>We are fully liable for intent, gross negligence, and injury to life, body, or health. In cases of slight negligence, we are only liable for the breach of essential contractual obligations and limited to foreseeable damage.</p>",
        "</div>"
      ].join("")
    },
    footerPopupPrivacyBody: function(uiLang) {
      var currentDate = formatFooterPopupDate(uiLang);

      if (uiLang === "de") {
        return [
          "<div>",
          "<p style=\"margin-bottom:1.2em; color:rgba(255,255,255,0.85); line-height:1.6;\"><strong>Datenschutzerkl&auml;rung</strong><br>Wir nehmen den Schutz Ihrer Daten ernst und verarbeiten personenbezogene Daten nur im Rahmen der geltenden Datenschutzgesetze (insb. DSGVO).</p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">1. Verantwortlicher</span><br>ScanMeFamily<br>Inhaber: Josef Gusejnov-K&ouml;ppl<br><span style=\"opacity:0.7;\">Weitere Angaben finden Sie im Impressum.</span></p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">2. Zugriffsdaten (Server-Logs)</span><br>Beim Besuch unserer Website werden durch den Hosting-Anbieter technisch notwendige Daten verarbeitet (z.&nbsp;B. IP-Adresse, Datum/Uhrzeit, aufgerufene Seite, Browser/OS). Die Verarbeitung erfolgt zur Bereitstellung und Sicherheit der Website (Art. 6 Abs. 1 lit. f DSGVO).</p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">3. Hosting und Shop-Plattform (Shopify)</span><br>Unser Shop wird &uuml;ber Shopify betrieben (Shopify International/Shopify Inc.). Shopify verarbeitet Daten, die zur Nutzung des Shops, zur Bestellabwicklung und zum technischen Betrieb erforderlich sind. Dabei kann es zu einer Verarbeitung in Drittl&auml;ndern (z.&nbsp;B. Kanada/USA) kommen. Shopify st&uuml;tzt sich hierf&uuml;r auf geeignete Garantien (insb. Standardvertragsklauseln). Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertrag) und Art. 6 Abs. 1 lit. f DSGVO (sicherer Betrieb).</p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">4. Bestellungen</span><br>Wenn Sie bei uns bestellen, verarbeiten wir die f&uuml;r die Vertragsabwicklung notwendigen Daten (z.&nbsp;B. Name, Lieferadresse, E-Mail-Adresse, bestellte Artikel, Zahlungs-/Transaktionsdaten). Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO. Gesetzliche Aufbewahrungspflichten (z.&nbsp;B. Handels-/Steuerrecht) bleiben unber&uuml;hrt (Art. 6 Abs. 1 lit. c DSGVO).</p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">5. Zahlungsabwicklung</span><br>Je nach gew&auml;hlter Zahlungsart werden Zahlungsdaten an den jeweiligen Zahlungsdienstleister &uuml;bermittelt (z.&nbsp;B. Shopify Payments und/oder weitere im Checkout angezeigte Anbieter). Die Verarbeitung erfolgt zur Zahlungsabwicklung (Art. 6 Abs. 1 lit. b DSGVO). Bitte beachten Sie die Datenschutzhinweise des jeweiligen Anbieters.</p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">6. Versand und Produktion (Print-on-Demand)</span><br>Zur Lieferung und &ndash; sofern erforderlich &ndash; zur Produktion (Print-on-Demand) geben wir Bestelldaten an Versanddienstleister und ggf. Produktions-/Fulfillment-Partner weiter (z.&nbsp;B. Name, Adresse, bestellte Artikel). Dies erfolgt ausschlie&szlig;lich zur Vertragserf&uuml;llung (Art. 6 Abs. 1 lit. b DSGVO).</p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">7. Kontakt</span><br>Wenn Sie uns per E-Mail kontaktieren, verarbeiten wir Ihre Angaben zur Bearbeitung der Anfrage. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (vorvertraglich/vertraglich) oder Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effizienter Kommunikation).</p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">8. Cookies und &auml;hnliche Technologien</span><br>Unser Shop nutzt technisch notwendige Cookies, um Grundfunktionen (z.&nbsp;B. Warenkorb, Checkout, Spracheinstellungen) bereitzustellen. Sofern wir zus&auml;tzliche Cookies/Tools (z.&nbsp;B. Reichweitenmessung/Marketing) einsetzen, erfolgt dies nur mit Ihrer Einwilligung &uuml;ber ein entsprechendes Cookie-Banner (Art. 6 Abs. 1 lit. a DSGVO). Welche Cookies konkret gesetzt werden, h&auml;ngt u.&nbsp;a. von Shopify und ggf. installierten Apps ab.</p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">9. Nutzung von Scan-Weiterleitungen</span><br>Unsere Produkte k&ouml;nnen QR-Codes enthalten, die auf Inhalte unserer Website oder auf Unterseiten (z.&nbsp;B. go.scanmefamily.com) weiterleiten. Beim Aufruf einer solchen Weiterleitung verarbeiten wir technische Nutzungsdaten (z.&nbsp;B. Zeitpunkt des Aufrufs, gek&uuml;rzte IP-Adresse, Herkunft der Anfrage), um die Funktionalit&auml;t der Weiterleitung sicherzustellen, Missbrauch zu erkennen und die Nutzung anonymisiert auszuwerten. Eine Zusammenf&uuml;hrung mit Kundenkonten oder eine Nutzung zu Werbezwecken findet nicht statt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.</p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">10. Ihre Rechte</span><br>Sie haben das Recht auf Auskunft, Berichtigung, L&ouml;schung, Einschr&auml;nkung der Verarbeitung, Daten&uuml;bertragbarkeit sowie Widerspruch gegen bestimmte Verarbeitungen (Art. 15&ndash;21 DSGVO). Wenn die Verarbeitung auf Einwilligung beruht, k&ouml;nnen Sie diese jederzeit mit Wirkung f&uuml;r die Zukunft widerrufen (Art. 7 Abs. 3 DSGVO).</p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">11. Beschwerderecht</span><br>Sie haben zudem das Recht, sich bei einer Datenschutzaufsichtsbeh&ouml;rde zu beschweren (Art. 77 DSGVO).</p>",
          "<p style=\"margin-bottom:0; color:rgba(255,255,255,0.7); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">Stand</span><br>",
          currentDate,
          "</p>",
          "</div>"
        ].join("");
      }

      return [
        "<div>",
        "<p style=\"margin-bottom:1.2em; color:rgba(255,255,255,0.85); line-height:1.6;\"><strong>Privacy Policy</strong><br>We take the protection of your data seriously and process personal data only in accordance with the applicable data protection laws (in particular the GDPR).</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">1. Controller</span><br>ScanMeFamily<br>Owner: Josef Gusejnov-K&ouml;ppl<br><span style=\"opacity:0.7;\">Further details can be found in the imprint.</span></p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">2. Access data (server logs)</span><br>When you visit our website, the hosting provider processes technically necessary data (e.g. IP address, date/time, page accessed, browser/OS). This processing is carried out to provide and secure the website (Art. 6 para. 1 lit. f GDPR).</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">3. Hosting and shop platform (Shopify)</span><br>Our shop is hosted on Shopify (Shopify International/Shopify Inc.). Shopify processes data required for the use of the shop, order processing, and technical operation. This may involve processing in third countries (e.g. Canada/USA). Shopify relies on appropriate safeguards for this, in particular standard contractual clauses. Legal basis: Art. 6 para. 1 lit. b GDPR (contract) and Art. 6 para. 1 lit. f GDPR (secure operation).</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">4. Orders</span><br>When you place an order with us, we process the data necessary for contract fulfilment (e.g. name, delivery address, email address, items ordered, payment/transaction data). Legal basis: Art. 6 para. 1 lit. b GDPR. Statutory retention obligations (e.g. commercial and tax law) remain unaffected (Art. 6 para. 1 lit. c GDPR).</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">5. Payment processing</span><br>Depending on the selected payment method, payment data is transferred to the respective payment service provider (e.g. Shopify Payments and/or other providers shown at checkout). The processing is carried out for payment handling (Art. 6 para. 1 lit. b GDPR). Please note the privacy notices of the respective provider.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">6. Shipping and production (print-on-demand)</span><br>For delivery and, where required, production (print-on-demand), we pass on order data to shipping providers and, where applicable, production/fulfilment partners (e.g. name, address, ordered items). This is done solely for the fulfilment of the contract (Art. 6 para. 1 lit. b GDPR).</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">7. Contact</span><br>If you contact us by email, we process the information you provide in order to handle your request. Legal basis: Art. 6 para. 1 lit. b GDPR (pre-contractual/contractual) or Art. 6 para. 1 lit. f GDPR (legitimate interest in efficient communication).</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">8. Cookies and similar technologies</span><br>Our shop uses technically necessary cookies to provide core functions (e.g. cart, checkout, language settings). If we use additional cookies/tools (e.g. analytics or marketing), this is done only with your consent via a corresponding cookie banner (Art. 6 para. 1 lit. a GDPR). Which cookies are set specifically depends, among other things, on Shopify and any installed apps.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">9. Use of scan redirects</span><br>Our products may contain QR codes that redirect to content on our website or subdomains (e.g. go.scanmefamily.com). When such a redirect is accessed, we process technical usage data (e.g. time of access, shortened IP address, origin of the request) in order to ensure the functionality of the redirect, detect misuse, and analyse usage in anonymised form. This data is not combined with customer accounts and is not used for advertising purposes. Legal basis: Art. 6 para. 1 lit. f GDPR.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">10. Your rights</span><br>You have the right to access, rectification, erasure, restriction of processing, data portability, and to object to certain processing activities (Art. 15&ndash;21 GDPR). If processing is based on consent, you may withdraw that consent at any time with effect for the future (Art. 7 para. 3 GDPR).</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">11. Right to lodge a complaint</span><br>You also have the right to lodge a complaint with a data protection supervisory authority (Art. 77 GDPR).</p>",
        "<p style=\"margin-bottom:0; color:rgba(255,255,255,0.7); line-height:1.6;\"><span style=\"font-weight:600; display:inline-block; margin-bottom:0.35em;\">Last updated</span><br>",
        currentDate,
        "</p>",
        "</div>"
      ].join("");
    },
    footerPopupWithdrawalBody: function(uiLang, lang) {
      var withdrawalUrl = buildLocalizedPath("/pages/widerruf", getShopLangForUiLang(lang));
      var returnsSubject = uiLang === "de" ? "Retouren - #Bestellnummer" : "Return - #OrderNumber";
      var returnsMailto = "mailto:support@scanmefamily.com?subject=" + encodeURIComponent(returnsSubject);

      if (uiLang === "de") {
        return [
          "<div>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.85); line-height:1.6;\"><strong>Widerrufsrecht</strong></p>",
          "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gr&uuml;nden diesen Vertrag zu widerrufen. Die Widerrufsfrist betr&auml;gt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Bef&ouml;rderer ist, die Waren in Besitz genommen haben bzw. hat.</p>",
          "<p style=\"margin-bottom:2.2em; color:rgba(255,255,255,0.7); line-height:1.6;\">Details und Musterformular finden Sie hier: <a href=\"",
          withdrawalUrl,
          "\" style=\"color:rgba(255,255,255,0.72); text-decoration:none;\">Ausf&uuml;hrliche Widerrufsbelehrung</a></p>",
          "<hr style=\"border:none; height:1px; background:rgba(255,255,255,0.08); margin:2.4em 0 1.8em 0;\">",
          "<p style=\"margin-bottom:0.8em; color:rgba(255,255,255,0.75); line-height:1.6;\"><strong>Retouren &amp; R&uuml;ckgabe</strong></p>",
          "<p style=\"margin-bottom:0.9em; color:rgba(255,255,255,0.75); line-height:1.6;\">So l&auml;uft die R&uuml;ckgabe ab:</p>",
          "<ul style=\"margin:0 0 1.4em 1.2em; padding:0; color:rgba(255,255,255,0.8); line-height:1.6;\">",
          "<li style=\"margin-bottom:0.6em;\">Kontaktieren Sie uns per E-Mail an <a href=\"",
          returnsMailto,
          "\" style=\"color:rgba(190,186,186,0.72); text-decoration:none;\">support@scanmefamily.com</a> (Betreff: &bdquo;Retouren - #Bestellnummer&ldquo;).</li>",
          "<li style=\"margin-bottom:0.6em;\">Bitte geben Sie Ihre Bestellnummer sowie den betreffenden Artikel an.</li>",
          "<li style=\"margin-bottom:0.6em;\">Die R&uuml;cksendung erfolgt innerhalb von 14 Tagen nach Widerruf. Die Ware sollte unbesch&auml;digt und &ndash; soweit m&ouml;glich &ndash; in Originalverpackung zur&uuml;ckgesendet werden.</li>",
          "<li style=\"margin-bottom:0.6em;\">Die unmittelbaren Kosten der R&uuml;cksendung betragen <strong>5,90&nbsp;&euro;</strong> und sind vom Kunden zu tragen. F&uuml;r die R&uuml;cksendung stellen wir ein Retourenlabel zur Verf&uuml;gung; die Kosten werden vom Erstattungsbetrag abgezogen.</li>",
          "<li style=\"margin-bottom:0;\">Bei falscher oder fehlerhafter Lieferung (z.&nbsp;B. falscher Artikel, falsch gelieferte Gr&ouml;&szlig;e oder fehlerhafter Druck) kontaktieren Sie uns bitte zun&auml;chst. Eine R&uuml;cksendung ist nur erforderlich, wenn wir Sie dazu auffordern.</li>",
          "</ul>",
          "<p style=\"margin-bottom:0; color:rgba(255,255,255,0.7); line-height:1.6;\">Hinweis: Der Ablauf dient der Orientierung; ma&szlig;geblich sind die Regelungen der Widerrufsbelehrung.</p>",
          "</div>"
        ].join("");
      }

      return [
        "<div>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.85); line-height:1.6;\"><strong>Right of withdrawal</strong></p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">You have the right to withdraw from this contract within fourteen days without giving any reason. The withdrawal period is fourteen days from the day on which you, or a third party named by you who is not the carrier, took possession of the goods.</p>",
        "<p style=\"margin-bottom:2.2em; color:rgba(255,255,255,0.7); line-height:1.6;\">Details and a sample form can be found here: <a href=\"",
        withdrawalUrl,
        "\" style=\"color:rgba(255,255,255,0.72); text-decoration:none;\">Full withdrawal policy</a></p>",
        "<hr style=\"border:none; height:1px; background:rgba(255,255,255,0.08); margin:2.4em 0 1.8em 0;\">",
        "<p style=\"margin-bottom:0.8em; color:rgba(255,255,255,0.75); line-height:1.6;\"><strong>Returns &amp; Refunds</strong></p>",
        "<p style=\"margin-bottom:0.9em; color:rgba(255,255,255,0.75); line-height:1.6;\">How to return an item:</p>",
        "<ul style=\"margin:0 0 1.4em 1.2em; padding:0; color:rgba(255,255,255,0.8); line-height:1.6;\">",
        "<li style=\"margin-bottom:0.6em;\">Contact us by email at <a href=\"",
        returnsMailto,
        "\" style=\"color:rgba(190,186,186,0.72); text-decoration:none;\">support@scanmefamily.com</a> (subject: &ldquo;Return - #OrderNumber&rdquo;).</li>",
        "<li style=\"margin-bottom:0.6em;\">Please include your order number and the item you would like to return.</li>",
        "<li style=\"margin-bottom:0.6em;\">The return must be sent within 14 days after cancellation. Items should be returned unused and &ndash; where possible &ndash; in their original packaging.</li>",
        "<li style=\"margin-bottom:0.6em;\">The direct cost of returning the goods is <strong>EUR 5.90</strong> and must be borne by the customer. We provide a return label for the shipment; the cost will be deducted from the refund amount.</li>",
        "<li style=\"margin-bottom:0;\">If the delivery is incorrect or defective (e.g. wrong item, incorrectly delivered size, or faulty print), please contact us first. A return is only required if we ask you to send the item back.</li>",
        "</ul>",
        "<p style=\"margin-bottom:0; color:rgba(255,255,255,0.7); line-height:1.6;\">Note: This process is provided for guidance; the legally binding terms are set out in the cancellation policy.</p>",
        "</div>"
      ].join("");
    },
    footerPopupAboutBody: {
      de: [
        "<div>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.85); line-height:1.6;\"><strong>Sch&ouml;n, dass du hier bist &#128521;</strong></p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">ScanMeFamily verbindet physische Produkte mit digitalen Informationen und Inhalten. Im Mittelpunkt steht <strong>PROTECTED</strong> &ndash; die gemeinsame Designsprache unserer Protected Bands und Apparel Collections. Sie steht f&uuml;r Schutz, Zugeh&ouml;rigkeit und eine Form von Pr&auml;senz, die nicht laut sein muss.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">Die <strong>Protected Bands</strong> bilden den funktionalen Kern von ScanMeFamily. &Uuml;ber QR-Code und NFC k&ouml;nnen wichtige Informationen, Kontaktm&ouml;glichkeiten und pers&ouml;nliche Inhalte direkt &uuml;ber das Band erreichbar gemacht werden. Besonders im Alltag mit Kindern entsteht so eine einfache Verbindung zwischen einem physischen Produkt und einer individuell hinterlegten digitalen Protected Page.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">Parallel dazu &uuml;bersetzt unser <strong>Apparel</strong> dieselbe Idee in Kleidung. Hoodies, T-Shirts, Crewnecks und Kids Pieces tragen PROTECTED als verbindendes Branding und kombinieren reduzierte Gestaltung, ausgew&auml;hlte Materialien und unterschiedliche Veredelungen wie Print und Stick. Die einzelnen Collections unterscheiden sich in Passform, Farbwelt und Ausf&uuml;hrung, geh&ouml;ren aber zur gleichen visuellen Sprache.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">Ein weiterer Teil von ScanMeFamily ist die Verbindung zu wechselnden digitalen Botschaften. &Uuml;ber unseren <strong>Signature QR</strong> &ouml;ffnet sich regelm&auml;&szlig;ig ein neuer Impuls &ndash; ein Vers, ein Gedanke oder eine kurze Botschaft, die Raum f&uuml;r Hoffnung, Glauben und pers&ouml;nliche Interpretation l&auml;sst. Nicht als fertige Antwort, sondern als kleiner Moment im Alltag, der vielleicht einen Gedanken anst&ouml;&szlig;t, eine neue Perspektive er&ouml;ffnet oder Glauben dort sichtbar macht, wo er sonst vielleicht keinen Raum gefunden h&auml;tte.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">ScanMeFamily selbst bleibt dabei bewusst im Hintergrund. Die Marke bildet das System hinter PROTECTED, den Bands, den digitalen Verbindungen und den Apparel Collections. Der sichtbare Fokus liegt auf den Produkten und der Verbindung, die durch sie entsteht.</p>",
        "<p style=\"margin-bottom:0; color:rgba(255,255,255,0.8); line-height:1.6;\"><strong>Speak without speaking.</strong></p>",
        "</div>"
      ].join(""),
      en: [
        "<div>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.85); line-height:1.6;\"><strong>Glad you&rsquo;re here &#128521;</strong></p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">ScanMeFamily connects physical products with digital information and content. At the center is <strong>PROTECTED</strong> &mdash; the shared design language across our Protected Bands and Apparel Collections. It stands for protection, belonging, and a kind of presence that does not need to be loud.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">The <strong>Protected Bands</strong> form the functional core of ScanMeFamily. Through QR code and NFC, important information, contact options, and personal content can be accessed directly through the band. Especially in everyday life with children, this creates a simple connection between a physical product and an individually stored digital Protected Page.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">Alongside this, our <strong>Apparel</strong> translates the same idea into clothing. Hoodies, T-shirts, crewnecks, and Kids Pieces carry PROTECTED as the unifying branding and combine reduced design, selected materials, and different finishes such as print and embroidery. The individual collections differ in fit, color palette, and execution, but remain part of the same visual language.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">Another part of ScanMeFamily is the connection to changing digital messages. Through our <strong>Signature QR</strong>, a new impulse appears regularly &mdash; a verse, a thought, or a short message that leaves room for hope, faith, and personal interpretation. Not as a finished answer, but as a small moment in everyday life that may spark a thought, open a new perspective, or make faith visible where it might otherwise have found no space.</p>",
        "<p style=\"margin-bottom:1.6em; color:rgba(255,255,255,0.8); line-height:1.6;\">ScanMeFamily itself deliberately stays in the background. The brand forms the system behind PROTECTED, the bands, the digital connections, and the Apparel Collections. The visible focus remains on the products and the connection they create.</p>",
        "<p style=\"margin-bottom:0; color:rgba(255,255,255,0.8); line-height:1.6;\"><strong>Speak without speaking.</strong></p>",
        "</div>"
      ].join("")
    },
    footerPopupContactBody: {
      de: "<p>Kontakt: <a href=\"mailto:support@scanmefamily.com\" style=\"color:rgba(190, 186, 186, 0.65); text-decoration:none;\">support@scanmefamily.com</a></p>",
      en: "<p>Contact: <a href=\"mailto:support@scanmefamily.com\" style=\"color:rgba(190, 186, 186, 0.65); text-decoration:none;\">support@scanmefamily.com</a></p>"
    }
  };

  function formatFooterPopupDate(uiLang) {
    var locale = uiLang === "de" ? "de-DE" : "en-GB";

    try {
      return new Date().toLocaleDateString(locale);
    } catch (error) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  var uiHintTexts = {
    nl: "De gebruikersoberfl\u00e4che is in het Engels beschikbaar.\nDe dagvers wordt in uw taal weergegeven.",
    fr: "L\u2019interface est disponible en anglais.\nLe verset du jour est affich\u00e9 dans votre langue.",
    es: "La interfaz est\u00e1 disponible en ingl\u00e9s.\nEl vers\u00edculo del d\u00eda se muestra en su idioma.",
    ru: "\u0418\u043d\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u0434\u043e\u0441\u0442\u0443\u043f\u0435\u043d \u043d\u0430 \u0430\u043d\u0433\u043b\u0438\u0439\u0441\u043a\u043e\u043c \u044f\u0437\u044b\u043a\u0435.\n\u0421\u0442\u0438\u0445 \u0434\u043d\u044f \u043f\u043e\u043a\u0430\u0437\u044b\u0432\u0430\u0435\u0442\u0441\u044f \u043d\u0430 \u0432\u0430\u0448\u0435\u043c \u044f\u0437\u044b\u043a\u0435."
  };

  function shouldShowLanguageHint(lang) {
    var safeLang = sanitizeVerseLang(lang);
    return !!(safeLang && safeLang !== "de" && safeLang !== "en");
  }

  function resolveUiHintText(lang) {
    return uiHintTexts[lang] || uiHintTexts.nl;
  }

  function persistLanguageHintPending(fromLang, toLang) {
    var from = sanitizeVerseLang(fromLang);
    var to = sanitizeVerseLang(toLang);

    if (!to || from === to || !shouldShowLanguageHint(to)) return false;

    try {
      sessionStorage.setItem(
        smfUiHintStorageKeys.pendingSwitch,
        JSON.stringify({
          from: from || null,
          to: to,
          t: Date.now()
        })
      );
      return true;
    } catch (error) {
      return false;
    }
  }

  function readLanguageHintPending(remove) {
    var raw;
    var payload;

    try {
      raw = sessionStorage.getItem(smfUiHintStorageKeys.pendingSwitch);
      if (remove) {
        sessionStorage.removeItem(smfUiHintStorageKeys.pendingSwitch);
      }
    } catch (error) {
      return null;
    }

    if (!raw) return null;

    try {
      payload = JSON.parse(raw);
    } catch (error) {
      if (remove) return null;
      try {
        sessionStorage.removeItem(smfUiHintStorageKeys.pendingSwitch);
      } catch (clearError) {
      }
      return null;
    }

    if (!payload || !payload.to) return null;
    if (
      typeof payload.t === "number" &&
      Date.now() - payload.t > SMF_UI_HINT_PENDING_MAX_AGE
    ) {
      if (!remove) {
        try {
          sessionStorage.removeItem(smfUiHintStorageKeys.pendingSwitch);
        } catch (staleError) {
        }
      }
      return null;
    }

    payload.to = sanitizeVerseLang(payload.to);
    payload.from = sanitizeVerseLang(payload.from);
    return payload.to ? payload : null;
  }

  function consumeLanguageHintPending() {
    return readLanguageHintPending(true);
  }
 
  var flagByLang = {
    de: "\/\/scanmefamily.com\/cdn\/shop\/t\/6\/assets\/flag-de.png?v=21182930467331145841788426896",
    en: "\/\/scanmefamily.com\/cdn\/shop\/t\/6\/assets\/flag-en.png?v=172300809621023485371788426897",
    nl: "\/\/scanmefamily.com\/cdn\/shop\/t\/6\/assets\/flag-nl.png?v=150792518922651956141788426897",
    fr: "\/\/scanmefamily.com\/cdn\/shop\/t\/6\/assets\/flag-fr.png?v=11170281871163066771788426897",
    es: "\/\/scanmefamily.com\/cdn\/shop\/t\/6\/assets\/flag-es.png?v=175163161857014721281788426897",
    ru: "\/\/scanmefamily.com\/cdn\/shop\/t\/6\/assets\/flag-ru.png?v=23585069236573070931788426897"
  };
  /* Keys must match supportedLanguages — keep in sync with snippets/smef-faith-bible-url.liquid */
  var faithBibleUrlByLang = {
    de: "https://www.bible.com/de",
    en: "https://www.bible.com/",
    nl: "https://www.bible.com/nl",
    fr: "https://www.bible.com/fr",
    es: "https://www.bible.com/es",
    ru: "https://www.bible.com/ru"
  };

  function getDayOfYear(date) {
    var d = date || new Date();
    var start = new Date(d.getFullYear(), 0, 0);
    var diff = d - start;
    var oneDay = 1000 * 60 * 60 * 24;
    return Math.floor(diff / oneDay);
  }

  function sanitizeVerseLang(lang) {
    var normalizedLang = String(lang || "")
      .slice(0, 2)
      .toLowerCase();

    return supportedLanguages.indexOf(normalizedLang) !== -1 ? normalizedLang : null;
  }

  function sanitizeShopLang(lang) {
    var normalizedLang = String(lang || "")
      .slice(0, 2)
      .toLowerCase();

    return normalizedLang === "de" || normalizedLang === "en" ? normalizedLang : null;
  }

  function sanitizeCountryCode(countryCode) {
    var normalizedCountryCode = String(countryCode || "")
      .slice(0, 2)
      .toUpperCase();

    return normalizedCountryCode || null;
  }

  function getLanguageBootstrapData() {
    var root = document.documentElement;

    return {
      requestLocale: root ? sanitizeShopLang(root.getAttribute("data-smf-request-locale")) : null,
      localizationLanguage: root ? sanitizeShopLang(root.getAttribute("data-smf-localization-language")) : null,
      countryCode: root ? sanitizeCountryCode(root.getAttribute("data-smf-country-code")) : null
    };
  }

  function getBrowserPreferredVerseLang() {
    return sanitizeVerseLang(navigator.language || navigator.userLanguage || "en");
  }

  function normalizePath(path) {
    var safePath = path || "/";
    var normalized = safePath.replace(/^https?:\/\/[^/]+/i, "");

    if (!normalized) normalized = "/";
    if (normalized.charAt(0) !== "/") normalized = "/" + normalized;

    normalized = normalized.replace(/\/{2,}/g, "/");

    if (normalized.length > 1) {
      normalized = normalized.replace(/\/+$/, "");
    }

    return normalized || "/";
  }

  function stripLocalePrefix(path) {
    var normalized = normalizePath(path);
    var stripped = normalized;

    while (SMF_LOCALE_PREFIX_RE.test(stripped)) {
      stripped = stripped.replace(SMF_LOCALE_PREFIX_RE, "");
      if (!stripped) stripped = "/";
    }

    return stripped || "/";
  }

  function getShopLangForUiLang(lang) {
    return sanitizeVerseLang(lang) === "de" ? "de" : "en";
  }

  function getUiLangForLang(lang) {
    return lang === "de" ? "de" : "en";
  }

  function getExplicitShopLangFromPath(path) {
    var safePath = normalizePath(path || window.location.pathname || "/");

    if (/^\/en(?=\/|$)/.test(safePath)) {
      return "en";
    }

    if (/^\/de(?=\/|$)/.test(safePath)) {
      return "de";
    }

    return null;
  }

  function getShopLangFromPath(path) {
    var safePath = normalizePath(path || window.location.pathname || "/");
    return /^\/en(?=\/|$)/.test(safePath) ? "en" : "de";
  }

  function getCurrentShopLang() {
    var explicitShopLang = getExplicitShopLangFromPath(window.location.pathname || "/");
    var htmlLang = "";
    var bootstrapData = getLanguageBootstrapData();

    if (explicitShopLang) {
      return explicitShopLang;
    }

    if (bootstrapData.requestLocale) {
      return bootstrapData.requestLocale;
    }

    if (document.documentElement && document.documentElement.lang) {
      htmlLang = String(document.documentElement.lang).slice(0, 2).toLowerCase();
    }

    if (htmlLang === "de" || htmlLang === "en") {
      return htmlLang;
    }

    return getShopLangFromPath(window.location.pathname || "/");
  }

  function buildLanguageState(verseLang, shopLang, source) {
    var safeVerseLang = sanitizeVerseLang(verseLang) || "en";
    var derivedShopLang = getShopLangForUiLang(safeVerseLang);
    var safeShopLang = sanitizeShopLang(shopLang) || derivedShopLang;

    if (safeShopLang !== derivedShopLang) {
      safeShopLang = derivedShopLang;
    }

    return {
      verseLang: safeVerseLang,
      shopLang: safeShopLang,
      uiLang: getUiLangForLang(safeVerseLang),
      source: source || null
    };
  }

  function readStoredLanguageState() {
    var savedVerseLang = null;
    var savedShopLang = null;
    var savedSource = null;

    try {
      savedVerseLang =
        sanitizeVerseLang(localStorage.getItem(smfLanguageStorageKeys.verse)) ||
        sanitizeVerseLang(localStorage.getItem(smfLanguageStorageKeys.legacyVerse));
      savedShopLang = sanitizeShopLang(localStorage.getItem(smfLanguageStorageKeys.shop));
      savedSource = localStorage.getItem(smfLanguageStorageKeys.source);
    } catch (error) {
      return null;
    }

    if (!savedVerseLang && !savedShopLang) {
      return null;
    }

    if (!savedVerseLang && savedShopLang) {
      savedVerseLang = savedShopLang;
    }

    if (!savedShopLang && savedVerseLang) {
      savedShopLang = getShopLangForUiLang(savedVerseLang);
    }

    if (!savedVerseLang || !savedShopLang) {
      return null;
    }

    return buildLanguageState(savedVerseLang, savedShopLang, savedSource || "stored");
  }

  function getVerseLangFromCountry(countryCode) {
    return smfVerseLangByCountry[sanitizeCountryCode(countryCode)] || null;
  }

  function getAutomaticLanguageState() {
    var explicitShopLang = getExplicitShopLangFromPath(window.location.pathname || "/");
    var bootstrapData = getLanguageBootstrapData();
    var countryVerseLang = getVerseLangFromCountry(bootstrapData.countryCode);
    var browserVerseLang = getBrowserPreferredVerseLang();
    var requestShopLang = bootstrapData.requestLocale || bootstrapData.localizationLanguage || getCurrentShopLang();

    if (explicitShopLang) {
      return buildLanguageState(explicitShopLang, explicitShopLang, "auto-path");
    }

    if (countryVerseLang) {
      return buildLanguageState(countryVerseLang, getShopLangForUiLang(countryVerseLang), "auto-country");
    }

    if (browserVerseLang) {
      return buildLanguageState(browserVerseLang, getShopLangForUiLang(browserVerseLang), "auto-browser");
    }

    if (requestShopLang) {
      return buildLanguageState(requestShopLang, requestShopLang, "auto-shopify");
    }

    return buildLanguageState("en", "en", "fallback");
  }

  function persistLanguageState(langOrState, source) {
    var nextState;

    if (typeof langOrState === "object" && langOrState) {
      nextState = buildLanguageState(
        langOrState.verseLang || langOrState.lang,
        langOrState.shopLang,
        source || langOrState.source
      );
    } else {
      nextState = buildLanguageState(langOrState, null, source);
    }

    try {
      localStorage.setItem(smfLanguageStorageKeys.verse, nextState.verseLang);
      localStorage.setItem(smfLanguageStorageKeys.legacyVerse, nextState.verseLang);
      localStorage.setItem(smfLanguageStorageKeys.shop, nextState.shopLang);
      localStorage.setItem(
        smfLanguageStorageKeys.source,
        source || nextState.source || "manual"
      );
    } catch (error) {
    }

    return buildLanguageState(
      nextState.verseLang,
      nextState.shopLang,
      source || nextState.source || "manual"
    );
  }

  function getInitialLanguageState() {
    var storedState = readStoredLanguageState();
    var automaticState;

    if (storedState) {
      return storedState;
    }

    automaticState = getAutomaticLanguageState();
    persistLanguageState(automaticState, automaticState.source || "auto");
    return automaticState;
  }

  function getInitialLanguage() {
    return getInitialLanguageState().verseLang;
  }

  function applyShopLanguageSelection(shopLang, source) {
    var safeShopLang = sanitizeShopLang(shopLang);

    if (!safeShopLang) return null;

    return persistLanguageState(
      {
        verseLang: safeShopLang,
        shopLang: safeShopLang
      },
      source || "manual-shopify"
    );
  }

  function getShopLangFromLanguageAction(action) {
    var match = String(action || "").match(/\/selectLanguage\/([a-z]{2})/i);
    if (!match) return null;

    var lang = match[1].toLowerCase();
    if (lang === "de" || lang === "en") {
      return lang;
    }

    return null;
  }

  function syncLandingLanguageState(preferStoredLanguage) {
    var nextState;

    if (!document.querySelector(".smf-wrapper")) return;

    nextState =
      preferStoredLanguage
        ? (readStoredLanguageState() || getInitialLanguageState())
        : getInitialLanguageState();

    if (!nextState) {
      return;
    }

    if (
      window.smfCurrentLang === nextState.verseLang &&
      window.smfCurrentShopLang === nextState.shopLang
    ) {
      syncLandingPathToStoredShopLang(nextState.shopLang);
      return;
    }

    window.smfCurrentLang = nextState.verseLang;
    applyLanguage(nextState.verseLang, {
      shopLang: nextState.shopLang,
      source: nextState.source || "sync"
    });
    syncLandingPathToStoredShopLang(nextState.shopLang);
  }

  function syncLandingPathToStoredShopLang(shopLang) {
    var nextShopLang = sanitizeShopLang(shopLang);
    var storedState;

    if (!document.querySelector(".smf-wrapper")) return;

    if (!nextShopLang) {
      storedState = readStoredLanguageState();
      nextShopLang = storedState ? storedState.shopLang : null;
    }

    if (!nextShopLang) return;

    var currentPath = normalizePath(window.location.pathname || "/");
    var parsed;
    var virtualPath;
    var targetPath;
    var cleanSearch;

    if (!isShopLocaleAwarePath(currentPath)) return;

    parsed = parseLandingVirtualLocation(currentPath, window.location.search || "");
    virtualPath = parsed.routeSlug
      ? getVirtualRouteByKey(parsed.routeSlug).path
      : stripLocalePrefix(currentPath);
    targetPath = buildLocalizedPath(virtualPath, nextShopLang);
    cleanSearch = stripLandingBootstrapSearch(window.location.search || "");

    if (
      targetPath === currentPath &&
      !parsed.usedPageQuery &&
      cleanSearch === (window.location.search || "")
    ) {
      return;
    }

    if (window.history && window.history.replaceState) {
      window.history.replaceState(
        null,
        "",
        targetPath + cleanSearch + (window.location.hash || "")
      );
    }
  }

  function setupGlobalShopifyLanguageSync() {
    if (window.__smfShopifyLanguageSyncBound) return;
    window.__smfShopifyLanguageSyncBound = true;

    function syncShopLanguage(shopLang, source) {
      var fromLang = sanitizeVerseLang(window.smfCurrentLang || getInitialLanguage());
      var nextState = applyShopLanguageSelection(shopLang, source);
      var languageChanged;

      if (!nextState) return;

      languageChanged = fromLang !== nextState.verseLang;
      if (languageChanged) {
        persistLanguageHintPending(fromLang, nextState.verseLang);
      }

      if (document.querySelector(".smf-wrapper")) {
        window.smfCurrentLang = nextState.verseLang;
        applyLanguage(nextState.verseLang, {
          shopLang: nextState.shopLang,
          persist: false,
          source: nextState.source
        });
        syncLandingPathToStoredShopLang(nextState.shopLang);
        if (!languageChanged || !shouldShowLanguageHint(nextState.verseLang)) {
          consumeLanguageHintPending();
          hideUiHint();
        }
      }
    }

    document.addEventListener("click", function (event) {
      var target = event.target;
      var trigger =
        target && target.closest
          ? target.closest(".smf-drawer-language-trigger, .smf-language-list__item")
          : null;

      if (!trigger) return;

      var shopLang = getShopLangFromLanguageAction(trigger.getAttribute("on:click"));
      if (!shopLang) return;

      syncShopLanguage(shopLang, "manual-shopify");
    }, true);

    window.addEventListener("smf:shop-language-change", function (event) {
      var eventShopLang = sanitizeShopLang(event && event.detail ? event.detail.lang : null);

      if (!eventShopLang) return;

      syncShopLanguage(eventShopLang, "manual-shopify");
    });

    window.addEventListener("pageshow", function (event) {
      syncLandingLanguageState(!!(event && event.persisted));
      syncLandingRouteStateFromUrl();
      pinLandingScrollToUrlSection();
    });

    window.addEventListener("popstate", function () {
      setTimeout(function () {
        syncLandingLanguageState(true);
        syncLandingRouteStateFromUrl();
        scrollLandingToLocationSection();
      }, 0);
    });

    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) {
        syncLandingLanguageState(true);
      }
    });
  }

  function buildLocalizedPath(path, shopLang) {
    var normalizedPath = stripLocalePrefix(path);
    var prefix = shopLang === "en" ? "/en" : "";

    if (normalizedPath === "/") {
      return prefix || "/";
    }

    return prefix + normalizedPath;
  }

  function getLocalePrefixFromPath(path) {
    var normalized = normalizePath(path || window.location.pathname || "/");
    var match = normalized.match(SMF_LOCALE_PREFIX_RE);

    return match ? "/" + match[1].toLowerCase() : "";
  }

  function getVirtualRouteByKey(key) {
    if (!key) return null;
    return SMF_VIRTUAL_ROUTES[String(key).replace(/^\//, "").toLowerCase()] || null;
  }

  function parseLandingVirtualLocation(path, search) {
    var rawPath = normalizePath(path || window.location.pathname || "/");
    var searchString = typeof search === "string" ? search : (window.location.search || "");
    var localePrefix = getLocalePrefixFromPath(rawPath);
    var virtualPath = stripLocalePrefix(rawPath);
    var pathKey = virtualPath === "/" ? "" : virtualPath.replace(/^\//, "").toLowerCase();
    var pageParam = "";
    var route = getVirtualRouteByKey(pathKey);
    var usedPageQuery = false;

    try {
      pageParam = String(new URLSearchParams(searchString).get("page") || "").toLowerCase();
    } catch (error) {
      pageParam = "";
    }

    if (!route && pageParam) {
      route = getVirtualRouteByKey(pageParam);
      usedPageQuery = !!route;
    }

    if (!route) {
      return {
        localePrefix: localePrefix,
        routeSlug: null,
        canonicalPath: localePrefix || "/",
        bootstrapPath: null,
        sectionId: "smf-daily-verse",
        usedPageQuery: false
      };
    }

    return {
      localePrefix: localePrefix,
      routeSlug: route.slug,
      canonicalPath: (localePrefix || "") + route.path,
      bootstrapPath:
        (localePrefix ? localePrefix + "/" : "/") +
        "?page=" +
        encodeURIComponent(route.slug),
      sectionId: route.sectionId,
      usedPageQuery: usedPageQuery
    };
  }

  function canonicalizeLandingLocation() {
    var parsed = parseLandingVirtualLocation(
      window.location.pathname || "/",
      window.location.search || ""
    );
    var params;
    var rest = "";
    var nextUrl;

    if (!parsed.routeSlug || !window.history || !window.history.replaceState) {
      return parsed;
    }

    try {
      params = new URLSearchParams(window.location.search || "");
      params.delete("page");
      rest = params.toString();
    } catch (error) {
      rest = "";
    }

    nextUrl =
      parsed.canonicalPath +
      (rest ? "?" + rest : "") +
      (window.location.hash || "");

    if (
      normalizePath(window.location.pathname || "/") !== parsed.canonicalPath ||
      parsed.usedPageQuery ||
      /(?:^|[?&])page=/.test(window.location.search || "")
    ) {
      try {
        window.history.replaceState(null, "", nextUrl);
      } catch (error) {
      }
    }

    return parsed;
  }

  function getSameOriginUrl(href) {
    var url;

    if (!href) return null;

    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }

    if (url.origin !== window.location.origin) return null;

    return url;
  }

  function rewriteVisibleVirtualRouteHrefs() {
    var anchors = document.querySelectorAll("a[href]");
    var i;
    var anchor;
    var url;
    var parsed;
    var nextHref;

    for (i = 0; i < anchors.length; i++) {
      anchor = anchors[i];
      url = getSameOriginUrl(anchor.getAttribute("href"));
      if (!url) continue;

      parsed = parseLandingVirtualLocation(url.pathname, url.search);
      if (!parsed.usedPageQuery && !/(?:^|[?&])page=/.test(url.search || "")) {
        continue;
      }

      if (!parsed.routeSlug && stripLocalePrefix(url.pathname) !== "/") {
        continue;
      }

      nextHref = parsed.canonicalPath + (url.hash || "");
      if (anchor.getAttribute("href") !== nextHref) {
        anchor.setAttribute("href", nextHref);
      }
    }
  }

  function setupLandingVirtualRouteLinks() {
    rewriteVisibleVirtualRouteHrefs();

    if (!getLandingScrollWrapper()) return;
    if (window.__smfVirtualRouteLinksBound) return;
    window.__smfVirtualRouteLinksBound = true;

    document.addEventListener(
      "click",
      function (event) {
        var anchor;
        var href;
        var url;
        var parsed;
        var target;
        var virtualPath;

        if (event.defaultPrevented) return;
        if (event.button && event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        anchor = event.target && event.target.closest ? event.target.closest("a[href]") : null;
        if (!anchor) return;
        if (anchor.target && anchor.target !== "" && anchor.target !== "_self") return;
        if (anchor.getAttribute("data-scroll-target")) return;
        if (anchor.getAttribute("data-popup-target")) return;

        /* Hash-only hrefs resolve against the origin, so "#" would look like a
           link to "/" and route to the daily verse section. */
        href = anchor.getAttribute("href");
        if (!href || href.charAt(0) === "#") return;

        url = getSameOriginUrl(href);
        if (!url) return;

        parsed = parseLandingVirtualLocation(url.pathname, url.search);
        virtualPath = stripLocalePrefix(url.pathname);

        if (!parsed.routeSlug && virtualPath !== "/") return;
        if (!document.getElementById(parsed.sectionId)) return;

        event.preventDefault();
        target = document.getElementById(parsed.sectionId);
        if (!target) return;

        scrollLandingSectionIntoView(target, "smooth");
        smfUpdateUrlForSectionId(parsed.sectionId, false);
      },
      true
    );
  }

  function getLandingSectionIdFromLocation(path, search) {
    return parseLandingVirtualLocation(path, search).sectionId;
  }

  function getLandingSectionElementFromLocation(path, search) {
    var targetId = getLandingSectionIdFromLocation(path, search);
    return targetId ? document.getElementById(targetId) : null;
  }

  function scrollLandingToLocationSection() {
    var wrapper = getLandingScrollWrapper();
    var target = getLandingSectionElementFromLocation();

    if (!wrapper || !target) return false;

    return scrollLandingSectionIntoView(target, "smooth");
  }

  function getLandingScrollWrapper() {
    return document.querySelector(".smf-wrapper");
  }

  function pinLandingScrollToUrlSection() {
    var wrapper = getLandingScrollWrapper();
    var target = getLandingSectionElementFromLocation();

    if (!wrapper || !target) {
      return false;
    }

    if (target.id !== "smf-daily-verse") {
      return false;
    }

    temporarilyDisableLandingScrollSnap(wrapper, SMF_LANDING_SNAP_RESTORE_DURATION);
    wrapper.scrollTop = 0;
    return true;
  }

  function temporarilyDisableLandingScrollSnap(wrapper, duration) {
    var restoreDelay =
      typeof duration === "number" ? duration : SMF_LANDING_SNAP_RESTORE_DURATION;

    if (!wrapper || !wrapper.classList) return;

    if (wrapper._smfSnapRestoreTimer) {
      clearTimeout(wrapper._smfSnapRestoreTimer);
      wrapper._smfSnapRestoreTimer = null;
    }

    wrapper.classList.add("smf-wrapper--snap-disabled");
    wrapper._smfSnapRestoreTimer = window.setTimeout(function() {
      wrapper.classList.remove("smf-wrapper--snap-disabled");
      wrapper._smfSnapRestoreTimer = null;
    }, Math.max(0, restoreDelay));
  }

  function getLandingSectionScrollTop(wrapper, target) {
    var currentScrollTop;
    var wrapperRect;
    var targetRect;

    if (!wrapper || !target) return 0;

    currentScrollTop = wrapper.scrollTop || 0;
    wrapperRect = wrapper.getBoundingClientRect();
    targetRect = target.getBoundingClientRect();

    return Math.max(0, currentScrollTop + (targetRect.top - wrapperRect.top));
  }

  var smfLandingScrollCorrectionState = {
    sequence: 0,
    targetId: null,
    animationFrame: null,
    finalizeFrame: null,
    delayedTimer: null,
    alignFrame: null,
    viewportFrame: null,
    viewportRealignPending: false
  };
  var smfLandingBootState = {
    active: false,
    completed: false,
    targetId: null,
    until: 0,
    onComplete: null
  };

  function beginLandingBootSequence(targetId, durationMs, onComplete) {
    smfLandingBootState.active = true;
    smfLandingBootState.completed = false;
    smfLandingBootState.targetId = targetId || null;
    smfLandingBootState.onComplete =
      typeof onComplete === "function" ? onComplete : null;
    smfLandingBootState.until =
      Date.now() + (typeof durationMs === "number" ? durationMs : SMF_LANDING_BOOT_GUARD_DURATION);
  }

  function endLandingBootSequence() {
    smfLandingBootState.active = false;
    smfLandingBootState.targetId = null;
    smfLandingBootState.until = 0;
  }

  function completeLandingBootSequence() {
    var callback;

    if (smfLandingBootState.completed) {
      return;
    }

    smfLandingBootState.completed = true;
    callback = smfLandingBootState.onComplete;
    smfLandingBootState.onComplete = null;
    endLandingBootSequence();

    if (typeof callback === "function") {
      callback();
    }
  }

  function maybeCompleteLandingBootSequence(target) {
    if (smfLandingBootState.completed || !smfLandingBootState.active) {
      return;
    }

    if (
      smfLandingBootState.targetId &&
      target &&
      target.id !== smfLandingBootState.targetId
    ) {
      return;
    }

    completeLandingBootSequence();
    smfUpdateViewportHeight("boot-complete");
  }

  function isLandingBootSequenceActive() {
    if (!smfLandingBootState.active) {
      return false;
    }

    if (Date.now() > smfLandingBootState.until) {
      completeLandingBootSequence();
      return false;
    }

    return true;
  }
  var smfPinchZoomState = {
    active: false,
    suspendAutoSync: false,
    idleTimer: null,
    finalFrame: null,
    lastScale: 1,
    live: false,
    startDistance: 0,
    originX: 0,
    originY: 0,
    root: null,
    pendingScale: 1,
    raf: null
  };
  var smfLandingJumpState = {
    suspendAutoSync: false,
    resumeTimer: null
  };
  var smfPendingDirectRouteSectionId = null;

  function getSmfVisualViewportScale() {
    if (
      window.visualViewport &&
      typeof window.visualViewport.scale === "number" &&
      isFinite(window.visualViewport.scale) &&
      window.visualViewport.scale > 0
    ) {
      return window.visualViewport.scale;
    }

    return 1;
  }

  function isSmfVisualViewportScaled(scale) {
    var nextScale = typeof scale === "number" ? scale : getSmfVisualViewportScale();
    return Math.abs(nextScale - 1) > SMF_PINCH_ZOOM_SCALE_EPSILON;
  }

  function isLandingAutoSyncSuspended() {
    return !!(smfPinchZoomState.suspendAutoSync || smfLandingJumpState.suspendAutoSync);
  }

  function beginLandingRouteJump() {
    if (smfLandingJumpState.resumeTimer) {
      clearTimeout(smfLandingJumpState.resumeTimer);
      smfLandingJumpState.resumeTimer = null;
    }

    smfLandingJumpState.suspendAutoSync = true;
  }

  function finishLandingRouteJump(delay) {
    if (smfLandingJumpState.resumeTimer) {
      clearTimeout(smfLandingJumpState.resumeTimer);
    }

    smfLandingJumpState.resumeTimer = window.setTimeout(function() {
      smfLandingJumpState.resumeTimer = null;
      smfLandingJumpState.suspendAutoSync = false;
      syncLandingRouteStateFromUrl();
    }, typeof delay === "number" ? delay : 220);
  }

  var smfLandingCrossfadeTimers = [];

  function clearLandingCrossfadeTimers() {
    while (smfLandingCrossfadeTimers.length) {
      clearTimeout(smfLandingCrossfadeTimers.pop());
    }
  }

  function resetLandingCrossfadeState() {
    var info = document.getElementById("smf-footer");
    var verse = document.getElementById("smf-daily-verse");

    if (info && info.classList) {
      info.classList.remove("smf-is-leaving");
    }

    if (verse && verse.classList) {
      verse.classList.remove("smf-is-hidden");
      verse.classList.remove("smf-is-arriving");
    }
  }

  /* Crossfade rather than a scroll: scrolling the whole landing page would show
     shop and social hub flying past, which reads as a fast scroll instead of a
     transition. The jump happens while both sections are invisible. */
  function jumpLandingToDailyVerseFromInfo() {
    var wrapper = getLandingScrollWrapper();
    var target = document.getElementById("smf-daily-verse");
    var info = document.getElementById("smf-footer");

    if (!wrapper || !target) return false;

    clearLandingCrossfadeTimers();
    resetLandingCrossfadeState();

    target.classList.add("smf-is-arriving");
    target.classList.add("smf-is-hidden");

    if (info && info.classList) {
      info.classList.add("smf-is-leaving");
    }

    beginLandingRouteJump();

    smfLandingCrossfadeTimers.push(
      window.setTimeout(function() {
        var sequence;
        var targetTop;

        temporarilyDisableLandingScrollSnap(wrapper, SMF_LANDING_SNAP_RESTORE_DURATION);
        sequence = beginLandingScrollCorrection(target);
        targetTop = getLandingSectionScrollTop(wrapper, target);
        finalizeLandingSectionScroll(wrapper, targetTop, target, sequence);
        smfUpdateUrlForSectionId("smf-daily-verse", true);

        if (info && info.classList) {
          info.classList.remove("smf-is-leaving");
        }

        /* Two frames so the hidden state is painted before the transition
           starts, otherwise the browser collapses it into no animation. */
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            target.classList.remove("smf-is-hidden");
          });
        });

        smfLandingCrossfadeTimers.push(
          window.setTimeout(function() {
            target.classList.remove("smf-is-arriving");
          }, SMF_LANDING_INFO_FADE_IN_DURATION + 60)
        );

        finishLandingRouteJump(SMF_LANDING_INFO_FADE_IN_DURATION);
      }, SMF_LANDING_INFO_FADE_OUT_DURATION)
    );

    return true;
  }

  function setLandingViewportRealignPending(isPending) {
    smfLandingScrollCorrectionState.viewportRealignPending = !!isPending;
  }

  function isLandingViewportRealignPending() {
    return !!smfLandingScrollCorrectionState.viewportRealignPending;
  }

  function clearLandingScrollCorrectionTimers() {
    if (smfLandingScrollCorrectionState.delayedTimer) {
      clearTimeout(smfLandingScrollCorrectionState.delayedTimer);
      smfLandingScrollCorrectionState.delayedTimer = null;
    }
  }

  function clearLandingScrollCorrectionFrames() {
    if (smfLandingScrollCorrectionState.finalizeFrame !== null) {
      cancelAnimationFrame(smfLandingScrollCorrectionState.finalizeFrame);
      smfLandingScrollCorrectionState.finalizeFrame = null;
    }

    if (smfLandingScrollCorrectionState.animationFrame !== null) {
      cancelAnimationFrame(smfLandingScrollCorrectionState.animationFrame);
      smfLandingScrollCorrectionState.animationFrame = null;
    }

    if (smfLandingScrollCorrectionState.alignFrame !== null) {
      cancelAnimationFrame(smfLandingScrollCorrectionState.alignFrame);
      smfLandingScrollCorrectionState.alignFrame = null;
    }

    if (smfLandingScrollCorrectionState.viewportFrame !== null) {
      cancelAnimationFrame(smfLandingScrollCorrectionState.viewportFrame);
      smfLandingScrollCorrectionState.viewportFrame = null;
    }
  }

  function clearPendingLandingScrollCorrections() {
    clearLandingScrollCorrectionTimers();
    clearLandingScrollCorrectionFrames();
  }

  function invalidateLandingScrollCorrections() {
    clearPendingLandingScrollCorrections();
    smfLandingScrollCorrectionState.sequence += 1;
    smfLandingScrollCorrectionState.targetId = null;
    setLandingViewportRealignPending(false);
  }

  function clearSmfPinchZoomIdleTimer() {
    if (smfPinchZoomState.idleTimer) {
      clearTimeout(smfPinchZoomState.idleTimer);
      smfPinchZoomState.idleTimer = null;
    }
  }

  function clearSmfPinchZoomFinalFrame() {
    if (smfPinchZoomState.finalFrame !== null) {
      cancelAnimationFrame(smfPinchZoomState.finalFrame);
      smfPinchZoomState.finalFrame = null;
    }
  }

  function getNearestLandingSectionFromCurrentScroll(wrapper) {
    var sections;
    var currentTop;
    var nearestSection = null;
    var nearestDistance = Infinity;

    if (!wrapper) {
      return null;
    }

    sections = Array.prototype.slice.call(document.querySelectorAll(".smf-section"));
    if (!sections.length) {
      return null;
    }

    currentTop = wrapper.scrollTop || 0;

    sections.forEach(function(section) {
      var sectionTop = getLandingSectionScrollTop(wrapper, section);
      var distance = Math.abs(sectionTop - currentTop);

      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestSection = section;
      }
    });

    return nearestSection;
  }

  function beginSmfPinchZoomSession() {
    var wrapper = getLandingScrollWrapper();

    smfPinchZoomState.active = true;
    smfPinchZoomState.suspendAutoSync = true;
    invalidateLandingScrollCorrections();

    if (wrapper) {
      temporarilyDisableLandingScrollSnap(wrapper, 420);
    }
  }

  function finalizeSmfPinchZoomSession() {
    var wrapper = getLandingScrollWrapper();
    var targetSection =
      getNearestLandingSectionFromCurrentScroll(wrapper) ||
      getLandingSectionElementFromLocation();

    smfPinchZoomState.active = false;
    smfPinchZoomState.suspendAutoSync = false;

    if (!wrapper || !targetSection) {
      syncLandingRouteStateFromUrl();
      return;
    }

    temporarilyDisableLandingScrollSnap(
      wrapper,
      targetSection.id === "smf-daily-verse" ? 220 : 520
    );
    scrollLandingSectionIntoView(targetSection, "auto");
  }

  function scheduleSmfPinchZoomFinalSync() {
    clearSmfPinchZoomIdleTimer();
    clearSmfPinchZoomFinalFrame();

    smfPinchZoomState.idleTimer = window.setTimeout(function() {
      smfPinchZoomState.idleTimer = null;
      smfPinchZoomState.finalFrame = requestAnimationFrame(function() {
        smfPinchZoomState.finalFrame = null;
        finalizeSmfPinchZoomSession();
      });
    }, SMF_GESTURE_SETTLE_DELAY);
  }

  function getSmfPinchZoomRoot() {
    var wrapper;
    var section;

    if (
      smfPinchZoomState.root &&
      document.documentElement.contains(smfPinchZoomState.root)
    ) {
      return smfPinchZoomState.root;
    }

    wrapper = getLandingScrollWrapper();
    if (wrapper) {
      section =
        getNearestLandingSectionFromCurrentScroll(wrapper) ||
        getLandingSectionElementFromLocation();
      return section || wrapper;
    }

    return document.body;
  }

  function cancelSmfLivePinchFrame() {
    if (smfPinchZoomState.raf !== null) {
      cancelAnimationFrame(smfPinchZoomState.raf);
      smfPinchZoomState.raf = null;
    }
  }

  function isSmfNativePinchExempt(event) {
    var node = event && event.target;

    if (!node || typeof node.closest !== "function") {
      return false;
    }

    return !!(
      node.closest("zoom-dialog") ||
      node.closest("drag-zoom-wrapper") ||
      node.closest(".dialog-zoomed-gallery")
    );
  }

  function getSmfTouchDistance(touchA, touchB) {
    var dx = touchA.clientX - touchB.clientX;
    var dy = touchA.clientY - touchB.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function clampSmfLivePinchScale(scale) {
    if (scale < SMF_LIVE_PINCH_MIN_SCALE) {
      return SMF_LIVE_PINCH_MIN_SCALE;
    }

    if (scale > SMF_LIVE_PINCH_MAX_SCALE) {
      return SMF_LIVE_PINCH_MAX_SCALE;
    }

    return scale;
  }

  function applySmfLivePinchTransform(scale, originX, originY) {
    var root = getSmfPinchZoomRoot();

    if (!root) {
      return;
    }

    smfPinchZoomState.root = root;
    root.classList.add("smf-pinch-zoom-root");
    root.style.willChange = "transform";
    root.style.transformOrigin = originX + "px " + originY + "px";
    root.style.transform = "translate3d(0,0,0) scale(" + scale + ")";
  }

  function clearSmfLivePinchTransform() {
    var root = smfPinchZoomState.root || getSmfPinchZoomRoot();

    cancelSmfLivePinchFrame();

    if (!root) {
      smfPinchZoomState.root = null;
      return;
    }

    root.classList.remove("smf-pinch-zoom-root");
    root.style.transform = "";
    root.style.transformOrigin = "";
    root.style.willChange = "";
    smfPinchZoomState.root = null;
  }

  function resetNativeVisualViewportZoom() {
    var meta = document.querySelector('meta[name="viewport"]');

    if (!meta) {
      return;
    }

    meta.setAttribute("content", "width=device-width,initial-scale=1,maximum-scale=1");
    requestAnimationFrame(function() {
      meta.setAttribute("content", "width=device-width,initial-scale=1");
    });
  }

  function setSmfLivePinchOriginFromTouches(touchA, touchB) {
    var root = getSmfPinchZoomRoot();
    var midX = (touchA.clientX + touchB.clientX) / 2;
    var midY = (touchA.clientY + touchB.clientY) / 2;
    var rect;

    if (!root) {
      smfPinchZoomState.originX = midX;
      smfPinchZoomState.originY = midY;
      return;
    }

    rect = root.getBoundingClientRect();
    smfPinchZoomState.originX = midX - rect.left;
    smfPinchZoomState.originY = midY - rect.top;
  }

  function beginSmfLivePinchZoom(event) {
    var touchA = event.touches[0];
    var touchB = event.touches[1];

    if (!touchA || !touchB) {
      return;
    }

    cancelSmfLivePinchFrame();
    smfPinchZoomState.live = true;
    smfPinchZoomState.pendingScale = 1;
    smfPinchZoomState.root = getSmfPinchZoomRoot();
    smfPinchZoomState.startDistance = getSmfTouchDistance(touchA, touchB) || 1;
    setSmfLivePinchOriginFromTouches(touchA, touchB);
    document.documentElement.classList.add("smf-is-pinch-zooming");
    beginSmfPinchZoomSession();
    applySmfLivePinchTransform(1, smfPinchZoomState.originX, smfPinchZoomState.originY);
  }

  function updateSmfLivePinchZoom(event) {
    var touchA = event.touches[0];
    var touchB = event.touches[1];

    if (!touchA || !touchB || !smfPinchZoomState.startDistance) {
      return;
    }

    smfPinchZoomState.pendingScale = clampSmfLivePinchScale(
      getSmfTouchDistance(touchA, touchB) / smfPinchZoomState.startDistance
    );

    if (smfPinchZoomState.raf !== null) {
      return;
    }

    smfPinchZoomState.raf = requestAnimationFrame(function() {
      smfPinchZoomState.raf = null;

      if (!smfPinchZoomState.live) {
        return;
      }

      applySmfLivePinchTransform(
        smfPinchZoomState.pendingScale,
        smfPinchZoomState.originX,
        smfPinchZoomState.originY
      );
    });
  }

  function endSmfLivePinchZoom() {
    var wasLive = smfPinchZoomState.live;

    smfPinchZoomState.live = false;
    smfPinchZoomState.startDistance = 0;
    smfPinchZoomState.pendingScale = 1;
    document.documentElement.classList.remove("smf-is-pinch-zooming");
    clearSmfLivePinchTransform();

    if (isSmfVisualViewportScaled()) {
      resetNativeVisualViewportZoom();
    }

    if (!wasLive && !smfPinchZoomState.active) {
      return;
    }

    clearSmfPinchZoomIdleTimer();
    clearSmfPinchZoomFinalFrame();
    smfPinchZoomState.finalFrame = requestAnimationFrame(function() {
      smfPinchZoomState.finalFrame = null;
      finalizeSmfPinchZoomSession();
    });
  }

  function setupSmfTransientPinchZoom() {
    if (window.__smfTransientPinchZoomBound) {
      return;
    }

    window.__smfTransientPinchZoomBound = true;

    document.addEventListener(
      "touchstart",
      function(event) {
        if (!smfIsMobileLayout() || isSmfNativePinchExempt(event)) {
          return;
        }

        if (event.touches && event.touches.length === 2) {
          beginSmfLivePinchZoom(event);
        }
      },
      { capture: true, passive: true }
    );

    document.addEventListener(
      "touchmove",
      function(event) {
        if (!smfIsMobileLayout() || isSmfNativePinchExempt(event)) {
          return;
        }

        if (!event.touches || event.touches.length !== 2) {
          return;
        }

        if (!smfPinchZoomState.live) {
          beginSmfLivePinchZoom(event);
        }

        if (event.cancelable) {
          event.preventDefault();
        }

        updateSmfLivePinchZoom(event);
      },
      { capture: true, passive: false }
    );

    document.addEventListener(
      "touchend",
      function(event) {
        if (!smfPinchZoomState.live && !isSmfVisualViewportScaled()) {
          return;
        }

        if (event.touches && event.touches.length >= 2) {
          return;
        }

        endSmfLivePinchZoom();
      },
      { capture: true, passive: true }
    );

    document.addEventListener(
      "touchcancel",
      function() {
        if (smfPinchZoomState.live || isSmfVisualViewportScaled()) {
          endSmfLivePinchZoom();
        }
      },
      { capture: true, passive: true }
    );
  }

  function setupSmfLandscapeLock() {
    var query;
    var landscapeQuery;
    var coarseQuery;
    var hideTimer = null;
    var hintTimer = null;
    var html = document.documentElement;
    var overlay;
    var prefersReducedMotionQuery;

    if (!window.matchMedia || window.__smfLandscapeLockBound) {
      return;
    }

    window.__smfLandscapeLockBound = true;
    html.classList.add("smf-landscape-lock-js");
    html.style.setProperty(
      "--smf-landscape-fade",
      SMF_LANDSCAPE_FADE_DURATION + "ms"
    );
    overlay = document.querySelector(".smf-landscape-lock");

    query = window.matchMedia(
      "(orientation: landscape) and (max-height: 500px) and (max-width: 950px) and (pointer: coarse)"
    );
    landscapeQuery = window.matchMedia(
      "(orientation: landscape) and (max-width: 950px) and (pointer: coarse)"
    );
    coarseQuery = window.matchMedia("(pointer: coarse)");
    prefersReducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    function clearTimer(timer) {
      if (timer) {
        window.clearTimeout(timer);
      }

      return null;
    }

    function settleDelay() {
      if (prefersReducedMotionQuery.matches) {
        return 0;
      }

      return SMF_LANDSCAPE_LOCK_SETTLE_DELAY;
    }

    function isPhoneLockDevice() {
      var width = window.innerWidth || 0;
      var height = window.innerHeight || 0;
      var shortSide = Math.min(width, height);
      var longSide = Math.max(width, height);

      return (
        coarseQuery.matches &&
        shortSide > 0 &&
        shortSide <= 500 &&
        longSide <= 950
      );
    }

    function isLandscapeAngle() {
      var windowAngle;
      var screenAngle;

      if (typeof window.orientation === "number") {
        windowAngle = Math.abs(window.orientation);
        if (windowAngle === 90) {
          return true;
        }
      }

      if (
        window.screen &&
        window.screen.orientation &&
        typeof window.screen.orientation.angle === "number"
      ) {
        screenAngle = Math.abs(window.screen.orientation.angle);
        if (screenAngle === 90 || screenAngle === 270) {
          return true;
        }
      }

      return landscapeQuery.matches;
    }

    function setHintVisible(visible) {
      hintTimer = clearTimer(hintTimer);

      if (visible) {
        html.classList.add("smf-landscape-hint-active");
        if (overlay) {
          overlay.setAttribute("aria-hidden", "false");
        }
        return;
      }

      html.classList.remove("smf-landscape-hint-active");
      if (overlay) {
        overlay.setAttribute("aria-hidden", "true");
      }
    }

    function showVeil() {
      hideTimer = clearTimer(hideTimer);
      html.classList.add("smf-landscape-lock-instant");
      html.classList.add("smf-landscape-lock-active");
      if (overlay) {
        overlay.offsetWidth;
      }
      requestAnimationFrame(function() {
        html.classList.remove("smf-landscape-lock-instant");
      });
    }

    function hideVeilAfterSettle() {
      hideTimer = clearTimer(hideTimer);
      applySmfViewportCssVars();
      hideTimer = window.setTimeout(function() {
        applySmfViewportCssVars();
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            html.classList.remove("smf-landscape-lock-active");
            hideTimer = null;
            smfUpdateViewportHeight("orientationchange");
          });
        });
      }, settleDelay());
    }

    function showLandscapeHint() {
      showVeil();
      hintTimer = clearTimer(hintTimer);
      applySmfViewportCssVars();
      hintTimer = window.setTimeout(function() {
        applySmfViewportCssVars();
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            hintTimer = null;
            if (query.matches) {
              setHintVisible(true);
            }
          });
        });
      }, settleDelay());
    }

    function beginRotateCover() {
      hideTimer = clearTimer(hideTimer);
      setHintVisible(false);
      showVeil();
    }

    function leaveLandscapeLock() {
      setHintVisible(false);

      if (html.classList.contains("smf-landscape-lock-active")) {
        hideVeilAfterSettle();
        return;
      }

      html.classList.remove("smf-landscape-lock-active");
    }

    function syncLandscapeLock(isLandscapeLock, instant) {
      if (instant) {
        html.classList.add("smf-landscape-lock-instant");
      }

      if (isLandscapeLock) {
        if (instant) {
          showVeil();
          setHintVisible(true);
        } else {
          showLandscapeHint();
        }
      } else {
        leaveLandscapeLock();
      }

      if (instant) {
        requestAnimationFrame(function() {
          html.classList.remove("smf-landscape-lock-instant");
        });
      }
    }

    function shouldCoverLandscape() {
      return (
        isLandscapeAngle() ||
        landscapeQuery.matches ||
        query.matches
      );
    }

    function coverLandscapeRotate() {
      if (
        query.matches &&
        html.classList.contains("smf-landscape-hint-active")
      ) {
        return;
      }

      beginRotateCover();
      if (query.matches) {
        showLandscapeHint();
      }
    }

    function onOrientationSignal() {
      if (!isPhoneLockDevice()) {
        return;
      }

      if (shouldCoverLandscape()) {
        coverLandscapeRotate();
        return;
      }

      leaveLandscapeLock();
    }

    function onEarlyCoverSignal() {
      if (html.classList.contains("smf-is-pinch-zooming")) {
        return;
      }

      if (!isPhoneLockDevice() || !shouldCoverLandscape()) {
        return;
      }

      coverLandscapeRotate();
    }

    function primeLandscapeVeil() {
      if (!overlay) {
        return;
      }

      overlay.style.willChange = "opacity";
      overlay.offsetWidth;
    }

    syncLandscapeLock(query.matches, true);
    primeLandscapeVeil();

    if (typeof query.addEventListener === "function") {
      query.addEventListener("change", function(event) {
        syncLandscapeLock(event.matches, false);
      });
    } else if (typeof query.addListener === "function") {
      query.addListener(function(event) {
        syncLandscapeLock(event.matches, false);
      });
    }

    window.addEventListener("orientationchange", onOrientationSignal);
    window.addEventListener("resize", onEarlyCoverSignal);

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", onEarlyCoverSignal);
    }

    if (
      window.screen &&
      window.screen.orientation &&
      typeof window.screen.orientation.addEventListener === "function"
    ) {
      window.screen.orientation.addEventListener("change", onOrientationSignal);
    }
  }

  function registerSmfPinchZoomActivity(source) {
    var scale = getSmfVisualViewportScale();
    var scaleChanged =
      Math.abs(scale - smfPinchZoomState.lastScale) > SMF_PINCH_ZOOM_SCALE_EPSILON;
    var sourceCanIndicatePinch =
      source === "visualViewport" ||
      source === "visualViewportScroll" ||
      source === "resize" ||
      source === "orientationchange";
    var shouldCapturePinch;

    smfPinchZoomState.lastScale = scale;

    if (smfPinchZoomState.live) {
      return true;
    }

    if (!window.visualViewport || !sourceCanIndicatePinch) {
      return false;
    }

    shouldCapturePinch =
      scaleChanged ||
      isSmfVisualViewportScaled(scale) ||
      smfPinchZoomState.active;

    if (!shouldCapturePinch) {
      return false;
    }

    beginSmfPinchZoomSession();
    scheduleSmfPinchZoomFinalSync();
    return true;
  }

  function beginLandingScrollCorrection(target) {
    clearPendingLandingScrollCorrections();
    smfLandingScrollCorrectionState.sequence += 1;
    smfLandingScrollCorrectionState.targetId =
      target && target.id ? target.id : null;
    return smfLandingScrollCorrectionState.sequence;
  }

  function isLandingScrollCorrectionCurrent(sequence, target) {
    if (sequence !== smfLandingScrollCorrectionState.sequence) {
      return false;
    }

    if (
      target &&
      document.documentElement &&
      !document.documentElement.contains(target)
    ) {
      return false;
    }

    if (
      target &&
      smfLandingScrollCorrectionState.targetId &&
      target.id !== smfLandingScrollCorrectionState.targetId
    ) {
      return false;
    }

    return true;
  }

  function syncLandingSectionStateAfterRealign(target) {
    if (!target || !target.id) return;
    setLandingViewportRealignPending(false);

    if (isLandingAutoSyncSuspended()) {
      return;
    }

    smfUpdateUrlForSectionId(target.id, true);
    if (target.id === smfPendingDirectRouteSectionId) {
      consumeLandingDirectRouteEntryState(target.id);
    }

    maybeCompleteLandingBootSequence(target);
  }

  function shouldBiasLandingSectionTop(target) {
    return !!(target && target.id && target.id !== "smf-daily-verse");
  }

  function clampLandingScrollTop(wrapper, targetTop) {
    var maxScrollTop;

    if (!wrapper) return 0;

    maxScrollTop = Math.max(
      0,
      (wrapper.scrollHeight || 0) - (wrapper.clientHeight || 0)
    );

    return Math.max(0, Math.min(maxScrollTop, targetTop));
  }

  function alignLandingSectionToTop(wrapper, target, attemptsLeft, sequence) {
    var remainingAttempts = typeof attemptsLeft === "number" ? attemptsLeft : 3;
    var wrapperRect;
    var targetRect;
    var delta;
    var adjustment;
    var nextTop;

    if (!wrapper || !target || !isLandingScrollCorrectionCurrent(sequence, target)) {
      return;
    }

    if (remainingAttempts <= 0) {
      syncLandingSectionStateAfterRealign(target);
      return;
    }

    wrapperRect = wrapper.getBoundingClientRect();
    targetRect = target.getBoundingClientRect();
    delta = targetRect.top - wrapperRect.top;

    if (delta <= 0 && Math.abs(delta) < 0.35) {
      syncLandingSectionStateAfterRealign(target);
      return;
    }

    if (delta > 0 && delta < 1) {
      adjustment = 1;
    } else {
      adjustment = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
    }

    if (!adjustment) {
      adjustment = delta > 0 ? 1 : -1;
    }

    nextTop = clampLandingScrollTop(wrapper, (wrapper.scrollTop || 0) + adjustment);

    if (nextTop === (wrapper.scrollTop || 0)) {
      syncLandingSectionStateAfterRealign(target);
      return;
    }

    wrapper.scrollTop = nextTop;

    smfLandingScrollCorrectionState.alignFrame = requestAnimationFrame(function() {
      smfLandingScrollCorrectionState.alignFrame = null;

      if (!isLandingScrollCorrectionCurrent(sequence, target)) {
        return;
      }

      alignLandingSectionToTop(wrapper, target, remainingAttempts - 1, sequence);
    });
  }

  function finalizeLandingSectionScroll(wrapper, targetTop, target, sequence) {
    var nextTop;

    if (!wrapper || !target || !isLandingScrollCorrectionCurrent(sequence, target)) {
      return;
    }

    nextTop = clampLandingScrollTop(
      wrapper,
      Math.ceil(targetTop) + (shouldBiasLandingSectionTop(target) ? 1 : 0)
    );
    wrapper.scrollTop = nextTop;

    smfLandingScrollCorrectionState.finalizeFrame = requestAnimationFrame(function() {
      smfLandingScrollCorrectionState.finalizeFrame = null;

      if (!isLandingScrollCorrectionCurrent(sequence, target)) {
        return;
      }

      wrapper.scrollTop = nextTop;
      alignLandingSectionToTop(wrapper, target, 4, sequence);
    });

    smfLandingScrollCorrectionState.delayedTimer = window.setTimeout(function() {
      smfLandingScrollCorrectionState.delayedTimer = null;

      if (!isLandingScrollCorrectionCurrent(sequence, target)) {
        return;
      }

      wrapper.scrollTop = nextTop;
      alignLandingSectionToTop(wrapper, target, 3, sequence);
    }, SMF_LANDING_SCROLL_CORRECTION_DELAY);
  }

  function easeLandingPageTransition(progress) {
    var t = Math.max(0, Math.min(1, progress));

    return 1 - Math.pow(1 - t, 3);
  }

  function animateLandingSectionScroll(wrapper, targetTop, target, sequence, duration) {
    var startTop;
    var distance;
    var startTime = null;
    var animationDuration = typeof duration === "number"
      ? duration
      : SMF_LANDING_PAGE_TRANSITION_DURATION;

    if (!wrapper || !target || !isLandingScrollCorrectionCurrent(sequence, target)) {
      return false;
    }

    startTop = wrapper.scrollTop || 0;
    distance = targetTop - startTop;

    if (Math.abs(distance) < 1) {
      finalizeLandingSectionScroll(wrapper, targetTop, target, sequence);
      return true;
    }

    function step(timestamp) {
      var elapsed;
      var progress;
      var easedProgress;

      if (!isLandingScrollCorrectionCurrent(sequence, target)) {
        smfLandingScrollCorrectionState.animationFrame = null;
        return;
      }

      if (startTime === null) {
        startTime = timestamp;
      }

      elapsed = timestamp - startTime;
      progress = animationDuration > 0 ? elapsed / animationDuration : 1;
      easedProgress = easeLandingPageTransition(progress);

      wrapper.scrollTop = clampLandingScrollTop(
        wrapper,
        startTop + (distance * easedProgress)
      );

      if (progress < 1) {
        smfLandingScrollCorrectionState.animationFrame = requestAnimationFrame(step);
        return;
      }

      smfLandingScrollCorrectionState.animationFrame = null;
      finalizeLandingSectionScroll(wrapper, targetTop, target, sequence);
    }

    smfLandingScrollCorrectionState.animationFrame = requestAnimationFrame(step);
    return true;
  }

  function scrollLandingSectionIntoView(target, behavior, duration) {
    var wrapper = getLandingScrollWrapper();
    var targetTop;
    var correctionSequence;
    var animationDuration =
      typeof duration === "number" ? duration : SMF_LANDING_PAGE_TRANSITION_DURATION;

    if (!target || !wrapper) return false;
    if (behavior !== "smooth" && isLandingAutoSyncSuspended()) return false;

    correctionSequence = beginLandingScrollCorrection(target);
    targetTop = getLandingSectionScrollTop(wrapper, target);

    if (behavior === "smooth") {
      /* Mandatory snap re-snaps after every programmatic scrollTop write, which
         pulls the animation onto the target within the first frames and reads as
         a hard jump. It stays off until the scroll has settled. */
      temporarilyDisableLandingScrollSnap(
        wrapper,
        animationDuration + SMF_LANDING_SNAP_RESTORE_DURATION
      );

      return animateLandingSectionScroll(
        wrapper,
        targetTop,
        target,
        correctionSequence,
        animationDuration
      );
    }

    finalizeLandingSectionScroll(wrapper, targetTop, target, correctionSequence);

    return true;
  }

  function setupLandingScrollSnapNormalizer() {
    var wrapper = getLandingScrollWrapper();
    var sections = Array.prototype.slice.call(document.querySelectorAll(".smf-section"));
    var settleTimer = null;
    var correctionThreshold = 6;

    if (!wrapper || sections.length < 2) return;

    function normalizeToNearestSection() {
      var currentTop = wrapper.scrollTop || 0;
      var nearestSection = null;
      var nearestTop = 0;
      var nearestDistance = Infinity;

      settleTimer = null;
      if (
        isLandingAutoSyncSuspended() ||
        isLandingViewportRealignPending() ||
        isLandingBootSequenceActive()
      ) {
        return;
      }

      sections.forEach(function(section) {
        var sectionTop = getLandingSectionScrollTop(wrapper, section);
        var distance = Math.abs(sectionTop - currentTop);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestSection = section;
          nearestTop = sectionTop;
        }
      });

      if (!nearestSection) return;
      if (nearestDistance < 0.5 || nearestDistance > correctionThreshold) return;

      scrollLandingSectionIntoView(nearestSection, "auto");
    }

    function scheduleNormalization() {
      if (
        isLandingAutoSyncSuspended() ||
        isLandingViewportRealignPending() ||
        isLandingBootSequenceActive()
      ) {
        if (settleTimer) {
          clearTimeout(settleTimer);
          settleTimer = null;
        }
        return;
      }

      if (settleTimer) {
        clearTimeout(settleTimer);
      }

      settleTimer = window.setTimeout(normalizeToNearestSection, SMF_LANDING_SECTION_SETTLE_DELAY);
    }

    window.addEventListener("resize", scheduleNormalization);
  }

  function buildFaithBibleUrl(lang) {
    var safeLang = sanitizeVerseLang(lang) || "en";

    return faithBibleUrlByLang[safeLang] || faithBibleUrlByLang.en;
  }

  function buildLandingShareUrl(lang) {
    var safeLang = supportedLanguages.indexOf(lang) !== -1 ? lang : "de";
    var origin =
      window.location.origin ||
      (window.location.protocol + "//" + window.location.host);

    return (
      origin +
      buildLocalizedPath("/", getShopLangForUiLang(safeLang))
    );
  }

  function consumeSocialEntrySource() {
    var source = null;

    try {
      source = sessionStorage.getItem(smfEntryStorageKeys.socialEntry);
      if (source) {
        sessionStorage.removeItem(smfEntryStorageKeys.socialEntry);
      }
    } catch (error) {
      source = null;
    }

    return source;
  }

  function updateFaithActionLinks(lang) {
    var verseEntryLinks = document.querySelectorAll("[data-smf-verse-faith-cta]");
    var faithPills = document.querySelectorAll("[data-smf-faith-pill]");
    var faithUrl = buildFaithBibleUrl(lang);

    for (var i = 0; i < verseEntryLinks.length; i++) {
      verseEntryLinks[i].setAttribute("href", faithUrl);
    }

    for (var j = 0; j < faithPills.length; j++) {
      faithPills[j].setAttribute("href", faithUrl);
    }
  }

  function isShopLocaleAwarePath(path) {
    var normalizedPath = stripLocalePrefix(path);

    return (
      normalizedPath === "/" ||
      normalizedPath === "/shop" ||
      normalizedPath === "/social" ||
      normalizedPath === "/sameskycollective" ||
      normalizedPath === "/samesky" ||
      normalizedPath === "/info" ||
      normalizedPath === "/protected" ||
      normalizedPath.startsWith("/products/") ||
      normalizedPath.startsWith("/collections/") ||
      normalizedPath === "/cart" ||
      normalizedPath.startsWith("/cart?")
    );
  }

  function stripLandingBootstrapSearch(search) {
    var params;
    var rest;

    try {
      params = new URLSearchParams(typeof search === "string" ? search : "");
      params.delete("page");
      rest = params.toString();
      return rest ? "?" + rest : "";
    } catch (error) {
      return "";
    }
  }

  function redirectToShopLanguage(shopLang) {
    var currentPath = normalizePath(window.location.pathname || "/");
    var parsed;
    var targetPath;
    var cleanSearch;
    var targetUrl;
    var currentUrl;

    if (!isShopLocaleAwarePath(currentPath)) return false;

    parsed = parseLandingVirtualLocation(currentPath, window.location.search || "");
    targetPath = parsed.routeSlug
      ? buildLocalizedPath(getVirtualRouteByKey(parsed.routeSlug).path, shopLang)
      : buildLocalizedPath(currentPath, shopLang);

    cleanSearch = stripLandingBootstrapSearch(window.location.search || "");
    targetUrl = targetPath + cleanSearch + (window.location.hash || "");
    currentUrl =
      (parsed.routeSlug ? parsed.canonicalPath : currentPath) +
      cleanSearch +
      (window.location.hash || "");

    if (targetUrl === currentUrl) return false;

    window.location.assign(targetUrl);
    return true;
  }

  function formatDescriptiveText(text) {
    var formatted = String(text || "").replace(/\r\n?/g, "\n");

    formatted = formatted.replace(/\u2060/g, "");
    formatted = formatted.replace(/\u00A0(\u2014|-)/g, " $1");
    formatted = formatted.replace(/\.[ \t]+(?=\S)/g, "\u2060.\n");
    formatted = formatted.replace(/[ \t]+(\u2014|-)[ \t]+(?=\S)/g, "\u00A0$1\n");
    formatted = formatted.replace(/[ \t]+\n/g, "\n");
    formatted = formatted.replace(/\n{3,}/g, "\n\n");

    return formatted.trim();
  }

  function refreshDescriptiveCopyFormatting() {
    var sublineNodes = document.querySelectorAll("#smf-artist .smf-artist-subline[data-i18n]");
    var i;

    for (i = 0; i < sublineNodes.length; i++) {
      sublineNodes[i].textContent = formatDescriptiveText(sublineNodes[i].textContent || "");
    }
  }

  function getVerseReferenceLabelElement() {
    return document.querySelector("[data-smf-verse-ref-label]");
  }

  function setVerseReferenceText(text) {
    var labelEl = getVerseReferenceLabelElement();
    var verseRefEl = document.getElementById("smf-verse-ref");
    var safeText = text || "";

    if (labelEl) {
      labelEl.textContent = safeText;
      return;
    }

    if (verseRefEl) {
      verseRefEl.textContent = safeText;
    }
  }

  function getVerseReferenceText() {
    var labelEl = getVerseReferenceLabelElement();
    var verseRefEl = document.getElementById("smf-verse-ref");

    if (labelEl) {
      return (labelEl.textContent || "").trim();
    }

    return verseRefEl ? (verseRefEl.textContent || "").trim() : "";
  }

  function stripVerseCardReferencePrefix(text) {
    var cleaned = String(text || "").trim();

    cleaned = cleaned.replace(/^—\s*/, "");
    cleaned = cleaned.replace(
      /^\s*(Basierend auf|Based on|Gebaseerd op|Bas\u00e9 sur|Basado en|\u041e\u0441\u043d\u043e\u0432\u0430\u043d\u043e \u043d\u0430)\s+/i,
      ""
    );

    return stripVerseReferenceLead(cleaned);
  }

  function stripVerseReferenceLead(text) {
    return String(text || "")
      .replace(/^\s*(lies|read|lees|lis|lee|читай)\s+/i, "")
      .trim();
  }

  function getLandingTextLangForKey(key, languageState) {
    var landingKeys = {
      verseKicker: true,
      verseOverlayTitle: true,
      verseOverlayCta: true
    };

    if (landingKeys[key]) {
      return languageState.verseLang;
    }

    return languageState.uiLang;
  }

  function resolveUiI18n(key) {
    var entry = i18n[key];
    var uiLang = window.smfCurrentLang === "de" ? "de" : "en";

    if (!entry) {
      return "";
    }

    return entry[uiLang] || entry.en || entry.de || "";
  }

  function getVerseReferenceIntro(lang) {
    switch (lang) {
      case "de":
        return "Basierend auf";
      case "nl":
        return "Gebaseerd op";
      case "fr":
        return "Bas\u00e9 sur";
      case "es":
        return "Basado en";
      case "ru":
        return "\u041e\u0441\u043d\u043e\u0432\u0430\u043d\u043e \u043d\u0430";
      default:
        return "Based on";
    }
  }

  function formatVerseReferenceLabel(text, verseLang) {
    var intro = getVerseReferenceIntro(verseLang);
    var reference = stripVerseReferenceLead(text);

    return reference ? intro + " " + reference : intro;
  }

  function applyLanguage(lang, options) {
    var languageState;
    var langUpper;
    var flagSrc;

    var flagEl = document.getElementById("smf-lang-flag");
    var codeEl = document.getElementById("smf-lang-code");
    var flagShop = document.getElementById("smf-lang-flag-shop");
    var codeShop = document.getElementById("smf-lang-code-shop");
    var flagArtist = document.getElementById("smf-lang-flag-artist");
    var codeArtist = document.getElementById("smf-lang-code-artist");
    var uiLang;

    options = options || {};

    if (supportedLanguages.indexOf(lang) === -1) {
      lang = "de";
    }

    languageState = buildLanguageState(lang, options.shopLang, options.source);
    if (options.persist !== false) {
      languageState = persistLanguageState(languageState, options.source || languageState.source || "sync");
    }

    window.smfCurrentLang = languageState.verseLang;
    window.smfCurrentShopLang = languageState.shopLang;

    langUpper = languageState.verseLang.toUpperCase();
    flagSrc = flagByLang[languageState.verseLang];

    if (flagEl && flagSrc) {
      flagEl.src = flagSrc;
      flagEl.alt = langUpper;
    }
    if (flagShop && flagSrc) {
      flagShop.src = flagSrc;
      flagShop.alt = langUpper;
    }
    if (flagArtist && flagSrc) {
      flagArtist.src = flagSrc;
      flagArtist.alt = langUpper;
    }

    if (codeEl) codeEl.textContent = langUpper;
    if (codeShop) codeShop.textContent = langUpper;
    if (codeArtist) codeArtist.textContent = langUpper;

    // UI:
    // - wenn lang === "de" -> deutsche UI
    // - sonst -> englische UI
    uiLang = languageState.uiLang;

	    var nodes = document.querySelectorAll("[data-i18n]");
	    for (var i = 0; i < nodes.length; i++) {
	      var el = nodes[i];
	      var key = el.getAttribute("data-i18n");
	      var entry = i18n[key];
	      var contentLang = getLandingTextLangForKey(key, languageState);
	      if (entry) {
	        var text = entry[contentLang] || entry[uiLang] || entry.en || entry.de;
	        if (text) {
	          el.textContent = text;
	        }
	      }
	    }

    var ariaNodes = document.querySelectorAll("[data-i18n-aria-label]");
    for (var a = 0; a < ariaNodes.length; a++) {
      var ariaEl = ariaNodes[a];
      var ariaKey = ariaEl.getAttribute("data-i18n-aria-label");
      var ariaEntry = i18n[ariaKey];
      var ariaText;

      if (!ariaEntry) {
        continue;
      }

      ariaText = ariaEntry[uiLang] || ariaEntry.en || ariaEntry.de || "";
      if (ariaText) {
        ariaEl.setAttribute("aria-label", ariaText);
      }
    }

    var htmlNodes = document.querySelectorAll("[data-i18n-html]");
    for (var j = 0; j < htmlNodes.length; j++) {
      var htmlEl = htmlNodes[j];
      var htmlKey = htmlEl.getAttribute("data-i18n-html");
      var htmlEntry = i18nHtml[htmlKey];
      var html = "";

      if (!htmlEntry) continue;

      if (typeof htmlEntry === "function") {
        html = htmlEntry(uiLang, languageState.verseLang);
      } else {
        html = htmlEntry[uiLang] || htmlEntry.en || htmlEntry.de || "";
      }

      htmlEl.innerHTML = html;
    }

    refreshDescriptiveCopyFormatting();

    // Vers wird in der ausgewählten Sprache gerendert
    var pool = verses[languageState.verseLang] || verses.en;
    var day = getDayOfYear();
    var index = (day - 1) % pool.length;
    var verseObj = pool[index];

    var verseTextEl = document.getElementById("smf-verse-text");
    var verseRefEl = document.getElementById("smf-verse-ref");

    if (verseTextEl && verseObj) verseTextEl.textContent = verseObj.text;
    if (verseRefEl && verseObj) {
      setVerseReferenceText(
        formatVerseReferenceLabel(verseObj.ref, languageState.verseLang)
      );
    }
    updateFaithActionLinks(languageState.verseLang);

    var yearEl = document.getElementById("smf-year");
    if (yearEl) yearEl.textContent = new Date().getFullYear();

    if (document.documentElement) {
      document.documentElement.lang = languageState.shopLang;
      document.documentElement.setAttribute("data-smf-verse-lang", languageState.verseLang);
    }
  }

  function smfFindClosest(element, selector) {
    while (element && element.nodeType === 1) {
      if (element.matches && element.matches(selector)) return element;
      element = element.parentElement;
    }
    return null;
  }

  function smfHasReducedMotionPreference() {
    return !!(
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function smfClearDrawerInlineMetrics(drawer) {
    drawer.style.top = "";
    drawer.style.right = "";
    drawer.style.width = "";
    drawer.style.height = "";
    drawer.style.borderRadius = "";
  }

  function smfSetHeaderControlsMorphState(controls, kind, isActive) {
    if (!controls) return;

    if (!isActive) {
      controls.classList.remove("is-drawer-morphing");
      controls.removeAttribute("data-smf-morph-active");
      return;
    }

    controls.classList.add("is-drawer-morphing");
    controls.setAttribute("data-smf-morph-active", kind);
  }

  function smfClearDrawerTimers(drawer) {
    var state = drawer && drawer._smfMorphState;

    if (!state) return;

    if (state.finishTimer) {
      window.clearTimeout(state.finishTimer);
      state.finishTimer = null;
    }
  }

  function smfCancelDrawerAnimation(drawer) {
    var state = drawer && drawer._smfMorphState;

    if (!state || !state.animation) return;

    state.animation.onfinish = null;
    state.animation.cancel();
    state.animation = null;
  }

  function smfCloseDrawerInstant(drawer) {
    var state = drawer && drawer._smfMorphState;

    if (!drawer) return;

    smfClearDrawerTimers(drawer);
    smfCancelDrawerAnimation(drawer);

    if (state && state.controls) {
      smfSetHeaderControlsMorphState(state.controls, state.kind, false);
    }

    drawer.classList.remove(
      "is-active",
      "is-morphing",
      "is-closing",
      "is-content-visible"
    );
    drawer.setAttribute("aria-hidden", "true");
    smfClearDrawerInlineMetrics(drawer);
    drawer._smfMorphState = null;
  }

  function smfOpenDrawerWithMorph(drawer, trigger, kind, onOpened) {
    var controls;
    var state;

    if (!drawer || !trigger) return;

    controls = smfFindClosest(trigger, ".smf-header-controls");

    smfCloseDrawerInstant(drawer);

    state = {
      kind: kind,
      trigger: trigger,
      controls: controls,
      animation: null,
      finishTimer: null
    };

    drawer._smfMorphState = state;
    drawer.classList.remove("is-closing", "is-content-visible");
    drawer.classList.remove("is-morphing");
    drawer.setAttribute("aria-hidden", "false");

    if (smfHasReducedMotionPreference()) {
      drawer.classList.add("is-active", "is-content-visible");
      smfSetHeaderControlsMorphState(controls, kind, false);
      if (typeof onOpened === "function") onOpened();
      return;
    }

    drawer.getBoundingClientRect();
    smfSetHeaderControlsMorphState(controls, kind, true);
    drawer.classList.add("is-active", "is-content-visible");

    state.finishTimer = window.setTimeout(function() {
      if (drawer._smfMorphState !== state) return;

      state.finishTimer = null;
      smfSetHeaderControlsMorphState(controls, kind, false);

      if (typeof onOpened === "function") onOpened();
    }, SMF_DRAWER_MORPH_DURATION);
  }

  function smfCloseDrawerWithMorph(drawer) {
    var state = drawer && drawer._smfMorphState;

    if (!drawer || !drawer.classList.contains("is-active")) return;

    if (
      !state ||
      !state.trigger ||
      !(state.trigger.isConnected || document.documentElement.contains(state.trigger))
    ) {
      smfCloseDrawerInstant(drawer);
      return;
    }

    smfClearDrawerTimers(drawer);
    smfCancelDrawerAnimation(drawer);
    smfSetHeaderControlsMorphState(state.controls, state.kind, false);

    if (smfHasReducedMotionPreference()) {
      smfCloseDrawerInstant(drawer);
      return;
    }

    drawer.classList.remove("is-active", "is-morphing");
    drawer.classList.add("is-closing");
    drawer.setAttribute("aria-hidden", "true");

    state.finishTimer = window.setTimeout(function() {
      if (drawer._smfMorphState !== state) return;

      smfCloseDrawerInstant(drawer);
    }, SMF_DRAWER_MORPH_DURATION + SMF_DRAWER_CLOSE_BUFFER);
  }

  function isSmfEscapeKey(event) {
    return !!(event && (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27));
  }

  var smfOverlayDismissLayers = [];
  var smfOverlayDismissBound = false;

  function registerSmfOverlayDismissLayer(layer) {
    var i;

    if (!layer || typeof layer.isOpen !== "function" || typeof layer.close !== "function") {
      return;
    }

    smfOverlayDismissLayers.push(layer);
    smfOverlayDismissLayers.sort(function(a, b) {
      return (b.priority || 0) - (a.priority || 0);
    });

    if (smfOverlayDismissBound) {
      return;
    }

    smfOverlayDismissBound = true;

    document.addEventListener("keydown", function(event) {
      if (!isSmfEscapeKey(event)) {
        return;
      }

      for (i = 0; i < smfOverlayDismissLayers.length; i++) {
        if (smfOverlayDismissLayers[i].isOpen()) {
          smfOverlayDismissLayers[i].close("morph");
          event.preventDefault();
          return;
        }
      }
    });

    document.addEventListener("click", function(event) {
      for (i = 0; i < smfOverlayDismissLayers.length; i++) {
        var activeLayer = smfOverlayDismissLayers[i];

        if (!activeLayer.isOpen()) {
          continue;
        }

        if (
          typeof activeLayer.shouldIgnoreOutsideClick === "function" &&
          activeLayer.shouldIgnoreOutsideClick(event)
        ) {
          return;
        }

        activeLayer.close("morph");
        return;
      }
    });
  }

  function setupLanguageMenu() {
    var langMenu = document.getElementById("smf-lang-menu");
    if (!langMenu) return;

    var langButtons = document.querySelectorAll(".smf-lang-toggle");
    var options = langMenu.querySelectorAll(".smf-lang-option");

    function openMenu(trigger) {
      // NAV-Menü schließen, falls offen
      var navMenu = document.getElementById("smf-nav-menu");
      if (navMenu && navMenu.classList.contains("is-active")) {
        smfCloseDrawerInstant(navMenu);
      }

      smfOpenDrawerWithMorph(langMenu, trigger, "lang");
      setLangToggleExpanded(true);
    }

    function closeMenu(mode) {
      if (mode === "instant") {
        smfCloseDrawerInstant(langMenu);
      } else {
        smfCloseDrawerWithMorph(langMenu);
      }
      setLangToggleExpanded(false);
    }

    function setLangToggleExpanded(isExpanded) {
      for (var i = 0; i < langButtons.length; i++) {
        langButtons[i].setAttribute(
          "aria-expanded",
          isExpanded ? "true" : "false"
        );
      }
    }

    // Alle Language-Toggles öffnen/schließen das Menü
    for (var i = 0; i < langButtons.length; i++) {
      langButtons[i].addEventListener("click", function(e) {
        e.stopPropagation();
        if (langMenu.classList.contains("is-active")) {
          closeMenu("morph");
        } else {
          openMenu(this);
        }
      });
    }

    // Klick auf Sprachoption: Sprache setzen + Menü schließen
    for (var j = 0; j < options.length; j++) {
      (function(btn) {
        var lang = btn.getAttribute("data-lang");
        btn.addEventListener("click", function(e) {
          e.stopPropagation();
          closeMenu("instant");
          switchLandingLanguage(lang, "manual");
        });
      })(options[j]);
    }

    registerSmfOverlayDismissLayer({
      priority: 20,
      isOpen: function() {
        return langMenu.classList.contains("is-active");
      },
      close: function(mode) {
        closeMenu(mode || "morph");
      },
      shouldIgnoreOutsideClick: function(event) {
        return (
          langMenu.contains(event.target) ||
          !!(
            event.target &&
            event.target.closest &&
            event.target.closest(".smf-lang-toggle")
          )
        );
      }
    });

    // Scrollen schließt das Sprachmenü
  var langScrollRoot = document.querySelector(".smf-wrapper") || window;

  langScrollRoot.addEventListener(
    "scroll",
    function () {
      if (langMenu.classList.contains("is-active")) {
        closeMenu("instant");
      }
    },
    { passive: true }
  );
}





   // ===========================================
  // UI-HINT für Sprachen ≠ DE/EN
  // ===========================================
  function getUiHintPopup() {
    return document.getElementById("smf-ui-hint");
  }

  function getUiHintMessageElement() {
    var hint = getUiHintPopup();
    return hint ? hint.querySelector("[data-smf-ui-hint-message]") : null;
  }

  function isUiHintOpen() {
    var hint = getUiHintPopup();

    return !!(
      hint &&
      (hint.classList.contains("is-open") ||
        hint.getAttribute("aria-hidden") === "false")
    );
  }

  function showUiHint() {
    var hint = getUiHintPopup();

    if (!hint) return;

    if (typeof window.smfOpenPopupById === "function") {
      window.smfOpenPopupById("ui-language-hint");
      return;
    }

    hint.classList.add("is-open");
    hint.setAttribute("aria-hidden", "false");
  }

  function hideUiHint() {
    var hint = getUiHintPopup();
    if (!hint) return;

    if (typeof window.smfClosePopupById === "function") {
      window.smfClosePopupById("ui-language-hint");
      return;
    }

    hint.classList.remove("is-open");
    hint.setAttribute("aria-hidden", "true");
  }

  function presentLanguageHint(langCode) {
    var hintMessage = getUiHintMessageElement();
    var safeLangCode = sanitizeVerseLang(langCode);

    if (!hintMessage || !shouldShowLanguageHint(safeLangCode)) return false;

    hintMessage.textContent = resolveUiHintText(safeLangCode);
    showUiHint();
    return true;
  }

  function showLanguageHintIfPending() {
    var pending;

    if (!getUiHintMessageElement()) return false;

    pending = readLanguageHintPending(false);

    if (
      !pending ||
      pending.to !== sanitizeVerseLang(window.smfCurrentLang) ||
      !shouldShowLanguageHint(pending.to)
    ) {
      return false;
    }

    consumeLanguageHintPending();
    presentLanguageHint(pending.to);
    return true;
  }

  function isLandingHeroRouteActive() {
    var sectionId;

    if (!document.querySelector(".smf-wrapper")) {
      return false;
    }

    sectionId = getLandingSectionIdFromLocation(
      window.location.pathname || "/",
      window.location.search || ""
    );

    return !sectionId || sectionId === "smf-daily-verse";
  }

  function revealLanguageHintAfterLeavingHero() {
    if (isLandingHeroRouteActive()) {
      return false;
    }

    return showLanguageHintIfPending();
  }

  function switchLandingLanguage(lang, source) {
    var fromLang = sanitizeVerseLang(window.smfCurrentLang || getInitialLanguage());
    var nextState = persistLanguageState(lang, source || "manual");
    var languageChanged = fromLang !== nextState.verseLang;
    var didRedirect;

    if (languageChanged) {
      persistLanguageHintPending(fromLang, nextState.verseLang);
    }

    didRedirect = redirectToShopLanguage(nextState.shopLang);

    if (didRedirect) {
      return nextState;
    }

    window.smfCurrentLang = nextState.verseLang;
    applyLanguage(nextState.verseLang, {
      shopLang: nextState.shopLang,
      persist: false,
      source: nextState.source
    });

    if (!languageChanged || !shouldShowLanguageHint(nextState.verseLang)) {
      consumeLanguageHintPending();
      hideUiHint();
    }

    return nextState;
  }



  /* ===========================================
     SCROLL-INDICATORS
  ============================================ */
function setupScrollIndicators() {
  var buttons = document.querySelectorAll(".smf-scroll-indicator");

  for (var i = 0; i < buttons.length; i++) {
    (function (btn) {
      var nextUrl = btn.getAttribute("data-next-url");
      var targetSelector = btn.getAttribute("data-scroll-target");

      // 1) Neuer Modus: auf andere Seite springen
      if (nextUrl) {
        btn.addEventListener("click", function () {
          window.location.href = nextUrl;
        });
        return;
      }

      // 2) Fallback: innerhalb derselben Seite scrollen
      if (targetSelector) {
        var target = document.querySelector(targetSelector);
        if (!target) return;

	        btn.addEventListener("click", function () {
	  if (btn.classList.contains("smf-scroll-footer")) {
	    jumpLandingToDailyVerseFromInfo();
	    return;
	  }

	  scrollLandingSectionIntoView(target, "smooth");
	});

	      }
	    })(buttons[i]);
	  }
}

  /* Notch nutzt denselben Pfad wie die übrigen .smf-scroll-indicator-Buttons. */
  function scrollShopWindowNotchTarget() {
    var nextSection = document.getElementById("smf-artist");

    if (!nextSection) {
      return;
    }

    scrollLandingSectionIntoView(nextSection, "smooth");
  }

  function setupShopWindowNotch() {
    var notch = document.querySelector("[data-smf-shop-window-notch]");

    if (!notch) {
      return;
    }

    notch.addEventListener("click", function(event) {
      event.preventDefault();
      scrollShopWindowNotchTarget();
    });
  }

  /* ===========================================
     NAVIGATION-OVERLAY
  ============================================ */
  function setupNavigationMenu() {
    var menu = document.getElementById("smf-nav-menu");
    if (!menu) return;

    var openButtons = document.querySelectorAll(".smf-login-button");
    var closeButton = menu.querySelector(".smf-nav-close");
    var items = menu.querySelectorAll(".smf-nav-item");

    function openMenu(trigger) {
      // Language-Menü schließen, falls offen
      var langMenu = document.getElementById("smf-lang-menu");
      if (langMenu && langMenu.classList.contains("is-active")) {
        smfCloseDrawerInstant(langMenu);
      }

      smfOpenDrawerWithMorph(menu, trigger, "nav");
    }

    function closeMenu(mode) {
      if (mode === "instant") {
        smfCloseDrawerInstant(menu);
      } else {
        smfCloseDrawerWithMorph(menu);
      }
    }

    // Alle Login-Buttons toggeln das Overlay
    for (var i = 0; i < openButtons.length; i++) {
      openButtons[i].addEventListener("click", function(e) {
        e.stopPropagation();
        if (menu.classList.contains("is-active")) {
          closeMenu("morph");
        } else {
          openMenu(this);
        }
      });
    }

    // X-Button schließt das Menü
    if (closeButton) {
      closeButton.addEventListener("click", function(e) {
        e.stopPropagation();
        closeMenu("morph");
      });
    }

    // Klick auf Menü-Item: scrollt zur Section + setzt URL + schließt Menü
    for (var j = 0; j < items.length; j++) {
      (function (btn) {
        var targetSelector = btn.getAttribute("data-scroll-target");
        if (!targetSelector) return;
        var target = document.querySelector(targetSelector);
        if (!target) return;

	        btn.addEventListener("click", function (event) {
	          event.preventDefault();
	          closeMenu("instant");
	          scrollLandingSectionIntoView(target, "smooth");

	          // URL anpassen (z.B. /shop, /social, /info)
	          var id = target.getAttribute("id");
	          if (id) {
	            smfUpdateUrlForSectionId(id, false);
          }
        });
      })(items[j]);
    }

    registerSmfOverlayDismissLayer({
      priority: 30,
      isOpen: function() {
        return menu.classList.contains("is-active");
      },
      close: function(mode) {
        closeMenu(mode || "morph");
      },
      shouldIgnoreOutsideClick: function(event) {
        return (
          menu.contains(event.target) ||
          !!(
            event.target &&
            event.target.closest &&
            event.target.closest(".smf-login-button")
          )
        );
      }
    });

  // Scrollen schließt das NAV-Menü
  var navScrollRoot = document.querySelector(".smf-wrapper") || window;

  navScrollRoot.addEventListener(
    "scroll",
    function () {
      if (menu.classList.contains("is-active")) {
        closeMenu("instant");
      }
    },
    { passive: true }
  );
}
   /* ===========================================
     URL-SYNC BEIM SCROLLEN (robust, auch mit Zoom)
  ============================================ */
  function getLandingScrollRootViewportBounds(scrollRoot) {
    var rect;

    if (scrollRoot === window) {
      return {
        top: 0,
        bottom: window.innerHeight || document.documentElement.clientHeight || 0
      };
    }

    if (!scrollRoot || !scrollRoot.getBoundingClientRect) {
      return null;
    }

    rect = scrollRoot.getBoundingClientRect();

    return {
      top: rect.top,
      bottom: rect.bottom
    };
  }

  function getLandingSectionViewportMetrics(scrollRoot, section) {
    var viewportBounds = getLandingScrollRootViewportBounds(scrollRoot);
    var rect;
    var viewportHeight;
    var viewportCenter;
    var sectionCenter;
    var visibleTop;
    var visibleBottom;
    var visiblePx;

    if (!viewportBounds || !section || !section.getBoundingClientRect) {
      return null;
    }

    rect = section.getBoundingClientRect();
    viewportHeight = Math.max(1, viewportBounds.bottom - viewportBounds.top);
    viewportCenter = viewportBounds.top + (viewportHeight / 2);
    sectionCenter = rect.top + (rect.height / 2);
    visibleTop = Math.max(rect.top, viewportBounds.top);
    visibleBottom = Math.min(rect.bottom, viewportBounds.bottom);
    visiblePx = Math.max(0, visibleBottom - visibleTop);

    return {
      section: section,
      viewportHeight: viewportHeight,
      visiblePx: visiblePx,
      visibleRatio: visiblePx / viewportHeight,
      centerDistance: Math.abs(sectionCenter - viewportCenter),
      topDistance: Math.abs(rect.top - viewportBounds.top)
    };
  }

  function shouldKeepCurrentLandingSection(currentMetrics, candidateMetrics) {
    var viewportHeight;

    if (!currentMetrics || !candidateMetrics) {
      return false;
    }

    if (currentMetrics.section === candidateMetrics.section) {
      return true;
    }

    if (currentMetrics.visiblePx <= 0) {
      return false;
    }

    viewportHeight = Math.max(
      1,
      currentMetrics.viewportHeight || 0,
      candidateMetrics.viewportHeight || 0
    );

    return (
      currentMetrics.visibleRatio >= 0.4 ||
      currentMetrics.visiblePx >= candidateMetrics.visiblePx * 0.74 ||
      (candidateMetrics.visiblePx - currentMetrics.visiblePx) <
        Math.max(28, viewportHeight * 0.16)
    );
  }

  function getStableLandingActiveSection(scrollRoot, sections, currentId) {
    var currentMetrics = null;
    var bestMetrics = null;
    var fallbackMetrics = null;
    var i;

    if (!sections || !sections.length) {
      return null;
    }

    for (i = 0; i < sections.length; i++) {
      var metrics = getLandingSectionViewportMetrics(scrollRoot, sections[i]);

      if (!metrics) {
        continue;
      }

      if (sections[i].id === currentId) {
        currentMetrics = metrics;
      }

      if (
        !bestMetrics ||
        metrics.visiblePx > bestMetrics.visiblePx ||
        (
          metrics.visiblePx === bestMetrics.visiblePx &&
          metrics.centerDistance < bestMetrics.centerDistance
        ) ||
        (
          metrics.visiblePx === bestMetrics.visiblePx &&
          metrics.centerDistance === bestMetrics.centerDistance &&
          metrics.topDistance < bestMetrics.topDistance
        )
      ) {
        bestMetrics = metrics;
      }

      if (
        !fallbackMetrics ||
        metrics.centerDistance < fallbackMetrics.centerDistance ||
        (
          metrics.centerDistance === fallbackMetrics.centerDistance &&
          metrics.topDistance < fallbackMetrics.topDistance
        )
      ) {
        fallbackMetrics = metrics;
      }
    }

    if (!bestMetrics) {
      return null;
    }

    if (bestMetrics.visiblePx <= 0) {
      return currentMetrics ? currentMetrics.section : fallbackMetrics.section;
    }

    if (shouldKeepCurrentLandingSection(currentMetrics, bestMetrics)) {
      return currentMetrics.section;
    }

    return bestMetrics.section;
  }

  function setupSectionUrlSync() {
    var scrollRoot = document.querySelector(".smf-wrapper") || window;
    var syncFrame = null;

    // Die Landing-Sections, die wir tracken wollen
    var sections = [
      document.getElementById("smf-daily-verse"),
      document.getElementById("smf-shop"),
      document.getElementById("smf-artist"),
      document.getElementById("smf-footer")
    ].filter(function (s) { return !!s; });

    if (!sections.length) return;

    var currentId = getLandingSectionIdFromLocation(
      window.location.pathname || "/",
      window.location.search || ""
    );

    function updateUrlFromScroll() {
      var bestSection = null;
      var id;

      if (
        isLandingAutoSyncSuspended() ||
        isLandingViewportRealignPending() ||
        isLandingBootSequenceActive()
      ) {
        return;
      }

      bestSection = getStableLandingActiveSection(scrollRoot, sections, currentId);

      if (!bestSection) return;

      id = bestSection.getAttribute("id");
      if (!id) return;

      var slug = smfSlugForSectionId(id);
      var currentPath = normalizePath(window.location.pathname || "/");
      var currentSearch = window.location.search || "";
      var urlNeedsUpdate =
        id !== currentId ||
        (slug && currentPath !== slug) ||
        !!currentSearch;

      if (!urlNeedsUpdate) return;

      if (id === "smf-daily-verse" && currentId && isUiHintOpen()) {
        hideUiHint();
      }

      currentId = id;
      smfUpdateUrlForSectionId(id, true);
    }

    function requestUrlSync() {
      if (
        isLandingAutoSyncSuspended() ||
        isLandingViewportRealignPending() ||
        isLandingBootSequenceActive()
      ) {
        if (syncFrame !== null) {
          cancelAnimationFrame(syncFrame);
          syncFrame = null;
        }
        return;
      }

      if (syncFrame !== null) {
        cancelAnimationFrame(syncFrame);
      }

      syncFrame = requestAnimationFrame(function() {
        syncFrame = null;
        updateUrlFromScroll();
      });
    }

    var scrollTarget = scrollRoot === window ? window : scrollRoot;
    scrollTarget.addEventListener("scroll", updateUrlFromScroll, { passive: true });
    window.addEventListener("resize", requestUrlSync);
    window.addEventListener("orientationchange", requestUrlSync);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", requestUrlSync);
    }

    updateUrlFromScroll();
  }

  function setupSectionDepthState() {
    var wrapper = document.querySelector(".smf-wrapper");
    var sections = Array.prototype.slice.call(
      document.querySelectorAll(".smf-wrapper > .smf-section")
    );
    var ticking = false;
    var fadeStart = 0.45;
    var fadeEnd = 0.85;
    var lastApplied = [];
    var lastAnchoredIndex = -1;
    var lastTransitioning = null;
    var i;

    if (!wrapper || sections.length < 2) return;

    for (i = 0; i < sections.length; i++) {
      lastApplied.push({ progress: 0, active: false, exit: "" });
    }

    function clearSectionDepth(section, index) {
      if (!lastApplied[index].active && lastApplied[index].progress === 0) {
        return;
      }

      section.style.removeProperty("--smf-depth-progress");
      section.style.removeProperty("--smf-section-content-opacity");
      section.style.removeProperty("--smf-section-softness");
      section.style.removeProperty("--smf-section-bg-fade");
      section.style.removeProperty("--smf-section-dim");
      section.classList.remove(
        "smf-section--depth-active",
        "smf-section--depth-exit-up",
        "smf-section--depth-exit-down"
      );
      lastApplied[index] = { progress: 0, active: false, exit: "" };
    }

    function setSectionTransitioning(isTransitioning) {
      var nextState = !!isTransitioning;

      if (lastTransitioning === nextState) {
        return;
      }

      lastTransitioning = nextState;
      wrapper.classList.toggle("smf-is-section-transitioning", nextState);
    }

    function clearOtherSections(activeIndex) {
      for (i = 0; i < sections.length; i++) {
        if (i !== activeIndex) {
          clearSectionDepth(sections[i], i);
        }
      }
    }

    function applySectionDepth(section, index, depthProgress, exitDir) {
      var isMobile = smfIsMobileLayout();
      var reducedMotion = smfHasReducedMotionPreference();
      var minOpacity = reducedMotion ? 0.88 : isMobile ? 0.2 : 0.15;
      var maxBlur = reducedMotion ? 0 : isMobile ? 6 : 8;
      var rounded = Math.round(depthProgress * 1000) / 1000;
      var opacity;
      var blur;

      if (
        lastApplied[index].active &&
        lastApplied[index].progress === rounded &&
        lastApplied[index].exit === exitDir
      ) {
        return;
      }

      opacity = (1 - (1 - minOpacity) * rounded).toFixed(4);
      blur = (maxBlur * rounded).toFixed(3);

      section.style.setProperty("--smf-depth-progress", String(rounded));
      section.style.setProperty("--smf-section-content-opacity", opacity);
      section.style.setProperty("--smf-section-softness", blur + "px");
      section.style.setProperty("--smf-section-bg-fade", rounded.toFixed(4));
      section.classList.add("smf-section--depth-active");
      section.classList.toggle("smf-section--depth-exit-up", exitDir === "up");
      section.classList.toggle("smf-section--depth-exit-down", exitDir === "down");
      lastApplied[index] = { progress: rounded, active: true, exit: exitDir };
    }

    function applyDepthState() {
      var wrapperRect;
      var viewportHeight;
      var metrics;
      var section;
      var rect;
      var visibleTop;
      var visibleBottom;
      var coverage;
      var offsetTop;
      var offsetBottom;
      var extendsAbove;
      var extendsBelow;
      var rawProgress;
      var depthProgress;
      var fadeRange;
      var exitDir;
      var topDistance;

      ticking = false;

      if (!wrapper.getBoundingClientRect) {
        setSectionTransitioning(false);
        return;
      }

      wrapperRect = wrapper.getBoundingClientRect();
      viewportHeight = Math.max(
        1,
        wrapperRect.height || wrapper.clientHeight || window.innerHeight || 0
      );
      fadeRange = Math.max(0.001, fadeEnd - fadeStart);
      metrics = [];

      for (i = 0; i < sections.length; i++) {
        section = sections[i];
        rect = section.getBoundingClientRect();
        visibleTop = Math.max(rect.top, wrapperRect.top);
        visibleBottom = Math.min(rect.bottom, wrapperRect.bottom);
        coverage = Math.max(0, visibleBottom - visibleTop) / viewportHeight;
        offsetTop = wrapperRect.top - rect.top;
        offsetBottom = rect.bottom - wrapperRect.bottom;
        extendsAbove = offsetTop > 0.5;
        extendsBelow = offsetBottom > 0.5;
        topDistance = Math.abs(rect.top - wrapperRect.top);

        metrics.push({
          coverage: coverage,
          offsetTop: offsetTop,
          offsetBottom: offsetBottom,
          extendsAbove: extendsAbove,
          extendsBelow: extendsBelow,
          visible: coverage > 0
        });

        if (coverage >= 0.97 && topDistance <= Math.max(8, viewportHeight * 0.02)) {
          lastAnchoredIndex = i;
        }
      }

      if (lastAnchoredIndex < 0 || !metrics[lastAnchoredIndex]) {
        lastAnchoredIndex = 0;
        for (i = 1; i < metrics.length; i++) {
          if (metrics[i].coverage > metrics[lastAnchoredIndex].coverage) {
            lastAnchoredIndex = i;
          }
        }
      }

      if (lastAnchoredIndex >= 0 && metrics[lastAnchoredIndex] && !metrics[lastAnchoredIndex].visible) {
        lastAnchoredIndex = 0;
        for (i = 1; i < metrics.length; i++) {
          if (metrics[i].coverage > metrics[lastAnchoredIndex].coverage) {
            lastAnchoredIndex = i;
          }
        }
      }

      if (lastAnchoredIndex < 0 || !metrics[lastAnchoredIndex]) {
        for (i = 0; i < sections.length; i++) {
          clearSectionDepth(sections[i], i);
        }
        setSectionTransitioning(false);
        return;
      }

      setSectionTransitioning(
        !isLandingBootSequenceActive() &&
        (
          (metrics[lastAnchoredIndex].extendsAbove && !metrics[lastAnchoredIndex].extendsBelow) ||
          (metrics[lastAnchoredIndex].extendsBelow && !metrics[lastAnchoredIndex].extendsAbove)
        )
      );

      clearOtherSections(lastAnchoredIndex);
      section = sections[lastAnchoredIndex];
      offsetTop = metrics[lastAnchoredIndex].offsetTop;
      offsetBottom = metrics[lastAnchoredIndex].offsetBottom;
      extendsAbove = metrics[lastAnchoredIndex].extendsAbove;
      extendsBelow = metrics[lastAnchoredIndex].extendsBelow;
      exitDir = "";
      rawProgress = 0;

      if (extendsAbove && !extendsBelow) {
        exitDir = "up";
        rawProgress = offsetTop / viewportHeight;
      } else if (extendsBelow && !extendsAbove) {
        exitDir = "down";
        rawProgress = offsetBottom / viewportHeight;
      }

      if (
        !exitDir ||
        rawProgress <= fadeStart ||
        rawProgress >= 1 ||
        !metrics[lastAnchoredIndex].visible
      ) {
        clearSectionDepth(section, lastAnchoredIndex);
        return;
      }

      depthProgress = (rawProgress - fadeStart) / fadeRange;
      if (depthProgress < 0) depthProgress = 0;
      if (depthProgress > 1) depthProgress = 1;

      if (depthProgress <= 0) {
        clearSectionDepth(section, lastAnchoredIndex);
        return;
      }

      applySectionDepth(section, lastAnchoredIndex, depthProgress, exitDir);
    }

    function requestDepthUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(applyDepthState);
    }

    wrapper.addEventListener("scroll", requestDepthUpdate, { passive: true });
    window.addEventListener("resize", requestDepthUpdate);
    applyDepthState();
  }

  /* ===========================================
     PUBLIC API
  ============================================ */
  function exposePublicApi() {
    window.smfSetLanguage = function(lang) {
      if (supportedLanguages.indexOf(lang) === -1) {
        return;
      }

      return switchLandingLanguage(lang, "manual-api");
    };

    window.smfSetShopLanguage = function(shopLang) {
      return applyShopLanguageSelection(shopLang, "manual-shopify");
    };

    window.smfGetLanguage = function() {
      return window.smfCurrentLang || null;
    };

    window.smfGetLanguageState = function() {
      return readStoredLanguageState() || getInitialLanguageState();
    };
  }

  /* ===========================================
     INIT
  ============================================ */
  
  // ===========================================
  //   URL-SLUGS pro Section (Onepager)
  // ===========================================
  function smfSlugForSectionId(id) {
    var baseSlug = null;
    var currentShopLang = window.smfCurrentShopLang || getShopLangFromPath();

    if (id === "smf-daily-verse") baseSlug = "/";
    if (id === "smf-shop") baseSlug = "/shop";
    if (id === "smf-artist") baseSlug = "/social";
    if (id === "smf-footer") baseSlug = "/info";
    if (!baseSlug) return null;

    return buildLocalizedPath(baseSlug, currentShopLang);
  }

  function setLandingRouteState(sectionId) {
    var routeClassNames = [
      "smf-route-daily-verse",
      "smf-route-social",
      "smf-route-info"
    ];
    var activeClass = null;
    var i;

    if (sectionId === "smf-daily-verse") activeClass = "smf-route-daily-verse";
    if (sectionId === "smf-artist") activeClass = "smf-route-social";
    if (sectionId === "smf-footer") activeClass = "smf-route-info";

    for (i = 0; i < routeClassNames.length; i++) {
      if (document.documentElement && document.documentElement.classList) {
        document.documentElement.classList.toggle(
          routeClassNames[i],
          routeClassNames[i] === activeClass
        );
      }

      if (document.body && document.body.classList) {
        document.body.classList.toggle(
          routeClassNames[i],
          routeClassNames[i] === activeClass
        );
      }
    }
  }

  function setLandingDirectRouteEntryState(path, search) {
    var initialSectionId = getLandingSectionIdFromLocation(path, search);
    var isDirectRouteEntry =
      initialSectionId === "smf-artist" ||
      initialSectionId === "smf-footer";

    smfPendingDirectRouteSectionId = isDirectRouteEntry ? initialSectionId : null;

    if (document.documentElement && document.documentElement.classList) {
      document.documentElement.classList.toggle("smf-direct-route-entry", isDirectRouteEntry);
    }

    if (document.body && document.body.classList) {
      document.body.classList.toggle("smf-direct-route-entry", isDirectRouteEntry);
    }
  }

  function clearLandingDirectRouteEntryState() {
    smfPendingDirectRouteSectionId = null;

    if (document.documentElement && document.documentElement.classList) {
      document.documentElement.classList.remove("smf-direct-route-entry");
    }

    if (document.body && document.body.classList) {
      document.body.classList.remove("smf-direct-route-entry");
    }
  }

  function consumeLandingDirectRouteEntryState(activeSectionId, options) {
    var force = !!(options && options.force);

    if (!smfPendingDirectRouteSectionId) {
      return;
    }

    if (force) {
      clearLandingDirectRouteEntryState();
      return;
    }

    if (activeSectionId && activeSectionId !== smfPendingDirectRouteSectionId) {
      clearLandingDirectRouteEntryState();
    }
  }

  function setShopRouteState(isActive) {
    var active = !!isActive;

    if (document.documentElement && document.documentElement.classList) {
      document.documentElement.classList.toggle("smf-route-shop", active);
    }

    if (document.body && document.body.classList) {
      document.body.classList.toggle("smf-route-shop", active);
    }
  }

  function syncLandingRouteStateFromUrl(path, search) {
    var activeSectionId = getLandingSectionIdFromLocation(path, search);
    var routeIsShop = activeSectionId === "smf-shop";

    setLandingRouteState(activeSectionId);
    setShopRouteState(routeIsShop);

    consumeLandingDirectRouteEntryState(activeSectionId);
  }

  function smfUpdateUrlForSectionId(id, replace) {
    if (!window.history || !window.history.replaceState) return;

    var slug = smfSlugForSectionId(id);
    if (!slug) return;

    syncLandingRouteStateFromUrl(slug, "");

    var currentPath = normalizePath(window.location.pathname || "/");
    var currentSearch = window.location.search || "";
    if (currentPath === slug && !currentSearch) {
      if (id && id !== "smf-daily-verse") {
        revealLanguageHintAfterLeavingHero();
      }
      return;
    }

    try {
      if (replace) {
        window.history.replaceState(null, "", slug);
      } else {
        window.history.pushState(null, "", slug);
      }
    } catch (e) {
      // falls Browser zickt: einfach ignorieren
    }

    if (id && id !== "smf-daily-verse") {
      revealLanguageHintAfterLeavingHero();
    }
  }



function setupFooterPopups() {
  var POPUP_OPEN_CLASS = "is-open";
  var popupSelector = "[data-popup-id]";
  var triggerSelector = "[data-popup-target]";
  var closeSelector = "[data-popup-close]";

  var popups = Array.prototype.slice.call(
    document.querySelectorAll(popupSelector)
  );
  var triggers = Array.prototype.slice.call(
    document.querySelectorAll(triggerSelector)
  );

  if (!popups.length) {
    return;
  }

  function getPopupById(id) {
    for (var i = 0; i < popups.length; i++) {
      if (popups[i].getAttribute("data-popup-id") === id) {
        return popups[i];
      }
    }
    return null;
  }

  function closePopup(id) {
    var popup = getPopupById(id);

    if (!popup || !popup.classList.contains(POPUP_OPEN_CLASS)) {
      return;
    }

    var scrollEl =
      popup.querySelector(".smf-popup__body") ||
      popup.querySelector(".smf-popup__content") ||
      popup;

    scrollEl.scrollTop = 0;
    popup.classList.remove(POPUP_OPEN_CLASS);
    popup.setAttribute("aria-hidden", "true");
  }

  function closeAllPopups() {
    popups.forEach(function (popup) {
      closePopup(popup.getAttribute("data-popup-id"));
    });
  }

  function anyPopupOpen() {
    for (var i = 0; i < popups.length; i++) {
      if (popups[i].classList.contains(POPUP_OPEN_CLASS)) {
        return true;
      }
    }
    return false;
  }

  function openPopup(id) {
    closeAllPopups();

    var popup = getPopupById(id);
    if (!popup) return;

    popup.classList.add(POPUP_OPEN_CLASS);
    popup.setAttribute("aria-hidden", "false");

    var focusTarget =
      popup.querySelector(".smf-popup__title") ||
      popup.querySelector("[data-smf-ui-hint-confirm]") ||
      popup.querySelector("[data-popup-close]") ||
      popup.querySelector(".smf-popup__cta");

    if (focusTarget && typeof focusTarget.focus === "function") {
      focusTarget.focus();
    }
  }

  window.smfOpenPopupById = openPopup;
  window.smfClosePopupById = closePopup;
  window.smfCloseAllPopups = closeAllPopups;

  // Klick auf Footer-Links (Impressum, AGB, …)
  triggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      var targetId = trigger.getAttribute("data-popup-target");
      var targetPopup = getPopupById(targetId);
      var isOpen =
        targetPopup && targetPopup.classList.contains(POPUP_OPEN_CLASS);

      if (isOpen) {
        closeAllPopups();
      } else {
        openPopup(targetId);
      }
    });
  });

  // X-Button im Popup
  popups.forEach(function (popup) {
    var closeBtn = popup.querySelector(closeSelector);
    if (closeBtn) {
      closeBtn.addEventListener("click", function (event) {
        event.stopPropagation();
        closeAllPopups();
      });
    }
  });

  registerSmfOverlayDismissLayer({
    priority: 40,
    isOpen: anyPopupOpen,
    close: function() {
      closeAllPopups();
    },
    shouldIgnoreOutsideClick: function(event) {
      var target = event.target;

      return !!(
        target &&
        target.closest &&
        (target.closest("[data-popup-id]") || target.closest("[data-popup-target]"))
      );
    }
  });

  // Scrollen der Seite schließt Popups (Page 4 -> Page 3 etc.)
  var scrollRoot = document.querySelector(".smf-wrapper") || window;

	  scrollRoot.addEventListener(
	    "scroll",
	    function () {
	      var uiHintPopup = getPopupById("ui-language-hint");

	      if (
	        uiHintPopup &&
	        uiHintPopup.classList.contains(POPUP_OPEN_CLASS)
	      ) {
	        return;
	      }

	      if (anyPopupOpen()) {
	        closeAllPopups();
      }
    },
	    { passive: true }
	  );
	}

  function getFaithPill() {
    return document.querySelector("[data-smf-faith-pill]");
  }

  function applyFaithPillAccent(level) {
    var pill = getFaithPill();

    if (!pill) return null;

    pill.classList.remove("smf-faith-pill--soft", "smf-faith-pill--strong");

    if (level === "strong") {
      pill.classList.add("smf-faith-pill--strong");
    } else {
      pill.classList.add("smf-faith-pill--soft");
    }

    return pill;
  }

  function highlightFaithPill(options) {
    var accent = options && options.accent === "strong" ? "strong" : "soft";
    var pill = applyFaithPillAccent(accent);
    var highlightClass = "smf-pill-highlight";
    var highlightDelay = accent === "strong" ? SMF_FAITH_PILL_HIGHLIGHT_DELAY_STRONG : 0;
    var highlightDuration = SMF_FAITH_PILL_HIGHLIGHT_DURATION;
    var highlightBuffer = SMF_FAITH_PILL_HIGHLIGHT_BUFFER;

    if (!pill) return;

    if (pill._smfHighlightStartTimer) {
      clearTimeout(pill._smfHighlightStartTimer);
      pill._smfHighlightStartTimer = null;
    }

    if (pill._smfHighlightStopTimer) {
      clearTimeout(pill._smfHighlightStopTimer);
      pill._smfHighlightStopTimer = null;
    }

    pill.classList.remove(highlightClass);
    void pill.offsetWidth;

    pill._smfHighlightStartTimer = setTimeout(function () {
      pill.classList.add(highlightClass);
      pill._smfHighlightStartTimer = null;
    }, highlightDelay);

    pill._smfHighlightStopTimer = setTimeout(function () {
      pill.classList.remove(highlightClass);
      pill._smfHighlightStopTimer = null;
      if (accent === "strong") {
        applyFaithPillAccent("soft");
      }
    }, highlightDelay + highlightDuration + highlightBuffer);
  }

  function focusFaithSection(options) {
    var accent = options && options.accent === "strong" ? "strong" : "soft";
    var faithSection = document.getElementById("faith");
    if (faithSection && faithSection.scrollIntoView) {
      faithSection.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    if (accent === "strong") {
      highlightFaithPill({ accent: "strong" });
      return;
    }

    applyFaithPillAccent("soft");
  }

  function setupVerseFaithLink() {
    var entryLinks = document.querySelectorAll("[data-smf-verse-faith-cta]");
    var lang = window.smfCurrentLang || getInitialLanguage();
    var targetUrl = buildFaithBibleUrl(lang);

    for (var i = 0; i < entryLinks.length; i++) {
      entryLinks[i].setAttribute("href", targetUrl);
    }
  }

  function setupVerseReferenceTrigger() {
    var triggers = document.querySelectorAll(
      "[data-smf-verse-trigger], #smf-verse-ref"
    );
    var i;

    for (i = 0; i < triggers.length; i++) {
      (function (trigger) {
        trigger.addEventListener("keydown", function (event) {
          if (event.key !== "Enter" && event.key !== " ") return;

          event.preventDefault();
          trigger.click();
        });
      })(triggers[i]);
    }
  }

  function setupCollectionCardMotion() {
    // Desktop hub tiles; mobile hierarchy cards keep native navigation.
    var tiles = Array.prototype.slice.call(
      document.querySelectorAll(".smf-shop .smf-collection-tile")
    );
    var scrollRoot = document.querySelector(".smf-wrapper") || window;
    var prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var visibleTiles = tiles.slice();
    var frameRequested = false;

    if (!tiles.length) return;

    function requestDepthUpdate() {
      if (prefersReducedMotion || frameRequested) return;

      frameRequested = true;
      requestAnimationFrame(function () {
        frameRequested = false;
        updateDepth();
      });
    }

    function updateDepth() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      var targets = visibleTiles.length ? visibleTiles : tiles;

      for (var i = 0; i < targets.length; i++) {
        var tile = targets[i];
        var rect = tile.getBoundingClientRect();
        var center = rect.top + (rect.height / 2);
        var progress = (center - (viewportHeight / 2)) / viewportHeight;
        var clamped = Math.max(-1, Math.min(1, progress));
        var shift = clamped * -6;
        var scale = 1.02 + ((1 - Math.abs(clamped)) * 0.008);

        tile.style.setProperty("--smf-card-media-shift", shift.toFixed(2) + "px");
        tile.style.setProperty("--smf-card-media-scale", scale.toFixed(3));
      }
    }

    function handleTileClick(event) {
      var target = event.currentTarget;
      var shouldBypass =
        event instanceof MouseEvent &&
        (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1);

      if (event.defaultPrevented) {
        return;
      }

      if (!(target instanceof HTMLAnchorElement) || !target.href || shouldBypass) {
        return;
      }

      event.preventDefault();

      for (var i = 0; i < tiles.length; i++) {
        tiles[i].classList.remove("is-activating");
      }

      target.classList.add("is-activating");

      window.setTimeout(function () {
        window.location.assign(target.href);
      }, prefersReducedMotion ? 0 : SMF_COLLECTION_TILE_ACTIVATE_DELAY);
    }

    for (var i = 0; i < tiles.length; i++) {
      tiles[i].style.setProperty("--smf-card-media-shift", "0px");
      tiles[i].style.setProperty("--smf-card-media-scale", "1.024");
      tiles[i].addEventListener("click", handleTileClick);
    }

    if (prefersReducedMotion) {
      return;
    }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        visibleTiles = visibleTiles.slice();

        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          var tile = entry.target;
          var index = visibleTiles.indexOf(tile);

          if (entry.isIntersecting) {
            if (index === -1) {
              visibleTiles.push(tile);
            }
          } else if (index !== -1) {
            visibleTiles.splice(index, 1);
            tile.style.setProperty("--smf-card-media-shift", "0px");
            tile.style.setProperty("--smf-card-media-scale", "1.024");
          }
        }

        requestDepthUpdate();
      }, {
        threshold: [0, 0.2, 0.5, 0.8, 1]
      });

      for (var j = 0; j < tiles.length; j++) {
        observer.observe(tiles[j]);
      }
    }

    scrollRoot.addEventListener("scroll", requestDepthUpdate, { passive: true });
    window.addEventListener("resize", requestDepthUpdate);
    requestDepthUpdate();
  }

  function setupMobileLandingPullToRefresh() {
    var wrapper = document.querySelector(".smf-wrapper");
    var startY = null;
    var shouldReload = false;
    var reloadThreshold = 88;

    if (!wrapper) return;

    function resetPullState() {
      startY = null;
      shouldReload = false;
    }

    function isMobileLandingReloadEligible() {
      var activePath = stripLocalePrefix(window.location.pathname || "/");

      return (
        smfIsMobileLayout() &&
        activePath === "/" &&
        wrapper.scrollTop <= 0 &&
        !document.querySelector(
          ".smf-nav-menu.is-active, .smf-lang-menu.is-active, .smf-save-sheet.is-open, .smf-popup.is-open"
        )
      );
    }

    wrapper.addEventListener(
      "touchstart",
      function (event) {
        if (!event.touches || event.touches.length !== 1) {
          resetPullState();
          return;
        }

        if (!isMobileLandingReloadEligible()) {
          resetPullState();
          return;
        }

        startY = event.touches[0].clientY;
        shouldReload = false;
      },
      { passive: true }
    );

    wrapper.addEventListener(
      "touchmove",
      function (event) {
        var currentY;
        var deltaY;

        if (startY === null || !event.touches || event.touches.length !== 1) {
          return;
        }

        if (!isMobileLandingReloadEligible()) {
          resetPullState();
          return;
        }

        currentY = event.touches[0].clientY;
        deltaY = currentY - startY;

        if (deltaY <= 0) {
          shouldReload = false;
          return;
        }

        shouldReload = deltaY >= reloadThreshold;
      },
      { passive: true }
    );

    wrapper.addEventListener(
      "touchend",
      function () {
        if (!shouldReload) {
          resetPullState();
          return;
        }

        resetPullState();
        wrapper.scrollTop = 0;
        if (window.history && "scrollRestoration" in window.history) {
          window.history.scrollRestoration = "manual";
        }

        try {
          window.location.replace(
            (window.location.pathname || "/") + (window.location.hash || "")
          );
        } catch (error) {
          window.location.reload();
        }
      },
      { passive: true }
    );

    wrapper.addEventListener(
      "touchcancel",
      function () {
        resetPullState();
      },
      { passive: true }
    );
  }

  function setupLandingIntro() {
    var notchArrow = document.querySelector(
      "#smf-daily-verse .smf-scroll-indicator--icon-only .smf-scroll-arrow"
    );
    var chevEl = document.querySelector(".smf-ref-chev");
    var prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var refPulseDelay =
      SMF_LANDING_INTRO_NOTCH_DELAY +
      SMF_LANDING_INTRO_NOTCH_PULSE_DURATION +
      SMF_LANDING_INTRO_REF_GAP;

    if (!notchArrow && !chevEl) {
      return;
    }

    if (prefersReducedMotion) {
      return;
    }

    try {
      if (localStorage.getItem(SMF_LANDING_INTRO_STORAGE_KEY)) {
        return;
      }

      if (localStorage.getItem(SMF_LANDING_INTRO_LEGACY_CHEV_KEY)) {
        localStorage.setItem(SMF_LANDING_INTRO_STORAGE_KEY, "1");
        return;
      }
    } catch (error) {
      return;
    }

    function markIntroSeen() {
      try {
        localStorage.setItem(SMF_LANDING_INTRO_STORAGE_KEY, "1");
      } catch (error) {
        // Ignore quota / private-mode failures.
      }
    }

    setTimeout(function () {
      if (!notchArrow) {
        return;
      }

      notchArrow.classList.add("is-intro-pulse");

      setTimeout(function () {
        notchArrow.classList.remove("is-intro-pulse");
      }, SMF_LANDING_INTRO_NOTCH_PULSE_DURATION);
    }, SMF_LANDING_INTRO_NOTCH_DELAY);

    setTimeout(function () {
      if (!chevEl) {
        markIntroSeen();
        return;
      }

      chevEl.classList.add("is-first");

      setTimeout(function () {
        chevEl.classList.remove("is-first");
        markIntroSeen();
      }, SMF_VERSE_CHEV_FIRST_HINT_DURATION);
    }, refPulseDelay);
  }

  function copyTextLegacy(text) {
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement("textarea");

      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.top = "0";
      textarea.style.left = "0";
      textarea.style.opacity = "0";

      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      try {
        if (document.execCommand("copy")) {
          document.body.removeChild(textarea);
          resolve();
          return;
        }
      } catch (error) {
      }

      document.body.removeChild(textarea);
      reject(new Error("copy_failed"));
    });
  }

  function copyTextWithFallback(text) {
    if (
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === "function" &&
      window.isSecureContext
    ) {
      return navigator.clipboard.writeText(text).catch(function () {
        return copyTextLegacy(text);
      });
    }

    return copyTextLegacy(text);
  }

  function setupVerseCardSheet() {
    var saveBtn = document.getElementById("smf-save-btn");
    var sheet = document.getElementById("smf-save-sheet");
    var downloadBtn = document.getElementById("smf-save-download-btn");
    var shareBtn = document.getElementById("smf-save-share-btn");
    var copyBtn = document.getElementById("smf-save-copy-btn");
    var verseEl = document.getElementById("smf-verse-text");
    var refEl = document.getElementById("smf-verse-ref");
    var mainActions = document.getElementById("smf-save-sheet-main-actions");
    var formatActions = document.getElementById("smf-save-sheet-format-actions");
    var formatBackBtn = document.getElementById("smf-save-format-back-btn");
    var formatPhoneBtn = formatActions
      ? formatActions.querySelector('[data-verse-card-format="phone"]')
      : null;
    var formatDesktopBtn = formatActions
      ? formatActions.querySelector('[data-verse-card-format="desktop"]')
      : null;
    var formatSquareBtn = formatActions
      ? formatActions.querySelector('[data-verse-card-format="square"]')
      : null;
    var sheetTitle = sheet ? sheet.querySelector(".smf-save-sheet__title") : null;

    if (
      !saveBtn ||
      !sheet ||
      !downloadBtn ||
      !shareBtn ||
      !copyBtn ||
      !verseEl ||
      !refEl ||
      !mainActions ||
      !formatActions ||
      !formatBackBtn ||
      !formatPhoneBtn ||
      !formatDesktopBtn ||
      !formatSquareBtn ||
      !sheetTitle
    ) {
      return;
    }

    function getVerseCardLink() {
      var lang = window.smfCurrentLang || getInitialLanguage();
      return buildLandingShareUrl(lang);
    }

    function openSheet() {
      showMainSheetActions();
      sheet.classList.add("is-open");
      sheet.setAttribute("aria-hidden", "false");
    }

    function closeSheet() {
      sheet.classList.remove("is-open");
      sheet.setAttribute("aria-hidden", "true");
      showMainSheetActions();
    }

    function setSheetTitleI18n(key) {
      sheetTitle.setAttribute("data-i18n", key);
      sheetTitle.textContent = resolveUiI18n(key);
    }

    function syncFormatOptionVisibility() {
      var isMobile = smfIsMobileLayout();

      formatPhoneBtn.hidden = !isMobile;
      formatDesktopBtn.hidden = isMobile;
    }

    function showMainSheetActions() {
      sheet.classList.remove("is-format-select");
      mainActions.hidden = false;
      formatActions.hidden = true;
      setSheetTitleI18n("verseCardSheetTitle");
    }

    function showFormatSheetActions() {
      syncFormatOptionVisibility();
      sheet.classList.add("is-format-select");
      mainActions.hidden = true;
      formatActions.hidden = false;
      setSheetTitleI18n("verseCardFormatTitle");
    }

    function getWrappedLines(ctx, text, maxWidth) {
      var words = String(text || "").trim().split(/\s+/);
      var lines = [];
      var line = "";
      var i;

      if (!words[0]) return lines;

      for (i = 0; i < words.length; i++) {
        var testLine = line ? line + " " + words[i] : words[i];
        var metrics = ctx.measureText(testLine);

        if (metrics.width > maxWidth && line) {
          lines.push(line);
          line = words[i];
        } else {
          line = testLine;
        }
      }

      if (line) {
        lines.push(line);
      }

      return lines;
    }

    function buildVerseCardPngBlob(formatKey) {
      return new Promise(function (resolve) {
        var format = SMF_VERSE_CARD_FORMATS[formatKey || "card"] || SMF_VERSE_CARD_FORMATS.card;
        var verse = (verseEl.textContent || "").trim();
        var ref = stripVerseCardReferencePrefix(getVerseReferenceText());
        var canvas = document.createElement("canvas");
        var ctx;
        var width = format.width;
        var height = format.height;
        var widthScale = width / SMF_VERSE_CARD_BASE_WIDTH;
        var scale = Math.min(widthScale, height / SMF_VERSE_CARD_BASE_HEIGHT);
        var verseFontSize = Math.round(64 * scale);
        var refFontSize = Math.round(28 * scale);
        var verseMaxWidth = Math.round(820 * widthScale);
        var lineHeight = Math.round(84 * scale);
        var verseCenterOffset = Math.round(-70 * scale);
        var refGap = Math.round(74 * scale);
        var verseLines;
        var verseStartY;
        var i;

        canvas.width = width;
        canvas.height = height;
        ctx = canvas.getContext("2d");

        if (!ctx || !verse) {
          resolve(null);
          return;
        }

        ctx.fillStyle = "#09090b";
        ctx.fillRect(0, 0, width, height);

        var backgroundGradient = ctx.createLinearGradient(0, 0, 0, height);
        backgroundGradient.addColorStop(0, "#0a0a0c");
        backgroundGradient.addColorStop(0.5, "#2f2f31");
        backgroundGradient.addColorStop(1, "#0a0a0c");
        ctx.fillStyle = backgroundGradient;
        ctx.fillRect(0, 0, width, height);

        var verseGlow = ctx.createRadialGradient(
          width / 2,
          height * 0.4,
          Math.round(60 * scale),
          width / 2,
          height * 0.4,
          width * 0.42
        );
        verseGlow.addColorStop(0, "rgba(245, 245, 245, 0.22)");
        verseGlow.addColorStop(0.42, "rgba(235, 235, 235, 0.08)");
        verseGlow.addColorStop(1, "rgba(0, 0, 0, 0)");
        ctx.fillStyle = verseGlow;
        ctx.fillRect(0, 0, width, height);

        ctx.textAlign = "center";
        ctx.textBaseline = "top";

        ctx.fillStyle = "rgba(255, 255, 255, 0.92)";
        ctx.font =
          "400 " + verseFontSize + "px 'Open Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

        verseLines = getWrappedLines(ctx, verse, verseMaxWidth);
        verseStartY = height / 2 - ((verseLines.length * lineHeight) / 2) + verseCenterOffset;

        for (i = 0; i < verseLines.length; i++) {
          ctx.fillText(verseLines[i], width / 2, verseStartY + (i * lineHeight));
        }

        ctx.fillStyle = "rgba(255, 255, 255, 0.48)";
        ctx.font =
          "500 " + refFontSize + "px 'Open Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
        ctx.fillText(
          ref,
          width / 2,
          verseStartY + (verseLines.length * lineHeight) + refGap
        );

        var brandText = "scanmefamily.com";
        var brandBottomRatio = 0.05;
        var brandFontSize = Math.round(Math.max(12, 14 * scale));
        var brandLetterSpacing = Math.max(0.08, 0.12 * scale);
        var brandY;

        if (formatKey === "phone") {
          brandBottomRatio = 0.08;
        } else if (formatKey === "desktop") {
          brandBottomRatio = 0.045;
        } else if (formatKey === "square") {
          brandBottomRatio = 0.05;
        }

        ctx.shadowBlur = 0;
        ctx.shadowColor = "transparent";
        ctx.textAlign = "center";
        ctx.textBaseline = "bottom";
        ctx.fillStyle = "rgba(255, 255, 255, 0.35)";
        ctx.font =
          "500 " + brandFontSize + "px 'Open Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

        brandY = height - Math.round(height * brandBottomRatio);

        if (typeof ctx.letterSpacing !== "undefined") {
          ctx.letterSpacing = brandLetterSpacing + "px";
          ctx.fillText(brandText, width / 2, brandY);
          ctx.letterSpacing = "0px";
        } else {
          ctx.fillText(brandText, width / 2, brandY);
        }

        ctx.textAlign = "center";

        canvas.toBlob(function (blob) {
          resolve(blob);
        }, "image/png", 0.92);
      });
    }

    function downloadVerseCardBlob(formatKey) {
      var format = SMF_VERSE_CARD_FORMATS[formatKey] || SMF_VERSE_CARD_FORMATS.card;

      return buildVerseCardPngBlob(formatKey).then(function (blob) {
        var objectUrl;
        var link;

        if (!blob) {
          return false;
        }

        objectUrl = URL.createObjectURL(blob);
        link = document.createElement("a");
        link.href = objectUrl;
        link.download = "scanmefamily-" + format.fileSuffix + ".png";

        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);

        return true;
      });
    }

    function fallbackCopyLink() {
      var shareUrl = getVerseCardLink();

      return copyTextWithFallback(shareUrl).catch(function () {
        window.prompt(resolveUiI18n("verseCardCopyPrompt"), shareUrl);
      });
    }

    sheet.addEventListener("click", function (event) {
      var target = event.target;
      if (target && target.hasAttribute("data-save-sheet-close")) {
        closeSheet();
      }
    });

    registerSmfOverlayDismissLayer({
      priority: 50,
      isOpen: function() {
        return sheet.classList.contains("is-open");
      },
      close: function() {
        closeSheet();
      },
      shouldIgnoreOutsideClick: function(event) {
        return (
          sheet.contains(event.target) ||
          !!(
            event.target &&
            event.target.closest &&
            event.target.closest("#smf-save-btn")
          )
        );
      }
    });

    saveBtn.addEventListener("click", openSheet);

    downloadBtn.addEventListener("click", function () {
      showFormatSheetActions();
    });

    formatBackBtn.addEventListener("click", function () {
      showMainSheetActions();
    });

    formatPhoneBtn.addEventListener("click", function () {
      downloadVerseCardBlob("phone").then(function () {
        closeSheet();
      });
    });

    formatDesktopBtn.addEventListener("click", function () {
      downloadVerseCardBlob("desktop").then(function () {
        closeSheet();
      });
    });

    formatSquareBtn.addEventListener("click", function () {
      downloadVerseCardBlob("square").then(function () {
        closeSheet();
      });
    });

    shareBtn.addEventListener("click", function () {
      var shareUrl = getVerseCardLink();

      buildVerseCardPngBlob()
        .then(function (blob) {
          var file;
          var sharePromise = null;

          if (
            blob &&
            typeof File !== "undefined" &&
            navigator.share &&
            typeof navigator.share === "function"
          ) {
            try {
              file = new File([blob], "scanmefamily-verse-card.png", {
                type: "image/png"
              });

              if (
                navigator.canShare &&
                navigator.canShare({ files: [file] })
              ) {
                sharePromise = navigator.share({
                  files: [file],
                  title: resolveUiI18n("verseCardShareTitle")
                });
              }
            } catch (error) {
              sharePromise = null;
            }
          }

          if (!sharePromise && navigator.share && typeof navigator.share === "function") {
            sharePromise = navigator.share({
              url: shareUrl,
              title: resolveUiI18n("verseCardShareTitle")
            });
          }

          if (!sharePromise) {
            return fallbackCopyLink();
          }

          return sharePromise.catch(function (error) {
            if (error && error.name === "AbortError") {
              return;
            }

            return fallbackCopyLink();
          });
        })
        .catch(function () {
          return fallbackCopyLink();
        })
        .then(function () {
          closeSheet();
        });
    });

    copyBtn.addEventListener("click", function () {
      fallbackCopyLink().then(function () {
        closeSheet();
      });
    });
  }

		  // ===========================================
  //   INITIALER SCROLL AUS URL (?page=...)
  // ===========================================
  function smfScrollToInitialSectionFromUrl() {
    var hash = (window.location.hash || "").toLowerCase();
    var shopLang = window.smfCurrentShopLang || getShopLangFromPath();
    var currentPath = window.location.pathname || "/";
    var currentSearch = window.location.search || "";
    var wrapper = getLandingScrollWrapper();
    var targetId = null;
    var finalSlug = null;
    var shouldFocusFaith = false;
    targetId = getLandingSectionIdFromLocation(currentPath, currentSearch);

    if (targetId === "smf-shop") {
      finalSlug = buildLocalizedPath("/shop", shopLang);
    } else if (targetId === "smf-artist") {
      finalSlug = buildLocalizedPath("/social", shopLang);
    } else if (targetId === "smf-footer") {
      finalSlug = buildLocalizedPath("/info", shopLang);
    } else {
      return false;
    }

    var target = document.getElementById(targetId);
    if (!target) {
      completeLandingBootSequence();
      return false;
    }

    if (targetId === "smf-artist") {
      consumeSocialEntrySource();
    }

    shouldFocusFaith = targetId === "smf-artist" && hash === "#faith";

    // Kleine Verzögerung, damit Layout + VH-Variable stehen
    setTimeout(function () {
      temporarilyDisableLandingScrollSnap(wrapper, SMF_LANDING_DEEP_LINK_SNAP_DISABLE_DURATION);

      scrollLandingSectionIntoView(target, "auto");
      if (shouldFocusFaith) {
        setTimeout(function () {
          focusFaithSection({
            accent: "soft"
          });
        }, SMF_LANDING_SECTION_SETTLE_DELAY);
      } else if (targetId === "smf-artist") {
        applyFaithPillAccent("soft");
      }


      // URL nach dem Scroll "aufräumen" (ohne ?page=...)
      if (finalSlug && window.history && window.history.replaceState) {
        window.history.replaceState(
          null,
          "",
          shouldFocusFaith ? finalSlug + "#faith" : finalSlug
        );
      }

      window.setTimeout(function() {
        consumeLandingDirectRouteEntryState(targetId);
        maybeCompleteLandingBootSequence(target);
      }, SMF_LANDING_SECTION_SETTLE_DELAY);
    }, 80);

    return true;
  }

  function init() {
    canonicalizeLandingLocation();
    pinLandingScrollToUrlSection();
    setupLandingVirtualRouteLinks();

    var initialPath = window.location.pathname || "/";
    var initialSearch = window.location.search || "";
    var bootTargetId = getLandingSectionIdFromLocation(initialPath, initialSearch);

    if (
      bootTargetId !== "smf-daily-verse" &&
      document.getElementById(bootTargetId)
    ) {
      beginLandingBootSequence(
        bootTargetId,
        SMF_LANDING_BOOT_GUARD_DURATION,
        initializeLandingObservers
      );
    }

    smfUpdateViewportHeight("init");

    var initialState = getInitialLanguageState();
    var landingObserversInitialized = false;
		window.smfCurrentLang = initialState.verseLang;
		window.smfCurrentShopLang = initialState.shopLang;

    function initializeLandingObservers() {
      if (landingObserversInitialized) {
        return;
      }

      landingObserversInitialized = true;
      setupSectionUrlSync();
      setupSectionDepthState();
      setupLandingScrollSnapNormalizer();

    }

    setLandingDirectRouteEntryState(window.location.pathname || "/", window.location.search || "");
    syncLandingRouteStateFromUrl();

    applyLanguage(initialState.verseLang, {
      shopLang: initialState.shopLang,
      persist: false,
      source: initialState.source
    });
    applyFaithPillAccent("soft");
    syncLandingPathToStoredShopLang(initialState.shopLang);
	    setupGlobalShopifyLanguageSync();
	    setupLanguageMenu();
	    setupScrollIndicators();
	    setupShopWindowNotch();
	    setupNavigationMenu();
	    setupFooterPopups();
    setupVerseFaithLink();
    setupVerseReferenceTrigger();
    setupLandingIntro();
    setupCollectionCardMotion();
    setupMobileLandingPullToRefresh();
    setupSmfTransientPinchZoom();
    setupSmfLandscapeLock();
    setupVerseCardSheet();

	    // 👇 NEU: beim Laden ggf. direkt zur passenden Section springen
	    if (!smfScrollToInitialSectionFromUrl()) {
      pinLandingScrollToUrlSection();
      if (!smfLandingBootState.completed) {
        completeLandingBootSequence();
      }
      if (!landingObserversInitialized) {
        initializeLandingObservers();
      }
    }


  
  // Shopify-Links immer auf DE/EN erzwingen (statt hrefs umzuschreiben)
 document.addEventListener("click", function (e) {
  var a = e.target && (e.target.closest ? e.target.closest("a") : null);
  if (!a) return;

  var href = a.getAttribute("href");
  if (!href) return;

  if (
    href.charAt(0) === "#" ||
    href.indexOf("mailto:") === 0 ||
    href.indexOf("tel:") === 0 ||
    href.indexOf("javascript:") === 0
  ) {
    return;
  }

  href = normalizePath(href);

  // Nur Shopify-Pfade abfangen
  var normalizedHref = stripLocalePrefix(href);
  var isProduct = normalizedHref.startsWith("/products/");
  var isCollection = normalizedHref.startsWith("/collections/");
  var isCart = normalizedHref === "/cart" || normalizedHref.startsWith("/cart?");
  if (!isProduct && !isCollection && !isCart) return;

  var storedState = readStoredLanguageState();
  var shopLang = (storedState && storedState.shopLang) || window.smfCurrentShopLang || "en";
  var target = buildLocalizedPath(normalizedHref, shopLang);

  // Wenn ohnehin richtig, nichts tun
  if (target === href) return;

  // Klick übernehmen
  e.preventDefault();
  window.location.href = target;
}, true);


	
    if (!isLandingHeroRouteActive()) {
      showLanguageHintIfPending();
    }
    exposePublicApi();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
    // ===========================================
  //   DYNAMISCHE VIEWPORT-HÖHE (für 100vh-Bug)
  // ===========================================
 // Shopify-Seiten (collections/cart/products) dürfen normal scrollen
(function () {
  var path = stripLocalePrefix(location.pathname); // /en und /de weg-normalisieren
  var isShopifyPage =
    path.startsWith("/products/") ||
    path.startsWith("/collections/") ||
    path === "/cart" ||
    path.startsWith("/cart");

  if (path.startsWith("/products/")) {
    document.documentElement.classList.add("smf-product-page");
    if (document.body) document.body.classList.add("smf-product-page");
  }
})();

  function getSmfViewportHeight() {
    if (
      window.visualViewport &&
      window.visualViewport.height &&
      !isSmfVisualViewportScaled()
    ) {
      return window.visualViewport.height;
    }

    return window.innerHeight || document.documentElement.clientHeight || 0;
  }

  function shouldRealignViewportSection(source, wrapper, targetSection) {
    if (!wrapper || !targetSection) {
      return false;
    }

    return (
      source === "init" ||
      source === "load" ||
      source === "boot-complete" ||
      source === "orientationchange" ||
      source === "resize"
    );
  }

  function applySmfViewportCssVars() {
    var appHeight = Math.round(getSmfViewportHeight());

    document.documentElement.style.setProperty("--smf-app-height", appHeight + "px");
  }

  function queueLandingViewportRealign(targetSection) {
    var wrapper = getLandingScrollWrapper();

    if (
      !wrapper ||
      !targetSection ||
      isLandingAutoSyncSuspended() ||
      isLandingBootSequenceActive()
    ) {
      setLandingViewportRealignPending(false);
      return;
    }

    setLandingViewportRealignPending(true);
    clearPendingLandingScrollCorrections();
    temporarilyDisableLandingScrollSnap(
      wrapper,
      targetSection.id === "smf-daily-verse" ? 220 : 520
    );

    smfLandingScrollCorrectionState.viewportFrame = requestAnimationFrame(function() {
      var activeTarget = getLandingSectionElementFromLocation() || targetSection;

      smfLandingScrollCorrectionState.viewportFrame = null;

      if (!activeTarget) {
        setLandingViewportRealignPending(false);
        return;
      }

      scrollLandingSectionIntoView(activeTarget, "auto");
    });
  }

  function smfUpdateViewportHeight(source) {
    var wrapper = getLandingScrollWrapper();
    var targetSection;
    if (
      source === "visualViewport" &&
      smfLandingScrollCorrectionState.targetId === "smf-daily-verse" &&
      (
        smfLandingScrollCorrectionState.finalizeFrame !== null ||
        smfLandingScrollCorrectionState.delayedTimer ||
        smfLandingScrollCorrectionState.alignFrame !== null
      )
    ) {
      return;
    }

    applySmfViewportCssVars();

    if (source === "visualViewport") {
      registerSmfPinchZoomActivity(source);
      return;
    }

    if (registerSmfPinchZoomActivity(source)) {
      return;
    }

    if (isLandingAutoSyncSuspended()) {
      return;
    }

    if (isLandingBootSequenceActive()) {
      return;
    }

    targetSection = getLandingSectionElementFromLocation();
    if (!shouldRealignViewportSection(source, wrapper, targetSection)) {
      return;
    }

    queueLandingViewportRealign(targetSection);
  }

  // CSS vars early (before DOMContentLoaded); realign runs from init()
  applySmfViewportCssVars();
  window.addEventListener("load", function() {
    smfUpdateViewportHeight("load");
  }, { once: true });

  // Und bei Größenänderungen / Rotation aktualisieren
  window.addEventListener("resize", function() {
    smfUpdateViewportHeight("resize");
  });
  window.addEventListener("orientationchange", function() {
    if (document.documentElement.classList.contains("smf-landscape-lock-active")) {
      return;
    }

    window.setTimeout(function() {
      smfUpdateViewportHeight("orientationchange");
    }, 280);
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", function() {
      smfUpdateViewportHeight("visualViewport");
    });
    window.visualViewport.addEventListener("scroll", function() {
      registerSmfPinchZoomActivity("visualViewportScroll");
    }, { passive: true });
  }

})();



// Light header: subtle divider once main content scrolls under the fixed header (desktop).
(function initSmfLightHeaderScroll() {
  function readHeaderHeight() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    const parsed = Number.parseFloat(raw);
    if (Number.isFinite(parsed) && parsed > 0) {
      return parsed;
    }

    const header = document.getElementById('header-component');
    if (header && header.offsetHeight > 0) {
      return header.offsetHeight;
    }

    return 56;
  }

  function bind() {
    if (window.matchMedia('(max-width: 749px)').matches) {
      return;
    }

    const root = document.documentElement;
    const body = document.body;
    if (!root.classList.contains('smf-light-header') && !body.classList.contains('smf-light-header')) {
      return;
    }

    const headerGroup = document.getElementById('header-group');
    const headerSection = headerGroup?.querySelector('.header-section');
    const main = document.getElementById('MainContent');
    if (!headerSection || !main) return;

    let sentinel = main.querySelector('.smf-light-header-scroll-sentinel');
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.className = 'smf-light-header-scroll-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      main.insertBefore(sentinel, main.firstChild);
    }

    const setScrolled = (enabled) => {
      headerSection.classList.toggle('smf-light-header--scrolled', enabled);
    };

    const headerHeight = readHeaderHeight();
    const observer = new IntersectionObserver(
      ([entry]) => {
        setScrolled(!entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0,
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
      }
    );

    observer.observe(sentinel);
    setScrolled(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

// ---------------------------
// Popup: Größentabelle Hinweis
// ---------------------------
document.addEventListener('DOMContentLoaded', () => {
  let popupShownCount = Number(sessionStorage.getItem('smef_popup_count') || 0);
  let hintOpenPending = false;
  let pendingProductUrl = '';
  let pendingFromVariant = '';

  const popup = document.querySelector('#smef-size-popup');
  if (!popup) return;
  popup.hidden = true;

  const backdrop = popup.querySelector('.smef-size-popup__backdrop');
  const closeBtn = popup.querySelector('.smef-size-popup__close');
  const recommenderLink = popup.querySelector('.smef-size-popup__recommender-link');
  const copyWithRecommender = popup.querySelector('[data-smef-size-with-recommender]');
  const copyWithoutRecommender = popup.querySelector('[data-smef-size-without-recommender]');

  function hasSeenPopup() {
    return popupShownCount >= 2;
  }

  function markPopupSeen() {
    popupShownCount++;
    sessionStorage.setItem('smef_popup_count', popupShownCount);
  }

  var SIZE_HINT_LAST_SHOWN_KEY = 'smf_size_hint_last_shown';
  var SIZE_HINT_COOLDOWN_MS = 24 * 60 * 60 * 1000;

  function readSizeHintLastShown() {
    try {
      var raw = window.localStorage.getItem(SIZE_HINT_LAST_SHOWN_KEY);
      if (raw == null || raw === '') return null;

      var timestamp = Number(raw);
      if (!Number.isFinite(timestamp) || timestamp <= 0 || timestamp > Date.now()) {
        return null;
      }

      return timestamp;
    } catch (error) {
      return null;
    }
  }

  function isSizeHintOnCooldown() {
    var lastShown = readSizeHintLastShown();
    if (lastShown == null) return false;
    return Date.now() - lastShown < SIZE_HINT_COOLDOWN_MS;
  }

  function markSizeHintShown() {
    try {
      window.localStorage.setItem(SIZE_HINT_LAST_SHOWN_KEY, String(Date.now()));
    } catch (error) {
      // localStorage unavailable: keep the existing hint flow intact.
    }
  }

  function getQuickAddDialogHost() {
    return document.getElementById('quick-add-dialog');
  }

  function getQuickAddDialogElement() {
    const host = getQuickAddDialogHost();
    const dialog = host && host.querySelector('dialog');
    return dialog instanceof HTMLDialogElement ? dialog : null;
  }

  function isDialogBusy(dialog) {
    return !!(dialog && (dialog.open || dialog.classList.contains('dialog-closing')));
  }

  function whenQuickAddFullyClosed() {
    const host = getQuickAddDialogHost();
    const dialog = getQuickAddDialogElement();

    if (!host || !dialog || !isDialogBusy(dialog)) {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var finished = false;

      function finish() {
        if (finished) return;
        finished = true;
        host.removeEventListener('dialog:close', finish);
        resolve();
      }

      host.addEventListener('dialog:close', finish);
    });
  }

  function isProductPath(pathname) {
    return /\/products\/[^/?#]+/.test(String(pathname || ''));
  }

  function toSameOriginProductUrl(href) {
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin || !isProductPath(url.pathname)) {
        return null;
      }
      return url;
    } catch (error) {
      return null;
    }
  }

  function findProductLink(root) {
    if (!(root instanceof Element)) return null;

    return (
      root.querySelector('.view-product-title a[href]') ||
      root.querySelector('.product-header a[href]') ||
      root.querySelector('a[href*="/products/"]')
    );
  }

  function resolveProductPageUrl(event) {
    const source = event && event.target instanceof Element ? event.target : null;
    const candidates = [];

    if (source) {
      const scoped = source.closest('#quick-add-dialog, quick-add-dialog, .quick-add-modal, .shopify-section');
      if (scoped) candidates.push(scoped);
      candidates.push(source);
    }

    const quickAdd = getQuickAddDialogHost();
    if (quickAdd) candidates.push(quickAdd);

    for (let i = 0; i < candidates.length; i++) {
      const link = findProductLink(candidates[i]);
      const url = link ? toSameOriginProductUrl(link.href) : null;
      if (url) return url;
    }

    return toSameOriginProductUrl(window.location.href);
  }

  function captureHintContext(event) {
    const url = resolveProductPageUrl(event);
    pendingProductUrl = url ? url.href : '';

    const sourceId = event && event.detail ? String(event.detail.sourceId || '') : '';
    pendingFromVariant = /^\d+$/.test(sourceId) ? sourceId : '';
  }

  function findPdpSizeRecommender() {
    const components = document.querySelectorAll('size-recommender-component:not([hidden])');

    for (let i = 0; i < components.length; i++) {
      const component = components[i];
      if (component.closest('#quick-add-dialog, quick-add-dialog, .quick-add-modal')) {
        continue;
      }
      return component;
    }

    return null;
  }

  function canOfferSizeFinder() {
    return Boolean(pendingProductUrl || findPdpSizeRecommender());
  }

  function syncSizeRecommenderCopy() {
    const hasFinder = canOfferSizeFinder();

    if (copyWithRecommender) copyWithRecommender.hidden = !hasFinder;
    if (copyWithoutRecommender) copyWithoutRecommender.hidden = hasFinder;
  }

  function openSizePopup() {
    markSizeHintShown();
    syncSizeRecommenderCopy();
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
  }

  function closeSizePopup() {
    if (popup.hidden) {
      return;
    }

    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    markPopupSeen();
  }

  function openSizePopupAfterCartSuccess(event) {
    if (hasSeenPopup() || hintOpenPending || !popup.hidden) {
      return;
    }

    captureHintContext(event);
    hintOpenPending = true;

    whenQuickAddFullyClosed().then(function () {
      hintOpenPending = false;

      if (hasSeenPopup() || !popup.hidden) {
        return;
      }

      if (isDialogBusy(getQuickAddDialogElement())) {
        return;
      }

      if (isSizeHintOnCooldown()) {
        return;
      }

      openSizePopup();
    });
  }

  function navigateToProductSizeRecommender() {
    const url = toSameOriginProductUrl(pendingProductUrl);
    if (!url) return false;

    url.searchParams.set('smf-sr', '1');
    if (pendingFromVariant) {
      url.searchParams.set('from_variant', pendingFromVariant);
    }

    window.location.assign(url.pathname + url.search + url.hash);
    return true;
  }

  function openLocalSizeRecommender() {
    const component = findPdpSizeRecommender();
    if (!component || typeof component.openDialog !== 'function') {
      return false;
    }

    try {
      component.openDialog();
      return true;
    } catch (error) {
      return false;
    }
  }

  function goToProductSizeRecommender() {
    if (navigateToProductSizeRecommender()) {
      return true;
    }

    return openLocalSizeRecommender();
  }

  if (closeBtn) closeBtn.addEventListener('click', closeSizePopup);
  if (backdrop) backdrop.addEventListener('click', closeSizePopup);
  if (recommenderLink) {
    recommenderLink.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeSizePopup();
      goToProductSizeRecommender();
    });
  }

  document.addEventListener('cart:update', function (event) {
    var data = event && event.detail ? event.detail.data : null;

    if (!data || data.didError || data.source !== 'product-form-component') {
      return;
    }

    if (hasSeenPopup()) {
      return;
    }

    openSizePopupAfterCartSuccess(event);
  });
});

